
export const communes = [
    {
        "id": 1,
        "code": "01000",
        "name": "Adrar",
        "name_ar": "أدرار",
        "daira_id": 1
    },
    {
        "id": 2,
        "code": "01023",
        "name": "Bouda",
        "name_ar": "بودة",
        "daira_id": 1
    },
    {
        "id": 3,
        "code": "01025",
        "name": "Ouled Ahmed Timmi",
        "name_ar": "أولاد أحمد تيمي",
        "daira_id": 1
    },
    {
        "id": 4,
        "code": "01003",
        "name": "Aoulef",
        "name_ar": "أولف",
        "daira_id": 2
    },
    {
        "id": 5,
        "code": "01031",
        "name": "Tit",
        "name_ar": "تيت",
        "daira_id": 2
    },
    {
        "id": 6,
        "code": "01041",
        "name": "Timekten",
        "name_ar": "تيمقتن",
        "daira_id": 2
    },
    {
        "id": 7,
        "code": "01044",
        "name": "Akabli",
        "name_ar": "اقبلي",
        "daira_id": 2
    },
    {
        "id": 8,
        "code": "01004",
        "name": "Reggane",
        "name_ar": "رقان",
        "daira_id": 3
    },
    {
        "id": 9,
        "code": "01009",
        "name": "Sali",
        "name_ar": "سالي",
        "daira_id": 3
    },
    {
        "id": 10,
        "code": "01007",
        "name": "Zaouiet Kounta",
        "name_ar": "زاوية كنتة",
        "daira_id": 4
    },
    {
        "id": 11,
        "code": "01047",
        "name": "In Zghmir",
        "name_ar": "إن زغمير",
        "daira_id": 4
    },
    {
        "id": 12,
        "code": "01008",
        "name": "Fenoughil",
        "name_ar": "فنوغيل",
        "daira_id": 5
    },
    {
        "id": 13,
        "code": "01020",
        "name": "Tamest",
        "name_ar": "تامست",
        "daira_id": 5
    },
    {
        "id": 14,
        "code": "01021",
        "name": "Tamantit",
        "name_ar": "تامنطيط",
        "daira_id": 5
    },
    {
        "id": 15,
        "code": "01011",
        "name": "Tsabit",
        "name_ar": "تسابيت",
        "daira_id": 6
    },
    {
        "id": 16,
        "code": "01022",
        "name": "Sebaa",
        "name_ar": "السبع",
        "daira_id": 6
    },
    {
        "id": 17,
        "code": "02000",
        "name": "Chlef",
        "name_ar": "الشلف",
        "daira_id": 7
    },
    {
        "id": 18,
        "code": "02024",
        "name": "Oum Drou",
        "name_ar": "أم الدروع",
        "daira_id": 7
    },
    {
        "id": 19,
        "code": "02025",
        "name": "Sendjas",
        "name_ar": "سنجاس",
        "daira_id": 7
    },
    {
        "id": 20,
        "code": "02001",
        "name": "Oued Fodda",
        "name_ar": "وادي الفضة",
        "daira_id": 8
    },
    {
        "id": 21,
        "code": "02029",
        "name": "Ouled Abbes",
        "name_ar": "أولاد عباس",
        "daira_id": 8
    },
    {
        "id": 22,
        "code": "02035",
        "name": "Beni Rached",
        "name_ar": "بني راشد",
        "daira_id": 8
    },
    {
        "id": 23,
        "code": "02002",
        "name": "Boukadir",
        "name_ar": "بوقادير",
        "daira_id": 9
    },
    {
        "id": 24,
        "code": "02011",
        "name": "Oued Sly",
        "name_ar": "وادي سلي",
        "daira_id": 9
    },
    {
        "id": 25,
        "code": "02030",
        "name": "Sobha",
        "name_ar": "الصبحة",
        "daira_id": 9
    },
    {
        "id": 26,
        "code": "02004",
        "name": "Ain Merane",
        "name_ar": "عين مران",
        "daira_id": 10
    },
    {
        "id": 27,
        "code": "02038",
        "name": "Herenfa",
        "name_ar": "الهرانفة",
        "daira_id": 10
    },
    {
        "id": 28,
        "code": "02006",
        "name": "Tenes",
        "name_ar": "تنس",
        "daira_id": 11
    },
    {
        "id": 29,
        "code": "02009",
        "name": "Sidi Akkacha",
        "name_ar": "سيدي عكاشة",
        "daira_id": 11
    },
    {
        "id": 30,
        "code": "02066",
        "name": "Sidi Abderrahmane",
        "name_ar": "سيدي عبد الرحمن",
        "daira_id": 11
    },
    {
        "id": 31,
        "code": "02007",
        "name": "Chettia",
        "name_ar": "الشطية",
        "daira_id": 12
    },
    {
        "id": 32,
        "code": "02010",
        "name": "Ouled Fares",
        "name_ar": "أولاد فارس",
        "daira_id": 12
    },
    {
        "id": 33,
        "code": "02073",
        "name": "Labiod Medjadja",
        "name_ar": "الأبيض مجاجة",
        "daira_id": 12
    },
    {
        "id": 34,
        "code": "02008",
        "name": "El Karimia",
        "name_ar": "الكريمية",
        "daira_id": 13
    },
    {
        "id": 35,
        "code": "02031",
        "name": "Harchoun",
        "name_ar": "حرشون",
        "daira_id": 13
    },
    {
        "id": 36,
        "code": "02071",
        "name": "Beni  Bouattab",
        "name_ar": "بني بوعتاب",
        "daira_id": 13
    },
    {
        "id": 37,
        "code": "02012",
        "name": "Taougrit",
        "name_ar": "تاوقريت",
        "daira_id": 14
    },
    {
        "id": 38,
        "code": "02032",
        "name": "Dahra",
        "name_ar": "الظهرة",
        "daira_id": 14
    },
    {
        "id": 39,
        "code": "02014",
        "name": "Zeboudja",
        "name_ar": "الزبوجة",
        "daira_id": 15
    },
    {
        "id": 40,
        "code": "02019",
        "name": "Bouzeghaia",
        "name_ar": "بوزغاية",
        "daira_id": 15
    },
    {
        "id": 41,
        "code": "02039",
        "name": "Benairia",
        "name_ar": "بنايرية",
        "daira_id": 15
    },
    {
        "id": 42,
        "code": "21058",
        "name": "El Marsa",
        "name_ar": "المرسى",
        "daira_id": 260
    },
    {
        "id": 43,
        "code": "02060",
        "name": "Moussadek",
        "name_ar": "مصدق",
        "daira_id": 16
    },
    {
        "id": 44,
        "code": "02017",
        "name": "Beni Haoua",
        "name_ar": "بني حواء",
        "daira_id": 17
    },
    {
        "id": 45,
        "code": "02061",
        "name": "Oued Goussine",
        "name_ar": "وادي قوسين",
        "daira_id": 17
    },
    {
        "id": 46,
        "code": "02070",
        "name": "Breira",
        "name_ar": "بريرة",
        "daira_id": 17
    },
    {
        "id": 47,
        "code": "02018",
        "name": "Abou El Hassane",
        "name_ar": "أبو الحسن",
        "daira_id": 18
    },
    {
        "id": 48,
        "code": "02043",
        "name": "Tadjena",
        "name_ar": "تاجنة",
        "daira_id": 18
    },
    {
        "id": 49,
        "code": "02065",
        "name": "Talassa",
        "name_ar": "تلعصة",
        "daira_id": 18
    },
    {
        "id": 50,
        "code": "02037",
        "name": "Ouled Ben Abdelkader",
        "name_ar": "أولاد بن عبد القادر",
        "daira_id": 19
    },
    {
        "id": 51,
        "code": "02050",
        "name": "El Hadjadj",
        "name_ar": "الحجاج",
        "daira_id": 19
    },
    {
        "id": 52,
        "code": "03000",
        "name": "Laghouat",
        "name_ar": "الأغواط",
        "daira_id": 20
    },
    {
        "id": 53,
        "code": "03001",
        "name": "Aflou",
        "name_ar": "أفلو",
        "daira_id": 21
    },
    {
        "id": 54,
        "code": "03024",
        "name": "Sidi Bouzid",
        "name_ar": "سيدي بوزيد",
        "daira_id": 21
    },
    {
        "id": 55,
        "code": "03034",
        "name": "Sebgag",
        "name_ar": "سبقاق",
        "daira_id": 21
    },
    {
        "id": 56,
        "code": "03003",
        "name": "Ksar El Hirane",
        "name_ar": "قصر الحيران",
        "daira_id": 22
    },
    {
        "id": 57,
        "code": "03033",
        "name": "Benacer Benchohra",
        "name_ar": "بن ناصر بن شهرة",
        "daira_id": 22
    },
    {
        "id": 58,
        "code": "03004",
        "name": "Hassi R'mel",
        "name_ar": "حاسي الرمل",
        "daira_id": 23
    },
    {
        "id": 59,
        "code": "03022",
        "name": "Hassi Delaa",
        "name_ar": "حاسي الدلاعة",
        "daira_id": 23
    },
    {
        "id": 60,
        "code": "03005",
        "name": "Brida",
        "name_ar": "بريدة",
        "daira_id": 24
    },
    {
        "id": 61,
        "code": "03026",
        "name": "Taouiala",
        "name_ar": "تاويالة",
        "daira_id": 24
    },
    {
        "id": 62,
        "code": "03038",
        "name": "Hadj Mechri",
        "name_ar": "الحاج مشري",
        "daira_id": 24
    },
    {
        "id": 63,
        "code": "03007",
        "name": "Tadjemout",
        "name_ar": "تاجموت",
        "daira_id": 25
    },
    {
        "id": 64,
        "code": "03010",
        "name": "Kheneg",
        "name_ar": "الخنق",
        "daira_id": 25
    },
    {
        "id": 65,
        "code": "03011",
        "name": "Tadjrouna",
        "name_ar": "تاجرونة",
        "daira_id": 25
    },
    {
        "id": 66,
        "code": "03012",
        "name": "Ain Madhi",
        "name_ar": "عين ماضي",
        "daira_id": 25
    },
    {
        "id": 67,
        "code": "03040",
        "name": "El Haouaita",
        "name_ar": "الحويطة",
        "daira_id": 25
    },
    {
        "id": 68,
        "code": "03013",
        "name": "El Beidha",
        "name_ar": "البيضاء",
        "daira_id": 26
    },
    {
        "id": 69,
        "code": "03025",
        "name": "Gueltat Sidi Saad",
        "name_ar": "قلتة سيدي سعد",
        "daira_id": 26
    },
    {
        "id": 70,
        "code": "03028",
        "name": "Ain Sidi Ali",
        "name_ar": "عين سيدي علي",
        "daira_id": 26
    },
    {
        "id": 71,
        "code": "03014",
        "name": "El Assafia",
        "name_ar": "العسافية",
        "daira_id": 27
    },
    {
        "id": 72,
        "code": "03019",
        "name": "Sidi Makhlouf",
        "name_ar": "سيدي مخلوف",
        "daira_id": 27
    },
    {
        "id": 73,
        "code": "03023",
        "name": "El Ghicha",
        "name_ar": "الغيشة",
        "daira_id": 28
    },
    {
        "id": 74,
        "code": "03027",
        "name": "Oued Morra",
        "name_ar": "وادي مرة",
        "daira_id": 29
    },
    {
        "id": 75,
        "code": "03041",
        "name": "Oued M'zi",
        "name_ar": "وادي مزي",
        "daira_id": 29
    },
    {
        "id": 76,
        "code": "04000",
        "name": "Oum El Bouaghi",
        "name_ar": "أم البواقي",
        "daira_id": 30
    },
    {
        "id": 77,
        "code": "04023",
        "name": "Ain Zitoun",
        "name_ar": "عين الزيتون",
        "daira_id": 30
    },
    {
        "id": 78,
        "code": "04001",
        "name": "Ain Beida",
        "name_ar": "عين البيضاء",
        "daira_id": 31
    },
    {
        "id": 79,
        "code": "04022",
        "name": "Berriche",
        "name_ar": "بريش",
        "daira_id": 31
    },
    {
        "id": 80,
        "code": "04024",
        "name": "Zorg",
        "name_ar": "الزرق",
        "daira_id": 31
    },
    {
        "id": 81,
        "code": "04002",
        "name": "Ain M'lila",
        "name_ar": "عين مليلة",
        "daira_id": 32
    },
    {
        "id": 82,
        "code": "04019",
        "name": "Ouled Hamla",
        "name_ar": "أولاد حملة",
        "daira_id": 32
    },
    {
        "id": 83,
        "code": "04041",
        "name": "Ouled Gacem",
        "name_ar": "أولاد قاسم",
        "daira_id": 32
    },
    {
        "id": 84,
        "code": "04004",
        "name": "Meskiana",
        "name_ar": "مسكيانة",
        "daira_id": 33
    },
    {
        "id": 85,
        "code": "04026",
        "name": "Behir Chergui",
        "name_ar": "بحير الشرقي",
        "daira_id": 33
    },
    {
        "id": 86,
        "code": "04044",
        "name": "El Belala",
        "name_ar": "البلالة",
        "daira_id": 33
    },
    {
        "id": 87,
        "code": "04045",
        "name": "Rahia",
        "name_ar": "الرحية",
        "daira_id": 33
    },
    {
        "id": 88,
        "code": "04005",
        "name": "Ain Fekroun",
        "name_ar": "عين فكرون",
        "daira_id": 34
    },
    {
        "id": 89,
        "code": "04042",
        "name": "El Fedjoudj Boughrara Sa",
        "name_ar": "الفجوج بوغرارة سعودي",
        "daira_id": 34
    },
    {
        "id": 90,
        "code": "04006",
        "name": "Ain Kercha",
        "name_ar": "عين كرشة",
        "daira_id": 35
    },
    {
        "id": 91,
        "code": "04012",
        "name": "Hanchir Toumghani",
        "name_ar": "هنشير تومغني",
        "daira_id": 35
    },
    {
        "id": 92,
        "code": "04032",
        "name": "El Harmilia",
        "name_ar": "الحرملية",
        "daira_id": 35
    },
    {
        "id": 93,
        "code": "04008",
        "name": "Dhalaa",
        "name_ar": "الضلعة",
        "daira_id": 36
    },
    {
        "id": 94,
        "code": "04040",
        "name": "El Djazia",
        "name_ar": "الجازية",
        "daira_id": 36
    },
    {
        "id": 95,
        "code": "04010",
        "name": "Souk Naamane",
        "name_ar": "سوق نعمان",
        "daira_id": 37
    },
    {
        "id": 96,
        "code": "04021",
        "name": "Bir Chouhada",
        "name_ar": "بئر الشهداء",
        "daira_id": 37
    },
    {
        "id": 97,
        "code": "04011",
        "name": "Sigus",
        "name_ar": "سيقوس",
        "daira_id": 38
    },
    {
        "id": 98,
        "code": "04038",
        "name": "El Amiria",
        "name_ar": "العامرية",
        "daira_id": 38
    },
    {
        "id": 99,
        "code": "04013",
        "name": "Fkirina",
        "name_ar": "فكيرينة",
        "daira_id": 39
    },
    {
        "id": 100,
        "code": "04047",
        "name": "Oued Nini",
        "name_ar": "وادي نيني",
        "daira_id": 39
    },
    {
        "id": 101,
        "code": "04018",
        "name": "Ksar Sbahi",
        "name_ar": "قصر الصباحي",
        "daira_id": 40
    },
    {
        "id": 102,
        "code": "04020",
        "name": "Ain Babouche",
        "name_ar": "عين ببوش",
        "daira_id": 41
    },
    {
        "id": 103,
        "code": "04025",
        "name": "Ain Diss",
        "name_ar": "عين الديس",
        "daira_id": 41
    },
    {
        "id": 104,
        "code": "05000",
        "name": "Batna",
        "name_ar": "باتنة",
        "daira_id": 42
    },
    {
        "id": 105,
        "code": "05054",
        "name": "Oued Chaaba",
        "name_ar": "وادي الشعبة",
        "daira_id": 42
    },
    {
        "id": 106,
        "code": "05077",
        "name": "Fesdis",
        "name_ar": "فسديس",
        "daira_id": 42
    },
    {
        "id": 107,
        "code": "05001",
        "name": "Barika",
        "name_ar": "بريكة",
        "daira_id": 43
    },
    {
        "id": 108,
        "code": "05037",
        "name": "M Doukal",
        "name_ar": "إمدوكل",
        "daira_id": 43
    },
    {
        "id": 109,
        "code": "05045",
        "name": "Bitam",
        "name_ar": "بيطام",
        "daira_id": 43
    },
    {
        "id": 110,
        "code": "05002",
        "name": "Ain Touta",
        "name_ar": "عين التوتة",
        "daira_id": 44
    },
    {
        "id": 111,
        "code": "05122",
        "name": "Ouled Aouf",
        "name_ar": "أولاد عوف",
        "daira_id": 44
    },
    {
        "id": 112,
        "code": "05123",
        "name": "Maafa",
        "name_ar": "معافة",
        "daira_id": 44
    },
    {
        "id": 113,
        "code": "05141",
        "name": "Beni Foudhala El Hakania",
        "name_ar": "بني فضالة الحقانية",
        "daira_id": 44
    },
    {
        "id": 114,
        "code": "05004",
        "name": "N Gaous",
        "name_ar": "نقاوس",
        "daira_id": 45
    },
    {
        "id": 115,
        "code": "05057",
        "name": "Boumagueur",
        "name_ar": "بومقر",
        "daira_id": 45
    },
    {
        "id": 116,
        "code": "05064",
        "name": "Sefiane",
        "name_ar": "سفيان",
        "daira_id": 45
    },
    {
        "id": 117,
        "code": "05007",
        "name": "Arris",
        "name_ar": "أريس",
        "daira_id": 46
    },
    {
        "id": 118,
        "code": "05060",
        "name": "Tighanimine",
        "name_ar": "تيغانمين",
        "daira_id": 46
    },
    {
        "id": 119,
        "code": "05009",
        "name": "Ras El Aioun",
        "name_ar": "رأس العيون",
        "daira_id": 47
    },
    {
        "id": 120,
        "code": "05044",
        "name": "Ouled Sellem",
        "name_ar": "أولاد سلام",
        "daira_id": 47
    },
    {
        "id": 121,
        "code": "05067",
        "name": "Guigba",
        "name_ar": "القيقبة",
        "daira_id": 47
    },
    {
        "id": 122,
        "code": "05090",
        "name": "Gosbat",
        "name_ar": "القصبات",
        "daira_id": 47
    },
    {
        "id": 123,
        "code": "05091",
        "name": "Rahbat",
        "name_ar": "الرحبات",
        "daira_id": 47
    },
    {
        "id": 124,
        "code": "05011",
        "name": "Tazoult",
        "name_ar": "تازولت",
        "daira_id": 48
    },
    {
        "id": 125,
        "code": "05069",
        "name": "Ouyoun El Assafir",
        "name_ar": "عيون العصافير",
        "daira_id": 48
    },
    {
        "id": 126,
        "code": "05012",
        "name": "Menaa",
        "name_ar": "منعة",
        "daira_id": 49
    },
    {
        "id": 127,
        "code": "05059",
        "name": "Tigharghar",
        "name_ar": "تغرغار",
        "daira_id": 49
    },
    {
        "id": 128,
        "code": "05013",
        "name": "Merouana",
        "name_ar": "مروانة",
        "daira_id": 50
    },
    {
        "id": 129,
        "code": "05016",
        "name": "Oued El Ma",
        "name_ar": "وادي الماء",
        "daira_id": 50
    },
    {
        "id": 130,
        "code": "05033",
        "name": "Hidoussa",
        "name_ar": "حيدوسة",
        "daira_id": 50
    },
    {
        "id": 131,
        "code": "05047",
        "name": "Ksar Bellezma",
        "name_ar": "قصر بلزمة",
        "daira_id": 50
    },
    {
        "id": 132,
        "code": "05015",
        "name": "El Madher",
        "name_ar": "المعذر",
        "daira_id": 51
    },
    {
        "id": 133,
        "code": "05031",
        "name": "Ain Yagout",
        "name_ar": "عين ياقوت",
        "daira_id": 51
    },
    {
        "id": 134,
        "code": "05104",
        "name": "Boumia",
        "name_ar": "بومية",
        "daira_id": 51
    },
    {
        "id": 135,
        "code": "05105",
        "name": "Djerma",
        "name_ar": "جرمة",
        "daira_id": 51
    },
    {
        "id": 136,
        "code": "05020",
        "name": "T Kout",
        "name_ar": "تكوت",
        "daira_id": 52
    },
    {
        "id": 137,
        "code": "05043",
        "name": "Ghassira",
        "name_ar": "غسيرة",
        "daira_id": 52
    },
    {
        "id": 138,
        "code": "05079",
        "name": "Kimmel",
        "name_ar": "كيمل",
        "daira_id": 52
    },
    {
        "id": 139,
        "code": "05023",
        "name": "Timgad",
        "name_ar": "تيمقاد",
        "daira_id": 53
    },
    {
        "id": 140,
        "code": "05063",
        "name": "Ouled Fadel",
        "name_ar": "أولاد فاضل",
        "daira_id": 53
    },
    {
        "id": 141,
        "code": "05025",
        "name": "Seriana",
        "name_ar": "سريانة",
        "daira_id": 54
    },
    {
        "id": 142,
        "code": "05071",
        "name": "Zanet El Beida",
        "name_ar": "زانة البيضاء",
        "daira_id": 54
    },
    {
        "id": 143,
        "code": "05117",
        "name": "Lazrou",
        "name_ar": "لازرو",
        "daira_id": 54
    },
    {
        "id": 144,
        "code": "05026",
        "name": "Ichemoul",
        "name_ar": "إشمول",
        "daira_id": 55
    },
    {
        "id": 145,
        "code": "05049",
        "name": "Foum Toub",
        "name_ar": "فم الطوب",
        "daira_id": 55
    },
    {
        "id": 146,
        "code": "05083",
        "name": "Inoughissen",
        "name_ar": "إينوغيسن",
        "daira_id": 55
    },
    {
        "id": 147,
        "code": "05027",
        "name": "Seggana",
        "name_ar": "سقانة",
        "daira_id": 56
    },
    {
        "id": 148,
        "code": "05127",
        "name": "Tilatou",
        "name_ar": "تيلاطو",
        "daira_id": 56
    },
    {
        "id": 149,
        "code": "05032",
        "name": "Ain Djasser",
        "name_ar": "عين جاسر",
        "daira_id": 57
    },
    {
        "id": 150,
        "code": "48059",
        "name": "El Hassi",
        "name_ar": "الحاسي",
        "daira_id": 514
    },
    {
        "id": 151,
        "code": "05035",
        "name": "Teniet El Abed",
        "name_ar": "ثنية العابد",
        "daira_id": 58
    },
    {
        "id": 152,
        "code": "05036",
        "name": "Oued Taga",
        "name_ar": "وادي الطاقة",
        "daira_id": 58
    },
    {
        "id": 153,
        "code": "05038",
        "name": "Chir",
        "name_ar": "شير",
        "daira_id": 58
    },
    {
        "id": 154,
        "code": "05039",
        "name": "Chemora",
        "name_ar": "الشمرة",
        "daira_id": 59
    },
    {
        "id": 155,
        "code": "05062",
        "name": "Boulhilat",
        "name_ar": "بولهيلات",
        "daira_id": 59
    },
    {
        "id": 156,
        "code": "05041",
        "name": "Bouzina",
        "name_ar": "بوزينة",
        "daira_id": 60
    },
    {
        "id": 157,
        "code": "05046",
        "name": "Djezzar",
        "name_ar": "الجزار",
        "daira_id": 61
    },
    {
        "id": 158,
        "code": "05087",
        "name": "Azil Abedelkader",
        "name_ar": "عزيل عبد القادر",
        "daira_id": 61
    },
    {
        "id": 159,
        "code": "05121",
        "name": "Ouled Ammar",
        "name_ar": "أولاد عمار",
        "daira_id": 61
    },
    {
        "id": 160,
        "code": "05055",
        "name": "Taxlent",
        "name_ar": "تاكسلانت",
        "daira_id": 62
    },
    {
        "id": 161,
        "code": "05066",
        "name": "Ouled Si Slimane",
        "name_ar": "أولاد سي سليمان",
        "daira_id": 62
    },
    {
        "id": 162,
        "code": "06000",
        "name": "Bejaia",
        "name_ar": "بجاية",
        "daira_id": 63
    },
    {
        "id": 163,
        "code": "06017",
        "name": "Oued Ghir",
        "name_ar": "وادي غير",
        "daira_id": 63
    },
    {
        "id": 164,
        "code": "06001",
        "name": "Akbou",
        "name_ar": "أقبو",
        "daira_id": 64
    },
    {
        "id": 165,
        "code": "06048",
        "name": "Ighram",
        "name_ar": "اغرم",
        "daira_id": 64
    },
    {
        "id": 166,
        "code": "06052",
        "name": "Chellata",
        "name_ar": "شلاطة",
        "daira_id": 64
    },
    {
        "id": 167,
        "code": "06053",
        "name": "Tamokra",
        "name_ar": "تامقرة",
        "daira_id": 64
    },
    {
        "id": 168,
        "code": "06003",
        "name": "El Kseur",
        "name_ar": "القصر",
        "daira_id": 65
    },
    {
        "id": 169,
        "code": "06030",
        "name": "Toudja",
        "name_ar": "توجة",
        "daira_id": 65
    },
    {
        "id": 170,
        "code": "06041",
        "name": "Fenaia Il Maten",
        "name_ar": "فناية الماثن",
        "daira_id": 65
    },
    {
        "id": 171,
        "code": "06004",
        "name": "Kherrata",
        "name_ar": "خراطة",
        "daira_id": 66
    },
    {
        "id": 172,
        "code": "06070",
        "name": "Dra El Caid",
        "name_ar": "ذراع القايد",
        "daira_id": 66
    },
    {
        "id": 173,
        "code": "06005",
        "name": "Sidi-Aich",
        "name_ar": "سيدي عيش",
        "daira_id": 67
    },
    {
        "id": 174,
        "code": "06028",
        "name": "Tifra",
        "name_ar": "تيفرة",
        "daira_id": 67
    },
    {
        "id": 175,
        "code": "06037",
        "name": "Tinebdar",
        "name_ar": "تينبدار",
        "daira_id": 67
    },
    {
        "id": 176,
        "code": "06043",
        "name": "Leflaye",
        "name_ar": "الفلاي",
        "daira_id": 67
    },
    {
        "id": 177,
        "code": "06085",
        "name": "Sidi Ayad",
        "name_ar": "سيدي عياد",
        "daira_id": 67
    },
    {
        "id": 178,
        "code": "06006",
        "name": "Tazmalt",
        "name_ar": "تازمالت",
        "daira_id": 68
    },
    {
        "id": 179,
        "code": "06018",
        "name": "Boudjellil",
        "name_ar": "بو جليل",
        "daira_id": 68
    },
    {
        "id": 180,
        "code": "06039",
        "name": "Beni-Mallikeche",
        "name_ar": "بني مليكش",
        "daira_id": 68
    },
    {
        "id": 181,
        "code": "06007",
        "name": "Aokas",
        "name_ar": "أوقاس",
        "daira_id": 69
    },
    {
        "id": 182,
        "code": "06058",
        "name": "Tizi-N'berber",
        "name_ar": "تيزي نبربر",
        "daira_id": 69
    },
    {
        "id": 183,
        "code": "06008",
        "name": "Amizour",
        "name_ar": "أميزور",
        "daira_id": 70
    },
    {
        "id": 184,
        "code": "06020",
        "name": "Smaoun",
        "name_ar": "سمعون",
        "daira_id": 70
    },
    {
        "id": 185,
        "code": "06033",
        "name": "Feraoun",
        "name_ar": "فرعون",
        "daira_id": 70
    },
    {
        "id": 186,
        "code": "06067",
        "name": "Beni Djellil",
        "name_ar": "بني جليل",
        "daira_id": 70
    },
    {
        "id": 187,
        "code": "06009",
        "name": "Barbacha",
        "name_ar": "برباشة",
        "daira_id": 71
    },
    {
        "id": 188,
        "code": "06032",
        "name": "Kendira",
        "name_ar": "كنديرة",
        "daira_id": 71
    },
    {
        "id": 189,
        "code": "06010",
        "name": "Ouzellaguen",
        "name_ar": "أوزلاقن",
        "daira_id": 72
    },
    {
        "id": 190,
        "code": "06011",
        "name": "Seddouk",
        "name_ar": "صدوق",
        "daira_id": 73
    },
    {
        "id": 191,
        "code": "06031",
        "name": "Bouhamza",
        "name_ar": "بوحمزة",
        "daira_id": 73
    },
    {
        "id": 192,
        "code": "06034",
        "name": "Amalou",
        "name_ar": "أمالو",
        "daira_id": 73
    },
    {
        "id": 193,
        "code": "06038",
        "name": "M'cisna",
        "name_ar": "مسيسنة",
        "daira_id": 73
    },
    {
        "id": 194,
        "code": "06012",
        "name": "Souk El Tenine",
        "name_ar": "سوق لإثنين",
        "daira_id": 74
    },
    {
        "id": 195,
        "code": "06076",
        "name": "Melbou",
        "name_ar": "مالبو",
        "daira_id": 74
    },
    {
        "id": 196,
        "code": "06077",
        "name": "Tamridjet",
        "name_ar": "تامريجت",
        "daira_id": 74
    },
    {
        "id": 197,
        "code": "06013",
        "name": "Ait R'zine",
        "name_ar": "أيت رزين",
        "daira_id": 75
    },
    {
        "id": 198,
        "code": "06014",
        "name": "Ighil-Ali",
        "name_ar": "إغيل علي",
        "daira_id": 75
    },
    {
        "id": 199,
        "code": "06015",
        "name": "Taskriout",
        "name_ar": "تاسكريوت",
        "daira_id": 76
    },
    {
        "id": 200,
        "code": "06016",
        "name": "Darguina",
        "name_ar": "درقينة",
        "daira_id": 76
    },
    {
        "id": 201,
        "code": "06044",
        "name": "Ait-Smail",
        "name_ar": "أيت إسماعيل",
        "daira_id": 76
    },
    {
        "id": 202,
        "code": "35027",
        "name": "Timezrit",
        "name_ar": "تيمزريت",
        "daira_id": 402
    },
    {
        "id": 203,
        "code": "06021",
        "name": "Adekar",
        "name_ar": "أدكار",
        "daira_id": 78
    },
    {
        "id": 204,
        "code": "06027",
        "name": "Beni K'sila",
        "name_ar": "بني كسيلة",
        "daira_id": 78
    },
    {
        "id": 205,
        "code": "06035",
        "name": "Taourit Ighil",
        "name_ar": "تاوريرت إغيل",
        "daira_id": 78
    },
    {
        "id": 206,
        "code": "06022",
        "name": "Chemini",
        "name_ar": "شميني",
        "daira_id": 79
    },
    {
        "id": 207,
        "code": "06025",
        "name": "Akfadou",
        "name_ar": "أكفادو",
        "daira_id": 79
    },
    {
        "id": 208,
        "code": "06036",
        "name": "Souk Oufella",
        "name_ar": "سوق اوفلا",
        "daira_id": 79
    },
    {
        "id": 209,
        "code": "06087",
        "name": "Tibane",
        "name_ar": "طيبان",
        "daira_id": 79
    },
    {
        "id": 210,
        "code": "06023",
        "name": "Tichy",
        "name_ar": "تيشي",
        "daira_id": 80
    },
    {
        "id": 211,
        "code": "06059",
        "name": "Boukhelifa",
        "name_ar": "بوخليفة",
        "daira_id": 80
    },
    {
        "id": 212,
        "code": "06066",
        "name": "Tala Hamza",
        "name_ar": "تالة حمزة",
        "daira_id": 80
    },
    {
        "id": 213,
        "code": "06024",
        "name": "Benimaouche",
        "name_ar": "بني معوش",
        "daira_id": 81
    },
    {
        "id": 214,
        "code": "07000",
        "name": "Biskra",
        "name_ar": "بسكرة",
        "daira_id": 82
    },
    {
        "id": 215,
        "code": "07037",
        "name": "El Hadjab",
        "name_ar": "الحاجب",
        "daira_id": 82
    },
    {
        "id": 216,
        "code": "07003",
        "name": "Tolga",
        "name_ar": "طولقة",
        "daira_id": 83
    },
    {
        "id": 217,
        "code": "07009",
        "name": "Lichana",
        "name_ar": "ليشانة",
        "daira_id": 83
    },
    {
        "id": 218,
        "code": "07021",
        "name": "Bordj Ben Azzouz",
        "name_ar": "برج بن عزوز",
        "daira_id": 83
    },
    {
        "id": 219,
        "code": "07022",
        "name": "Bouchakroun",
        "name_ar": "بوشقرون",
        "daira_id": 83
    },
    {
        "id": 220,
        "code": "07005",
        "name": "Sidi Okba",
        "name_ar": "سيدي عقبة",
        "daira_id": 84
    },
    {
        "id": 221,
        "code": "07024",
        "name": "Chetma",
        "name_ar": "شتمة",
        "daira_id": 84
    },
    {
        "id": 222,
        "code": "07028",
        "name": "El Haouch",
        "name_ar": "الحوش",
        "daira_id": 84
    },
    {
        "id": 223,
        "code": "07039",
        "name": "Ain Naga",
        "name_ar": "عين الناقة",
        "daira_id": 84
    },
    {
        "id": 224,
        "code": "07008",
        "name": "El Kantara",
        "name_ar": "القنطرة",
        "daira_id": 85
    },
    {
        "id": 225,
        "code": "07013",
        "name": "Ain Zaatout",
        "name_ar": "عين زعطوط",
        "daira_id": 85
    },
    {
        "id": 226,
        "code": "07010",
        "name": "M'chouneche",
        "name_ar": "مشونش",
        "daira_id": 86
    },
    {
        "id": 227,
        "code": "07011",
        "name": "Ourlal",
        "name_ar": "أورلال",
        "daira_id": 87
    },
    {
        "id": 228,
        "code": "07033",
        "name": "Lioua",
        "name_ar": "ليوة",
        "daira_id": 87
    },
    {
        "id": 229,
        "code": "07034",
        "name": "Mekhadma",
        "name_ar": "مخادمة",
        "daira_id": 87
    },
    {
        "id": 230,
        "code": "07035",
        "name": "Oumache",
        "name_ar": "أوماش",
        "daira_id": 87
    },
    {
        "id": 231,
        "code": "07068",
        "name": "M'lili",
        "name_ar": "مليلي",
        "daira_id": 87
    },
    {
        "id": 232,
        "code": "07012",
        "name": "Zeribet El Oued",
        "name_ar": "زريبة الوادي",
        "daira_id": 88
    },
    {
        "id": 233,
        "code": "07026",
        "name": "El Feidh",
        "name_ar": "الفيض",
        "daira_id": 88
    },
    {
        "id": 234,
        "code": "07032",
        "name": "Khenguet Sidi Nadji",
        "name_ar": "خنقة سيدي ناجي",
        "daira_id": 88
    },
    {
        "id": 235,
        "code": "07043",
        "name": "Meziraa",
        "name_ar": "المزيرعة",
        "daira_id": 88
    },
    {
        "id": 236,
        "code": "07023",
        "name": "Branis",
        "name_ar": "برانيس",
        "daira_id": 89
    },
    {
        "id": 237,
        "code": "07025",
        "name": "Djemorah",
        "name_ar": "جمورة",
        "daira_id": 89
    },
    {
        "id": 238,
        "code": "07027",
        "name": "El Ghrous",
        "name_ar": "الغروس",
        "daira_id": 90
    },
    {
        "id": 239,
        "code": "07031",
        "name": "Foughala",
        "name_ar": "فوغالة",
        "daira_id": 90
    },
    {
        "id": 240,
        "code": "07030",
        "name": "El Outaya",
        "name_ar": "الوطاية",
        "daira_id": 91
    },
    {
        "id": 241,
        "code": "08000",
        "name": "Bechar",
        "name_ar": "بشار",
        "daira_id": 92
    },
    {
        "id": 242,
        "code": "08003",
        "name": "Abadla",
        "name_ar": "العبادلة",
        "daira_id": 93
    },
    {
        "id": 243,
        "code": "08023",
        "name": "Erg-Ferradj",
        "name_ar": "عرق فراج",
        "daira_id": 93
    },
    {
        "id": 244,
        "code": "08027",
        "name": "Machraa-Houari-Boumediene",
        "name_ar": "مشرع هواري بومدين",
        "daira_id": 93
    },
    {
        "id": 245,
        "code": "08010",
        "name": "Beni-Ounif",
        "name_ar": "بني ونيف",
        "daira_id": 94
    },
    {
        "id": 246,
        "code": "08011",
        "name": "Kenadsa",
        "name_ar": "القنادسة",
        "daira_id": 95
    },
    {
        "id": 247,
        "code": "08041",
        "name": "Meridja",
        "name_ar": "المريجة",
        "daira_id": 95
    },
    {
        "id": 248,
        "code": "08026",
        "name": "Lahmar",
        "name_ar": "لحمر",
        "daira_id": 96
    },
    {
        "id": 249,
        "code": "08034",
        "name": "Boukais",
        "name_ar": "بوكايس",
        "daira_id": 96
    },
    {
        "id": 250,
        "code": "08042",
        "name": "Mogheul",
        "name_ar": "موغل",
        "daira_id": 96
    },
    {
        "id": 251,
        "code": "08029",
        "name": "Tabelbala",
        "name_ar": "تبلبالة",
        "daira_id": 97
    },
    {
        "id": 252,
        "code": "08030",
        "name": "Taghit",
        "name_ar": "تاغيت",
        "daira_id": 98
    },
    {
        "id": 253,
        "code": "09000",
        "name": "Blida",
        "name_ar": "البليدة",
        "daira_id": 99
    },
    {
        "id": 254,
        "code": "09019",
        "name": "Bouarfa",
        "name_ar": "بوعرفة",
        "daira_id": 99
    },
    {
        "id": 255,
        "code": "09001",
        "name": "Boufarik",
        "name_ar": "بوفاريك",
        "daira_id": 100
    },
    {
        "id": 256,
        "code": "09022",
        "name": "Soumaa",
        "name_ar": "الصومعة",
        "daira_id": 100
    },
    {
        "id": 257,
        "code": "09029",
        "name": "Guerrouaou",
        "name_ar": "قرواو",
        "daira_id": 100
    },
    {
        "id": 258,
        "code": "09002",
        "name": "Larbaa",
        "name_ar": "الأربعاء",
        "daira_id": 101
    },
    {
        "id": 259,
        "code": "09034",
        "name": "Souhane",
        "name_ar": "صوحان",
        "daira_id": 101
    },
    {
        "id": 260,
        "code": "09003",
        "name": "Beni Mered",
        "name_ar": "بني مراد",
        "daira_id": 102
    },
    {
        "id": 261,
        "code": "09015",
        "name": "Ouled Yaich",
        "name_ar": "أولاد يعيش",
        "daira_id": 102
    },
    {
        "id": 262,
        "code": "09027",
        "name": "Chrea",
        "name_ar": "الشريعة",
        "daira_id": 102
    },
    {
        "id": 263,
        "code": "14018",
        "name": "Bougara",
        "name_ar": "بوقرة",
        "daira_id": 167
    },
    {
        "id": 264,
        "code": "09030",
        "name": "Hammam Elouane",
        "name_ar": "حمام ملوان",
        "daira_id": 103
    },
    {
        "id": 265,
        "code": "09033",
        "name": "Ouled Slama",
        "name_ar": "اولاد سلامة",
        "daira_id": 103
    },
    {
        "id": 266,
        "code": "09009",
        "name": "Chebli",
        "name_ar": "الشبلي",
        "daira_id": 104
    },
    {
        "id": 267,
        "code": "09020",
        "name": "Bouinan",
        "name_ar": "بوعينان",
        "daira_id": 104
    },
    {
        "id": 268,
        "code": "09010",
        "name": "Chiffa",
        "name_ar": "الشفة",
        "daira_id": 105
    },
    {
        "id": 269,
        "code": "09013",
        "name": "Mouzaia",
        "name_ar": "موزاية",
        "daira_id": 105
    },
    {
        "id": 270,
        "code": "09023",
        "name": "Ain Romana",
        "name_ar": "عين الرمانة",
        "daira_id": 105
    },
    {
        "id": 271,
        "code": "09011",
        "name": "El-Affroun",
        "name_ar": "العفرون",
        "daira_id": 106
    },
    {
        "id": 272,
        "code": "09032",
        "name": "Oued  Djer",
        "name_ar": "وادي جر",
        "daira_id": 106
    },
    {
        "id": 273,
        "code": "09012",
        "name": "Meftah",
        "name_ar": "مفتاح",
        "daira_id": 107
    },
    {
        "id": 274,
        "code": "09028",
        "name": "Djebabra",
        "name_ar": "جبابرة",
        "daira_id": 107
    },
    {
        "id": 275,
        "code": "09014",
        "name": "Oued El Alleug",
        "name_ar": "وادي العلايق",
        "daira_id": 108
    },
    {
        "id": 276,
        "code": "09024",
        "name": "Beni-Tamou",
        "name_ar": "بني تامو",
        "daira_id": 108
    },
    {
        "id": 277,
        "code": "09025",
        "name": "Benkhelil",
        "name_ar": "بن خليل",
        "daira_id": 108
    },
    {
        "id": 278,
        "code": "10000",
        "name": "Bouira",
        "name_ar": "البويرة",
        "daira_id": 109
    },
    {
        "id": 279,
        "code": "31014",
        "name": "Ain Turk",
        "name_ar": "عين الترك",
        "daira_id": 372
    },
    {
        "id": 280,
        "code": "10034",
        "name": "Ait Laaziz",
        "name_ar": "أيت لعزيز",
        "daira_id": 109
    },
    {
        "id": 281,
        "code": "10002",
        "name": "Lakhdaria",
        "name_ar": "الأخضرية",
        "daira_id": 110
    },
    {
        "id": 282,
        "code": "10016",
        "name": "Bouderbala",
        "name_ar": "بودربالة",
        "daira_id": 110
    },
    {
        "id": 283,
        "code": "10037",
        "name": "Guerrouma",
        "name_ar": "قرومة",
        "daira_id": 110
    },
    {
        "id": 284,
        "code": "10039",
        "name": "Maala",
        "name_ar": "معلة",
        "daira_id": 110
    },
    {
        "id": 285,
        "code": "10047",
        "name": "Z'barbar (El Isseri )",
        "name_ar": "زبربر",
        "daira_id": 110
    },
    {
        "id": 286,
        "code": "10054",
        "name": "Boukram",
        "name_ar": "بوكرم",
        "daira_id": 110
    },
    {
        "id": 287,
        "code": "10003",
        "name": "M Chedallah",
        "name_ar": "أمشدالة",
        "daira_id": 111
    },
    {
        "id": 288,
        "code": "10007",
        "name": "Aghbalou",
        "name_ar": "أغبالو",
        "daira_id": 111
    },
    {
        "id": 289,
        "code": "10011",
        "name": "Ath Mansour",
        "name_ar": "آث  منصور",
        "daira_id": 111
    },
    {
        "id": 290,
        "code": "29039",
        "name": "Chorfa",
        "name_ar": "الشرفاء",
        "daira_id": 348
    },
    {
        "id": 291,
        "code": "10030",
        "name": "Hanif",
        "name_ar": "حنيف",
        "daira_id": 111
    },
    {
        "id": 292,
        "code": "10043",
        "name": "Saharidj",
        "name_ar": "سحاريج",
        "daira_id": 111
    },
    {
        "id": 293,
        "code": "10004",
        "name": "Sour El Ghozlane",
        "name_ar": "سور الغزلان",
        "daira_id": 112
    },
    {
        "id": 294,
        "code": "10020",
        "name": "Dirah",
        "name_ar": "ديرة",
        "daira_id": 112
    },
    {
        "id": 295,
        "code": "10057",
        "name": "Dechmia",
        "name_ar": "الدشمية",
        "daira_id": 112
    },
    {
        "id": 296,
        "code": "10058",
        "name": "El-Hakimia",
        "name_ar": "الحاكمية",
        "daira_id": 112
    },
    {
        "id": 297,
        "code": "20013",
        "name": "Maamora",
        "name_ar": "المعمورة",
        "daira_id": 250
    },
    {
        "id": 298,
        "code": "10083",
        "name": "Ridane",
        "name_ar": "ريدان",
        "daira_id": 112
    },
    {
        "id": 299,
        "code": "10005",
        "name": "Ain-Bessem",
        "name_ar": "عين بسام",
        "daira_id": 113
    },
    {
        "id": 300,
        "code": "20001",
        "name": "Ain El Hadjar",
        "name_ar": "عين الحجر",
        "daira_id": 248
    },
    {
        "id": 301,
        "code": "10032",
        "name": "Ain Laloui",
        "name_ar": "عين العلوي",
        "daira_id": 113
    },
    {
        "id": 302,
        "code": "10006",
        "name": "Kadiria",
        "name_ar": "قادرية",
        "daira_id": 114
    },
    {
        "id": 303,
        "code": "10010",
        "name": "Aomar",
        "name_ar": "أعمر",
        "daira_id": 114
    },
    {
        "id": 304,
        "code": "10036",
        "name": "Djebahia",
        "name_ar": "جباحية",
        "daira_id": 114
    },
    {
        "id": 305,
        "code": "10008",
        "name": "Ahl El Ksar",
        "name_ar": "أهل القصر",
        "daira_id": 115
    },
    {
        "id": 306,
        "code": "10012",
        "name": "Bechloul",
        "name_ar": "بشلول",
        "daira_id": 115
    },
    {
        "id": 307,
        "code": "10021",
        "name": "El Adjiba",
        "name_ar": "العجيبة",
        "daira_id": 115
    },
    {
        "id": 308,
        "code": "10022",
        "name": "El Asnam",
        "name_ar": "الأسنام",
        "daira_id": 115
    },
    {
        "id": 309,
        "code": "10013",
        "name": "Bir Ghbalou",
        "name_ar": "بئر غبالو",
        "daira_id": 116
    },
    {
        "id": 310,
        "code": "10038",
        "name": "El Khabouzia",
        "name_ar": "الخبوزية",
        "daira_id": 116
    },
    {
        "id": 311,
        "code": "10042",
        "name": "Raouraoua",
        "name_ar": "روراوة",
        "daira_id": 116
    },
    {
        "id": 312,
        "code": "10014",
        "name": "Bordj Okhriss",
        "name_ar": "برج أوخريص",
        "daira_id": 117
    },
    {
        "id": 313,
        "code": "10040",
        "name": "Mezdour",
        "name_ar": "مزدور",
        "daira_id": 117
    },
    {
        "id": 314,
        "code": "10045",
        "name": "Taguedite",
        "name_ar": "تاقديت",
        "daira_id": 117
    },
    {
        "id": 315,
        "code": "10065",
        "name": "Hadjera Zerga",
        "name_ar": "الحجرة الزرقاء",
        "daira_id": 117
    },
    {
        "id": 316,
        "code": "10023",
        "name": "El Hachimia",
        "name_ar": "الهاشمية",
        "daira_id": 118
    },
    {
        "id": 317,
        "code": "10075",
        "name": "Oued El Berdi",
        "name_ar": "وادي البردي",
        "daira_id": 118
    },
    {
        "id": 318,
        "code": "10024",
        "name": "Haizer",
        "name_ar": "حيزر",
        "daira_id": 119
    },
    {
        "id": 319,
        "code": "39083",
        "name": "Taghzout",
        "name_ar": "تغزوت",
        "daira_id": 423
    },
    {
        "id": 320,
        "code": "10044",
        "name": "Souk El Khemis",
        "name_ar": "سوق الخميس",
        "daira_id": 120
    },
    {
        "id": 321,
        "code": "10060",
        "name": "El-Mokrani",
        "name_ar": "المقراني",
        "daira_id": 120
    },
    {
        "id": 322,
        "code": "11000",
        "name": "Tamanrasset",
        "name_ar": "تمنراست",
        "daira_id": 121
    },
    {
        "id": 323,
        "code": "11003",
        "name": "Ain Amguel",
        "name_ar": "عين امقل",
        "daira_id": 121
    },
    {
        "id": 324,
        "code": "11007",
        "name": "Abelsa",
        "name_ar": "ابلسة",
        "daira_id": 122
    },
    {
        "id": 325,
        "code": "11010",
        "name": "Tazrouk",
        "name_ar": "تاظروك",
        "daira_id": 123
    },
    {
        "id": 326,
        "code": "11013",
        "name": "Idles",
        "name_ar": "أدلس",
        "daira_id": 123
    },
    {
        "id": 327,
        "code": "12000",
        "name": "Tebessa",
        "name_ar": "تبسة",
        "daira_id": 124
    },
    {
        "id": 328,
        "code": "12001",
        "name": "Bir-El-Ater",
        "name_ar": "بئر العاتر",
        "daira_id": 125
    },
    {
        "id": 329,
        "code": "12043",
        "name": "El Ogla El Malha",
        "name_ar": "العقلة المالحة",
        "daira_id": 125
    },
    {
        "id": 330,
        "code": "12002",
        "name": "Cheria",
        "name_ar": "الشريعة",
        "daira_id": 126
    },
    {
        "id": 331,
        "code": "12053",
        "name": "Telidjen",
        "name_ar": "ثليجان",
        "daira_id": 126
    },
    {
        "id": 332,
        "code": "12003",
        "name": "Ouenza",
        "name_ar": "الونزة",
        "daira_id": 127
    },
    {
        "id": 333,
        "code": "12008",
        "name": "Ain Zerga",
        "name_ar": "عين الزرقاء",
        "daira_id": 127
    },
    {
        "id": 334,
        "code": "12023",
        "name": "El Meridj",
        "name_ar": "المريج",
        "daira_id": 127
    },
    {
        "id": 335,
        "code": "12005",
        "name": "El-Aouinet",
        "name_ar": "العوينات",
        "daira_id": 128
    },
    {
        "id": 336,
        "code": "12012",
        "name": "Boukhadra",
        "name_ar": "بوخضرة",
        "daira_id": 128
    },
    {
        "id": 337,
        "code": "12006",
        "name": "El Kouif",
        "name_ar": "الكويف",
        "daira_id": 129
    },
    {
        "id": 338,
        "code": "12019",
        "name": "Bekkaria",
        "name_ar": "بكارية",
        "daira_id": 129
    },
    {
        "id": 339,
        "code": "12039",
        "name": "Boulhaf Dyr",
        "name_ar": "بولحاف الدير",
        "daira_id": 129
    },
    {
        "id": 340,
        "code": "12011",
        "name": "Bir Mokkadem",
        "name_ar": "بئر مقدم",
        "daira_id": 130
    },
    {
        "id": 341,
        "code": "16082",
        "name": "Hammamet",
        "name_ar": "الحمامات",
        "daira_id": 196
    },
    {
        "id": 342,
        "code": "12046",
        "name": "Guorriguer",
        "name_ar": "قريقر",
        "daira_id": 130
    },
    {
        "id": 343,
        "code": "12014",
        "name": "El Malabiod",
        "name_ar": "الماء الابيض",
        "daira_id": 131
    },
    {
        "id": 344,
        "code": "12038",
        "name": "El-Houidjbet",
        "name_ar": "الحويجبات",
        "daira_id": 131
    },
    {
        "id": 345,
        "code": "39055",
        "name": "El Ogla",
        "name_ar": "العقلة",
        "daira_id": 429
    },
    {
        "id": 346,
        "code": "12032",
        "name": "Stah Guentis",
        "name_ar": "سطح قنطيس",
        "daira_id": 132
    },
    {
        "id": 347,
        "code": "12035",
        "name": "Bedjene",
        "name_ar": "بجن",
        "daira_id": 132
    },
    {
        "id": 348,
        "code": "12042",
        "name": "El Mezeraa",
        "name_ar": "المزرعة",
        "daira_id": 132
    },
    {
        "id": 349,
        "code": "12017",
        "name": "Morsott",
        "name_ar": "مرسط",
        "daira_id": 133
    },
    {
        "id": 350,
        "code": "12031",
        "name": "Bir Dheheb",
        "name_ar": "بئر الذهب",
        "daira_id": 133
    },
    {
        "id": 351,
        "code": "12024",
        "name": "Negrine",
        "name_ar": "نقرين",
        "daira_id": 134
    },
    {
        "id": 352,
        "code": "12044",
        "name": "Ferkane",
        "name_ar": "فركان",
        "daira_id": 134
    },
    {
        "id": 353,
        "code": "12027",
        "name": "Oum Ali",
        "name_ar": "أم علي",
        "daira_id": 135
    },
    {
        "id": 354,
        "code": "12037",
        "name": "Saf Saf El Ouesra",
        "name_ar": "صفصاف الوسرى",
        "daira_id": 135
    },
    {
        "id": 355,
        "code": "13000",
        "name": "Tlemcen",
        "name_ar": "تلمسان",
        "daira_id": 136
    },
    {
        "id": 356,
        "code": "13001",
        "name": "Maghnia",
        "name_ar": "مغنية",
        "daira_id": 137
    },
    {
        "id": 357,
        "code": "13036",
        "name": "Hammam Boughrara",
        "name_ar": "حمام بوغرارة",
        "daira_id": 137
    },
    {
        "id": 358,
        "code": "13002",
        "name": "Ghazaouet",
        "name_ar": "الغزوات",
        "daira_id": 138
    },
    {
        "id": 359,
        "code": "13020",
        "name": "Souahlia",
        "name_ar": "السواحلية",
        "daira_id": 138
    },
    {
        "id": 360,
        "code": "13032",
        "name": "Dar Yaghmoracen",
        "name_ar": "دار يغمراسن",
        "daira_id": 138
    },
    {
        "id": 361,
        "code": "13047",
        "name": "Tianet",
        "name_ar": "تيانت",
        "daira_id": 138
    },
    {
        "id": 362,
        "code": "13004",
        "name": "Nedroma",
        "name_ar": "ندرومة",
        "daira_id": 139
    },
    {
        "id": 363,
        "code": "13029",
        "name": "Djebala",
        "name_ar": "جبالة",
        "daira_id": 139
    },
    {
        "id": 364,
        "code": "13005",
        "name": "Remchi",
        "name_ar": "الرمشي",
        "daira_id": 140
    },
    {
        "id": 365,
        "code": "13013",
        "name": "Ain Youcef",
        "name_ar": "عين يوسف",
        "daira_id": 140
    },
    {
        "id": 366,
        "code": "13025",
        "name": "Beni Ouarsous",
        "name_ar": "بني وارسوس",
        "daira_id": 140
    },
    {
        "id": 367,
        "code": "13033",
        "name": "El Fehoul",
        "name_ar": "الفحول",
        "daira_id": 140
    },
    {
        "id": 368,
        "code": "13042",
        "name": "Sebbaa Chioukh",
        "name_ar": "سبعة شيوخ",
        "daira_id": 140
    },
    {
        "id": 369,
        "code": "13006",
        "name": "Sebdou",
        "name_ar": "سبدو",
        "daira_id": 141
    },
    {
        "id": 370,
        "code": "13031",
        "name": "El Aricha",
        "name_ar": "العريشة",
        "daira_id": 141
    },
    {
        "id": 371,
        "code": "13034",
        "name": "El Gor",
        "name_ar": "القور",
        "daira_id": 141
    },
    {
        "id": 372,
        "code": "13008",
        "name": "Bensekrane",
        "name_ar": "بن سكران",
        "daira_id": 142
    },
    {
        "id": 373,
        "code": "13019",
        "name": "Sidi Abdelli",
        "name_ar": "سيدي العبدلي",
        "daira_id": 142
    },
    {
        "id": 374,
        "code": "13009",
        "name": "Hennaya",
        "name_ar": "الحناية",
        "daira_id": 143
    },
    {
        "id": 375,
        "code": "13051",
        "name": "Zenata",
        "name_ar": "زناتة",
        "daira_id": 143
    },
    {
        "id": 376,
        "code": "13070",
        "name": "Ouled Riyah",
        "name_ar": "أولاد رياح",
        "daira_id": 143
    },
    {
        "id": 377,
        "code": "13010",
        "name": "Ouled Mimoun",
        "name_ar": "أولاد ميمون",
        "daira_id": 144
    },
    {
        "id": 378,
        "code": "13068",
        "name": "Oued Lakhdar",
        "name_ar": "وادي الخضر",
        "daira_id": 144
    },
    {
        "id": 379,
        "code": "13086",
        "name": "Beni Smiel",
        "name_ar": "بني صميل",
        "daira_id": 144
    },
    {
        "id": 380,
        "code": "13011",
        "name": "Sabra",
        "name_ar": "صبرة",
        "daira_id": 145
    },
    {
        "id": 381,
        "code": "13026",
        "name": "Bouhlou",
        "name_ar": "بوحلو",
        "daira_id": 145
    },
    {
        "id": 382,
        "code": "13012",
        "name": "Ain Tellout",
        "name_ar": "عين تالوت",
        "daira_id": 146
    },
    {
        "id": 383,
        "code": "13054",
        "name": "Ain Nehala",
        "name_ar": "عين النحالة",
        "daira_id": 146
    },
    {
        "id": 384,
        "code": "13014",
        "name": "Bab El Assa",
        "name_ar": "باب العسة",
        "daira_id": 147
    },
    {
        "id": 385,
        "code": "13046",
        "name": "Souani",
        "name_ar": "السواني",
        "daira_id": 147
    },
    {
        "id": 386,
        "code": "13078",
        "name": "Souk Tleta",
        "name_ar": "سوق الثلاثاء",
        "daira_id": 147
    },
    {
        "id": 387,
        "code": "13015",
        "name": "Honnaine",
        "name_ar": "هنين",
        "daira_id": 148
    },
    {
        "id": 388,
        "code": "13074",
        "name": "Beni Khellad",
        "name_ar": "بني خلاد",
        "daira_id": 148
    },
    {
        "id": 389,
        "code": "13017",
        "name": "Marsa Ben M'hidi",
        "name_ar": "مرسى بن مهيدي",
        "daira_id": 149
    },
    {
        "id": 390,
        "code": "13024",
        "name": "M'sirda Fouaga",
        "name_ar": "مسيردة الفواقة",
        "daira_id": 149
    },
    {
        "id": 391,
        "code": "13022",
        "name": "Ain Fezza",
        "name_ar": "عين فزة",
        "daira_id": 150
    },
    {
        "id": 392,
        "code": "13048",
        "name": "Chetouane",
        "name_ar": "شتوان",
        "daira_id": 150
    },
    {
        "id": 393,
        "code": "13058",
        "name": "Amieur",
        "name_ar": "عمير",
        "daira_id": 150
    },
    {
        "id": 394,
        "code": "13023",
        "name": "Ain Ghoraba",
        "name_ar": "عين غرابة",
        "daira_id": 151
    },
    {
        "id": 395,
        "code": "13038",
        "name": "Beni Mester",
        "name_ar": "بني مستر",
        "daira_id": 151
    },
    {
        "id": 396,
        "code": "27036",
        "name": "Mansourah",
        "name_ar": "منصورة",
        "daira_id": 329
    },
    {
        "id": 397,
        "code": "13079",
        "name": "Terny Beni Hediel",
        "name_ar": "تيرني بني هديل",
        "daira_id": 151
    },
    {
        "id": 398,
        "code": "13028",
        "name": "Ain Fetah",
        "name_ar": "عين فتاح",
        "daira_id": 152
    },
    {
        "id": 399,
        "code": "13035",
        "name": "Fellaoucene",
        "name_ar": "فلاوسن",
        "daira_id": 152
    },
    {
        "id": 400,
        "code": "13049",
        "name": "Ain Kebira",
        "name_ar": "عين الكبيرة",
        "daira_id": 152
    },
    {
        "id": 401,
        "code": "13030",
        "name": "Bouihi",
        "name_ar": "البويهي",
        "daira_id": 153
    },
    {
        "id": 402,
        "code": "13043",
        "name": "Sidi Djillali",
        "name_ar": "سيدي الجيلالي",
        "daira_id": 153
    },
    {
        "id": 403,
        "code": "13037",
        "name": "Beni Snous",
        "name_ar": "بني سنوس",
        "daira_id": 154
    },
    {
        "id": 404,
        "code": "13060",
        "name": "Beni Bahdel",
        "name_ar": "بني بهدل",
        "daira_id": 154
    },
    {
        "id": 405,
        "code": "13080",
        "name": "Azail",
        "name_ar": "العزايل",
        "daira_id": 154
    },
    {
        "id": 406,
        "code": "13044",
        "name": "Sidi Medjahed",
        "name_ar": "سيدي مجاهد",
        "daira_id": 155
    },
    {
        "id": 407,
        "code": "14000",
        "name": "Tiaret",
        "name_ar": "تيارت",
        "daira_id": 156
    },
    {
        "id": 408,
        "code": "14001",
        "name": "Frenda",
        "name_ar": "فرندة",
        "daira_id": 157
    },
    {
        "id": 409,
        "code": "14008",
        "name": "Ain El Hadid",
        "name_ar": "عين الحديد",
        "daira_id": 157
    },
    {
        "id": 410,
        "code": "14015",
        "name": "Takhemaret",
        "name_ar": "تخمرت",
        "daira_id": 157
    },
    {
        "id": 411,
        "code": "14002",
        "name": "Ksar Chellala",
        "name_ar": "قصر الشلالة",
        "daira_id": 158
    },
    {
        "id": 412,
        "code": "14038",
        "name": "Zmalet El Emir Abdelkade",
        "name_ar": "زمالة  الأمير عبد القادر",
        "daira_id": 158
    },
    {
        "id": 413,
        "code": "14051",
        "name": "Serghine",
        "name_ar": "سرغين",
        "daira_id": 158
    },
    {
        "id": 414,
        "code": "14003",
        "name": "Sougueur",
        "name_ar": "السوقر",
        "daira_id": 159
    },
    {
        "id": 415,
        "code": "14027",
        "name": "Si Abdelghani",
        "name_ar": "سي عبد الغني",
        "daira_id": 159
    },
    {
        "id": 416,
        "code": "14037",
        "name": "Tousnina",
        "name_ar": "توسنينة",
        "daira_id": 159
    },
    {
        "id": 417,
        "code": "14049",
        "name": "Faidja",
        "name_ar": "الفايجة",
        "daira_id": 159
    },
    {
        "id": 418,
        "code": "14004",
        "name": "Mahdia",
        "name_ar": "مهدية",
        "daira_id": 160
    },
    {
        "id": 419,
        "code": "14017",
        "name": "Ain Dzarit",
        "name_ar": "عين دزاريت",
        "daira_id": 160
    },
    {
        "id": 420,
        "code": "14030",
        "name": "Sebaine",
        "name_ar": "السبعين",
        "daira_id": 160
    },
    {
        "id": 421,
        "code": "14058",
        "name": "Nadorah",
        "name_ar": "الناظورة",
        "daira_id": 160
    },
    {
        "id": 422,
        "code": "14005",
        "name": "Rahouia",
        "name_ar": "الرحوية",
        "daira_id": 161
    },
    {
        "id": 423,
        "code": "14019",
        "name": "Guertoufa",
        "name_ar": "قرطوفة",
        "daira_id": 161
    },
    {
        "id": 424,
        "code": "14007",
        "name": "Ain Deheb",
        "name_ar": "عين الذهب",
        "daira_id": 162
    },
    {
        "id": 425,
        "code": "14046",
        "name": "Chehaima",
        "name_ar": "شحيمة",
        "daira_id": 162
    },
    {
        "id": 426,
        "code": "14060",
        "name": "Naima",
        "name_ar": "النعيمة",
        "daira_id": 162
    },
    {
        "id": 427,
        "code": "14009",
        "name": "Ain Kermes",
        "name_ar": "عين كرمس",
        "daira_id": 163
    },
    {
        "id": 428,
        "code": "14013",
        "name": "Medrissa",
        "name_ar": "مدريسة",
        "daira_id": 163
    },
    {
        "id": 429,
        "code": "14055",
        "name": "Madna",
        "name_ar": "مادنة",
        "daira_id": 163
    },
    {
        "id": 430,
        "code": "14061",
        "name": "Djebilet Rosfa",
        "name_ar": "جبيلات الرصفاء",
        "daira_id": 163
    },
    {
        "id": 431,
        "code": "14010",
        "name": "Dahmouni",
        "name_ar": "دحموني",
        "daira_id": 164
    },
    {
        "id": 432,
        "code": "14040",
        "name": "Ain Bouchekif",
        "name_ar": "عين بوشقيف",
        "daira_id": 164
    },
    {
        "id": 433,
        "code": "14012",
        "name": "Mechraa Safa",
        "name_ar": "مشرع الصفا",
        "daira_id": 165
    },
    {
        "id": 434,
        "code": "14016",
        "name": "Djillali Ben Amar",
        "name_ar": "جيلالي بن عمار",
        "daira_id": 165
    },
    {
        "id": 435,
        "code": "14068",
        "name": "Tagdempt",
        "name_ar": "تاقدمت",
        "daira_id": 165
    },
    {
        "id": 436,
        "code": "14014",
        "name": "Oued Lilli",
        "name_ar": "وادي ليلي",
        "daira_id": 166
    },
    {
        "id": 437,
        "code": "14064",
        "name": "Sidi Ali Mellal",
        "name_ar": "سيدي علي ملال",
        "daira_id": 166
    },
    {
        "id": 438,
        "code": "14071",
        "name": "Tidda",
        "name_ar": "تيدة",
        "daira_id": 166
    },
    {
        "id": 439,
        "code": "14020",
        "name": "Hamadia",
        "name_ar": "حمادية",
        "daira_id": 167
    },
    {
        "id": 440,
        "code": "14026",
        "name": "Rechaiga",
        "name_ar": "الرشايقة",
        "daira_id": 167
    },
    {
        "id": 441,
        "code": "14023",
        "name": "Medroussa",
        "name_ar": "مدروسة",
        "daira_id": 168
    },
    {
        "id": 442,
        "code": "14025",
        "name": "Mellakou",
        "name_ar": "ملاكو",
        "daira_id": 168
    },
    {
        "id": 443,
        "code": "14065",
        "name": "Sidi Bakhti",
        "name_ar": "سيدي بختي",
        "daira_id": 168
    },
    {
        "id": 444,
        "code": "14024",
        "name": "Meghila",
        "name_ar": "مغيلة",
        "daira_id": 169
    },
    {
        "id": 445,
        "code": "14029",
        "name": "Sidi Hosni",
        "name_ar": "سيدي حسني",
        "daira_id": 169
    },
    {
        "id": 446,
        "code": "15000",
        "name": "Tizi-Ouzou",
        "name_ar": "تيزي وزو",
        "daira_id": 170
    },
    {
        "id": 447,
        "code": "15001",
        "name": "Azazga",
        "name_ar": "عزازقة",
        "daira_id": 171
    },
    {
        "id": 448,
        "code": "15012",
        "name": "Freha",
        "name_ar": "فريحة",
        "daira_id": 171
    },
    {
        "id": 449,
        "code": "15034",
        "name": "Ifigha",
        "name_ar": "إيفيغاء",
        "daira_id": 171
    },
    {
        "id": 450,
        "code": "15051",
        "name": "Yakourene",
        "name_ar": "إعــكورن",
        "daira_id": 171
    },
    {
        "id": 451,
        "code": "15076",
        "name": "Zekri",
        "name_ar": "زكري",
        "daira_id": 171
    },
    {
        "id": 452,
        "code": "15002",
        "name": "Ain-El-Hammam",
        "name_ar": "عين الحمام",
        "daira_id": 172
    },
    {
        "id": 453,
        "code": "15072",
        "name": "Ait-Yahia",
        "name_ar": "أيت يحيى",
        "daira_id": 172
    },
    {
        "id": 454,
        "code": "15092",
        "name": "Akbil",
        "name_ar": "اقبيل",
        "daira_id": 172
    },
    {
        "id": 455,
        "code": "15003",
        "name": "Boghni",
        "name_ar": "بوغني",
        "daira_id": 173
    },
    {
        "id": 456,
        "code": "15025",
        "name": "Assi-Youcef",
        "name_ar": "أسي يوسف",
        "daira_id": 173
    },
    {
        "id": 457,
        "code": "15031",
        "name": "Bounouh",
        "name_ar": "بونوح",
        "daira_id": 173
    },
    {
        "id": 458,
        "code": "15041",
        "name": "Mechtras",
        "name_ar": "مشطراس",
        "daira_id": 173
    },
    {
        "id": 459,
        "code": "15004",
        "name": "Draa-Ben-Khedda",
        "name_ar": "ذراع بن خدة",
        "daira_id": 174
    },
    {
        "id": 460,
        "code": "15018",
        "name": "Tadmait",
        "name_ar": "تادمايت",
        "daira_id": 174
    },
    {
        "id": 461,
        "code": "15042",
        "name": "Sidi Namane",
        "name_ar": "سيدي نعمان",
        "daira_id": 174
    },
    {
        "id": 462,
        "code": "15048",
        "name": "Tirmitine",
        "name_ar": "تيرمتين",
        "daira_id": 174
    },
    {
        "id": 463,
        "code": "15005",
        "name": "Draa-El-Mizan",
        "name_ar": "ذراع الميزان",
        "daira_id": 175
    },
    {
        "id": 464,
        "code": "15026",
        "name": "Ait Yahia Moussa",
        "name_ar": "أيت يحي موسى",
        "daira_id": 175
    },
    {
        "id": 465,
        "code": "15055",
        "name": "Ain-Zaouia",
        "name_ar": "عين الزاوية",
        "daira_id": 175
    },
    {
        "id": 466,
        "code": "15067",
        "name": "Frikat",
        "name_ar": "فريقات",
        "daira_id": 175
    },
    {
        "id": 467,
        "code": "15006",
        "name": "Larbaa Nath Irathen",
        "name_ar": "الأربعــاء ناث إيراثن",
        "daira_id": 176
    },
    {
        "id": 468,
        "code": "15038",
        "name": "Irdjen",
        "name_ar": "إيرجـــن",
        "daira_id": 176
    },
    {
        "id": 469,
        "code": "15058",
        "name": "Ait Aggouacha",
        "name_ar": "أيت عقـواشة",
        "daira_id": 176
    },
    {
        "id": 470,
        "code": "15009",
        "name": "Bouzeguene",
        "name_ar": "بوزقــن",
        "daira_id": 177
    },
    {
        "id": 471,
        "code": "15035",
        "name": "Idjeur",
        "name_ar": "إيجــار",
        "daira_id": 177
    },
    {
        "id": 472,
        "code": "15037",
        "name": "Illoula Oumalou",
        "name_ar": "إيلولة أومـــالو",
        "daira_id": 177
    },
    {
        "id": 473,
        "code": "15118",
        "name": "Beni-Zikki",
        "name_ar": "بني زيكــي",
        "daira_id": 177
    },
    {
        "id": 474,
        "code": "15010",
        "name": "Azeffoun",
        "name_ar": "أزفون",
        "daira_id": 178
    },
    {
        "id": 475,
        "code": "15021",
        "name": "Aghribs",
        "name_ar": "أغريب",
        "daira_id": 178
    },
    {
        "id": 476,
        "code": "15027",
        "name": "Akerrou",
        "name_ar": "أقرو",
        "daira_id": 178
    },
    {
        "id": 477,
        "code": "15059",
        "name": "Ait-Chafaa",
        "name_ar": "أيت شافع",
        "daira_id": 178
    },
    {
        "id": 478,
        "code": "15011",
        "name": "Beni-Douala",
        "name_ar": "بني دوالة",
        "daira_id": 179
    },
    {
        "id": 479,
        "code": "15028",
        "name": "Beni Zmenzer",
        "name_ar": "بنــــي زمنزار",
        "daira_id": 179
    },
    {
        "id": 480,
        "code": "15044",
        "name": "Ait-Mahmoud",
        "name_ar": "أيت محمود",
        "daira_id": 179
    },
    {
        "id": 481,
        "code": "15069",
        "name": "Beni-Aissi",
        "name_ar": "بني عيسي",
        "daira_id": 179
    },
    {
        "id": 482,
        "code": "15013",
        "name": "Iferhounene",
        "name_ar": "إفــرحــونان",
        "daira_id": 180
    },
    {
        "id": 483,
        "code": "15023",
        "name": "Imsouhal",
        "name_ar": "إمســوحال",
        "daira_id": 180
    },
    {
        "id": 484,
        "code": "15036",
        "name": "Illilten",
        "name_ar": "إيلـيــلتـن",
        "daira_id": 180
    },
    {
        "id": 485,
        "code": "15014",
        "name": "Mekla",
        "name_ar": "مقــلع",
        "daira_id": 181
    },
    {
        "id": 486,
        "code": "15043",
        "name": "Souama",
        "name_ar": "صوامـــع",
        "daira_id": 181
    },
    {
        "id": 487,
        "code": "15079",
        "name": "Ait Khellili",
        "name_ar": "أيت خليلي",
        "daira_id": 181
    },
    {
        "id": 488,
        "code": "15015",
        "name": "Ouacif",
        "name_ar": "واسيف",
        "daira_id": 182
    },
    {
        "id": 489,
        "code": "15062",
        "name": "Ait-Toudert",
        "name_ar": "أيت تودرت",
        "daira_id": 182
    },
    {
        "id": 490,
        "code": "15084",
        "name": "Ait Boumahdi",
        "name_ar": "أيت بومهدي",
        "daira_id": 182
    },
    {
        "id": 491,
        "code": "15016",
        "name": "Ouadhias",
        "name_ar": "واضية",
        "daira_id": 183
    },
    {
        "id": 492,
        "code": "15022",
        "name": "Agouni-Gueghrane",
        "name_ar": "أقني قغران",
        "daira_id": 183
    },
    {
        "id": 493,
        "code": "15024",
        "name": "Ait Bouaddou",
        "name_ar": "أيت بــوادو",
        "daira_id": 183
    },
    {
        "id": 494,
        "code": "15049",
        "name": "Tizi N'tleta",
        "name_ar": "تيزي نثلاثة",
        "daira_id": 183
    },
    {
        "id": 495,
        "code": "15017",
        "name": "Maatkas",
        "name_ar": "معـــاتقة",
        "daira_id": 184
    },
    {
        "id": 496,
        "code": "15123",
        "name": "Souk-El-Tenine",
        "name_ar": "سوق الإثنين",
        "daira_id": 184
    },
    {
        "id": 497,
        "code": "15019",
        "name": "Tigzirt",
        "name_ar": "تيقـزيرت",
        "daira_id": 185
    },
    {
        "id": 498,
        "code": "15061",
        "name": "Mizrana",
        "name_ar": "ميزرانـــة",
        "daira_id": 185
    },
    {
        "id": 499,
        "code": "15068",
        "name": "Iflissen",
        "name_ar": "إفليـــسن",
        "daira_id": 185
    },
    {
        "id": 500,
        "code": "15020",
        "name": "Tizi-Gheniff",
        "name_ar": "تيزي غنيف",
        "daira_id": 186
    },
    {
        "id": 501,
        "code": "15046",
        "name": "M'kira",
        "name_ar": "مكيرة",
        "daira_id": 186
    },
    {
        "id": 502,
        "code": "15029",
        "name": "Beni-Yenni",
        "name_ar": "بني يني",
        "daira_id": 187
    },
    {
        "id": 503,
        "code": "15052",
        "name": "Yatafene",
        "name_ar": "يطــافن",
        "daira_id": 187
    },
    {
        "id": 504,
        "code": "15073",
        "name": "Iboudrarene",
        "name_ar": "إبودرارن",
        "daira_id": 187
    },
    {
        "id": 505,
        "code": "15030",
        "name": "Boudjima",
        "name_ar": "بوجيمة",
        "daira_id": 188
    },
    {
        "id": 506,
        "code": "15040",
        "name": "Makouda",
        "name_ar": "ماكودة",
        "daira_id": 188
    },
    {
        "id": 507,
        "code": "15032",
        "name": "Ait-Aissa-Mimoun",
        "name_ar": "أيت عيسى ميمون",
        "daira_id": 189
    },
    {
        "id": 508,
        "code": "15039",
        "name": "Timizart",
        "name_ar": "تيمـيزار",
        "daira_id": 189
    },
    {
        "id": 509,
        "code": "15045",
        "name": "Ouaguenoun",
        "name_ar": "واقنون",
        "daira_id": 189
    },
    {
        "id": 510,
        "code": "15050",
        "name": "Tizi-Rached",
        "name_ar": "تيزي راشد",
        "daira_id": 190
    },
    {
        "id": 511,
        "code": "16000",
        "name": "Alger Centre",
        "name_ar": "الجزائر الوسطى",
        "daira_id": 191
    },
    {
        "id": 512,
        "code": "28045",
        "name": "Sidi M'hamed",
        "name_ar": "سيدي امحمد",
        "daira_id": 336
    },
    {
        "id": 513,
        "code": "16015",
        "name": "El Madania",
        "name_ar": "المدنية",
        "daira_id": 191
    },
    {
        "id": 514,
        "code": "16035",
        "name": "El Mouradia",
        "name_ar": "المرادية",
        "daira_id": 191
    },
    {
        "id": 515,
        "code": "16001",
        "name": "Casbah",
        "name_ar": "القصبة",
        "daira_id": 192
    },
    {
        "id": 516,
        "code": "16008",
        "name": "Bab El Oued",
        "name_ar": "باب الوادي",
        "daira_id": 192
    },
    {
        "id": 517,
        "code": "16030",
        "name": "Bologhine Ibnou Ziri",
        "name_ar": "بولوغين بن زيري",
        "daira_id": 192
    },
    {
        "id": 518,
        "code": "16060",
        "name": "Rais Hamidou",
        "name_ar": "الرايس حميدو",
        "daira_id": 192
    },
    {
        "id": 519,
        "code": "16182",
        "name": "Oued Koriche",
        "name_ar": "وادي قريش",
        "daira_id": 192
    },
    {
        "id": 520,
        "code": "16003",
        "name": "El Biar",
        "name_ar": "الابيار",
        "daira_id": 193
    },
    {
        "id": 521,
        "code": "16028",
        "name": "Ben Aknoun",
        "name_ar": "ابن عكنون",
        "daira_id": 193
    },
    {
        "id": 522,
        "code": "16032",
        "name": "Bouzareah",
        "name_ar": "بوزريعة",
        "daira_id": 193
    },
    {
        "id": 523,
        "code": "16044",
        "name": "Beni Messous",
        "name_ar": "بني مسوس",
        "daira_id": 193
    },
    {
        "id": 524,
        "code": "16009",
        "name": "Kouba",
        "name_ar": "القبة",
        "daira_id": 194
    },
    {
        "id": 525,
        "code": "16151",
        "name": "Mohamed Belouzdad",
        "name_ar": "محمد بلوزداد",
        "daira_id": 194
    },
    {
        "id": 526,
        "code": "16005",
        "name": "Hussein Dey",
        "name_ar": "حسين داي",
        "daira_id": 194
    },
    {
        "id": 527,
        "code": "16053",
        "name": "El Magharia",
        "name_ar": "المغارية",
        "daira_id": 194
    },
    {
        "id": 528,
        "code": "16013",
        "name": "Bir Mourad Rais",
        "name_ar": "بئر مراد رايس",
        "daira_id": 195
    },
    {
        "id": 529,
        "code": "16016",
        "name": "Hydra",
        "name_ar": "حيدرة",
        "daira_id": 195
    },
    {
        "id": 530,
        "code": "16029",
        "name": "Birkhadem",
        "name_ar": "بئر خادم",
        "daira_id": 195
    },
    {
        "id": 531,
        "code": "16173",
        "name": "Djasr Kasentina",
        "name_ar": "جسر قسنطينة",
        "daira_id": 195
    },
    {
        "id": 532,
        "code": "16095",
        "name": "Sehaoula",
        "name_ar": "السحاولة",
        "daira_id": 195
    },
    {
        "id": 533,
        "code": "16014",
        "name": "Cheraga",
        "name_ar": "الشراقة",
        "daira_id": 196
    },
    {
        "id": 534,
        "code": "16018",
        "name": "Ain Benian",
        "name_ar": "عين بنيان",
        "daira_id": 196
    },
    {
        "id": 535,
        "code": "16047",
        "name": "Dely Ibrahim",
        "name_ar": "دالي ابراهيم",
        "daira_id": 196
    },
    {
        "id": 536,
        "code": "16094",
        "name": "Ouled Fayet",
        "name_ar": "اولاد فايت",
        "daira_id": 196
    },
    {
        "id": 537,
        "code": "16045",
        "name": "Bir Touta",
        "name_ar": "بئر توتة",
        "daira_id": 197
    },
    {
        "id": 538,
        "code": "16099",
        "name": "Tessala El Merdja",
        "name_ar": "تسالة المرجة",
        "daira_id": 197
    },
    {
        "id": 539,
        "code": "16118",
        "name": "Ouled Chebel",
        "name_ar": "اولاد شبل",
        "daira_id": 197
    },
    {
        "id": 540,
        "code": "16049",
        "name": "Douira",
        "name_ar": "الدويرة",
        "daira_id": 198
    },
    {
        "id": 541,
        "code": "16050",
        "name": "Draria",
        "name_ar": "الدرارية",
        "daira_id": 198
    },
    {
        "id": 542,
        "code": "16081",
        "name": "Baba Hassen",
        "name_ar": "بابا حسن",
        "daira_id": 198
    },
    {
        "id": 543,
        "code": "16091",
        "name": "Khraissia",
        "name_ar": "الخرايسية",
        "daira_id": 198
    },
    {
        "id": 544,
        "code": "16104",
        "name": "El Achour",
        "name_ar": "العاشور",
        "daira_id": 198
    },
    {
        "id": 545,
        "code": "16062",
        "name": "Staoueli",
        "name_ar": "سطاوالي",
        "daira_id": 199
    },
    {
        "id": 546,
        "code": "16063",
        "name": "Zeralda",
        "name_ar": "زرالدة",
        "daira_id": 199
    },
    {
        "id": 547,
        "code": "16093",
        "name": "Maalma",
        "name_ar": "المعالمة",
        "daira_id": 199
    },
    {
        "id": 548,
        "code": "16097",
        "name": "Souidania",
        "name_ar": "سويدانية",
        "daira_id": 199
    },
    {
        "id": 549,
        "code": "16121",
        "name": "Rahmania",
        "name_ar": "الرحمانية",
        "daira_id": 199
    },
    {
        "id": 550,
        "code": "16004",
        "name": "El Harrach",
        "name_ar": "الحراش",
        "daira_id": 200
    },
    {
        "id": 551,
        "code": "16026",
        "name": "Bachedjerah",
        "name_ar": "باش جراح",
        "daira_id": 200
    },
    {
        "id": 552,
        "code": "16054",
        "name": "Bourouba",
        "name_ar": "بوروبة",
        "daira_id": 200
    },
    {
        "id": 553,
        "code": "16059",
        "name": "Oued Smar",
        "name_ar": "وادي السمار",
        "daira_id": 200
    },
    {
        "id": 554,
        "code": "16017",
        "name": "Rouiba",
        "name_ar": "الرويبة",
        "daira_id": 201
    },
    {
        "id": 555,
        "code": "16036",
        "name": "Reghaia",
        "name_ar": "رغاية",
        "daira_id": 201
    },
    {
        "id": 556,
        "code": "16116",
        "name": "Herraoua",
        "name_ar": "هراوة",
        "daira_id": 201
    },
    {
        "id": 557,
        "code": "16019",
        "name": "Ain Taya",
        "name_ar": "عين طاية",
        "daira_id": 202
    },
    {
        "id": 558,
        "code": "16024",
        "name": "Bab Ezzouar",
        "name_ar": "باب الزوار",
        "daira_id": 202
    },
    {
        "id": 559,
        "code": "16031",
        "name": "Bordj El Kiffan",
        "name_ar": "برج الكيفان",
        "daira_id": 202
    },
    {
        "id": 560,
        "code": "16033",
        "name": "Dar El Beida",
        "name_ar": "الدار البيضاء",
        "daira_id": 202
    },
    {
        "id": 561,
        "code": "16046",
        "name": "Bordj El Bahri",
        "name_ar": "برج البحري",
        "daira_id": 202
    },
    {
        "id": 562,
        "code": "29003",
        "name": "Mohammadia",
        "name_ar": "المحمدية",
        "daira_id": 349
    },
    {
        "id": 563,
        "code": "16027",
        "name": "Baraki",
        "name_ar": "براقي",
        "daira_id": 203
    },
    {
        "id": 564,
        "code": "16057",
        "name": "Les Eucalyptus",
        "name_ar": "الكاليتوس",
        "daira_id": 203
    },
    {
        "id": 565,
        "code": "16189",
        "name": "Sidi Moussa",
        "name_ar": "سيدي موسى",
        "daira_id": 203
    },
    {
        "id": 566,
        "code": "17000",
        "name": "Djelfa",
        "name_ar": "الجلفة",
        "daira_id": 204
    },
    {
        "id": 567,
        "code": "17001",
        "name": "Ain Oussera",
        "name_ar": "عين وسارة",
        "daira_id": 205
    },
    {
        "id": 568,
        "code": "17054",
        "name": "Guernini",
        "name_ar": "قرنيني",
        "daira_id": 205
    },
    {
        "id": 569,
        "code": "17002",
        "name": "Hassi Bahbah",
        "name_ar": "حاسي بحبح",
        "daira_id": 206
    },
    {
        "id": 570,
        "code": "17025",
        "name": "Ain Maabed",
        "name_ar": "عين معبد",
        "daira_id": 206
    },
    {
        "id": 571,
        "code": "17032",
        "name": "Hassi El Euch",
        "name_ar": "حاسي العش",
        "daira_id": 206
    },
    {
        "id": 572,
        "code": "17038",
        "name": "Zaafrane",
        "name_ar": "زعفران",
        "daira_id": 206
    },
    {
        "id": 573,
        "code": "17003",
        "name": "Messaad",
        "name_ar": "مسعد",
        "daira_id": 207
    },
    {
        "id": 574,
        "code": "01036",
        "name": "Deldoul",
        "name_ar": "دلدول",
        "daira_id": 524
    },
    {
        "id": 575,
        "code": "17055",
        "name": "Guettara",
        "name_ar": "قطارة",
        "daira_id": 207
    },
    {
        "id": 576,
        "code": "17062",
        "name": "Sed Rahal",
        "name_ar": "سد الرحال",
        "daira_id": 207
    },
    {
        "id": 577,
        "code": "17063",
        "name": "Selmana",
        "name_ar": "سلمانة",
        "daira_id": 207
    },
    {
        "id": 578,
        "code": "17006",
        "name": "Dar Chioukh",
        "name_ar": "دار الشيوخ",
        "daira_id": 208
    },
    {
        "id": 579,
        "code": "17036",
        "name": "M'liliha",
        "name_ar": "مليليحة",
        "daira_id": 208
    },
    {
        "id": 580,
        "code": "17052",
        "name": "Sidi Baizid",
        "name_ar": "سيدي بايزيد",
        "daira_id": 208
    },
    {
        "id": 581,
        "code": "17011",
        "name": "Ain El Ibel",
        "name_ar": "عين الإبل",
        "daira_id": 209
    },
    {
        "id": 582,
        "code": "17037",
        "name": "Taadmit",
        "name_ar": "تعظميت",
        "daira_id": 209
    },
    {
        "id": 583,
        "code": "17058",
        "name": "Moudjebara",
        "name_ar": "مجبارة",
        "daira_id": 209
    },
    {
        "id": 584,
        "code": "17065",
        "name": "Zaccar",
        "name_ar": "زكار",
        "daira_id": 209
    },
    {
        "id": 585,
        "code": "17014",
        "name": "Birine",
        "name_ar": "بيرين",
        "daira_id": 210
    },
    {
        "id": 586,
        "code": "17043",
        "name": "Benhar",
        "name_ar": "بنهار",
        "daira_id": 210
    },
    {
        "id": 587,
        "code": "17015",
        "name": "Charef",
        "name_ar": "الشارف",
        "daira_id": 211
    },
    {
        "id": 588,
        "code": "17019",
        "name": "El Guedid",
        "name_ar": "القديد",
        "daira_id": 211
    },
    {
        "id": 589,
        "code": "17026",
        "name": "Benyagoub",
        "name_ar": "بن يعقوب",
        "daira_id": 211
    },
    {
        "id": 590,
        "code": "17020",
        "name": "El Idrissia",
        "name_ar": "الادريسية",
        "daira_id": 212
    },
    {
        "id": 591,
        "code": "17030",
        "name": "Douis",
        "name_ar": "دويس",
        "daira_id": 212
    },
    {
        "id": 592,
        "code": "17039",
        "name": "Ain Chouhada",
        "name_ar": "عين الشهداء",
        "daira_id": 212
    },
    {
        "id": 593,
        "code": "17021",
        "name": "Faidh El Botma",
        "name_ar": "فيض البطمة",
        "daira_id": 213
    },
    {
        "id": 594,
        "code": "17042",
        "name": "Amourah",
        "name_ar": "عمورة",
        "daira_id": 213
    },
    {
        "id": 595,
        "code": "17061",
        "name": "Oum Laadham",
        "name_ar": "أم العظام",
        "daira_id": 213
    },
    {
        "id": 596,
        "code": "17022",
        "name": "Had Sahary",
        "name_ar": "حد الصحاري",
        "daira_id": 214
    },
    {
        "id": 597,
        "code": "17040",
        "name": "Ain Fekka",
        "name_ar": "عين فقه",
        "daira_id": 214
    },
    {
        "id": 598,
        "code": "17044",
        "name": "Bouira Lahdab",
        "name_ar": "بويرة الأحداب",
        "daira_id": 214
    },
    {
        "id": 599,
        "code": "17024",
        "name": "Sidi Laadjel",
        "name_ar": "سيدي لعجال",
        "daira_id": 215
    },
    {
        "id": 600,
        "code": "17051",
        "name": "El Khemis",
        "name_ar": "الخميس",
        "daira_id": 215
    },
    {
        "id": 601,
        "code": "17056",
        "name": "Hassi Fedoul",
        "name_ar": "حاسي فدول",
        "daira_id": 215
    },
    {
        "id": 602,
        "code": "18000",
        "name": "Jijel",
        "name_ar": "جيجل",
        "daira_id": 216
    },
    {
        "id": 603,
        "code": "18001",
        "name": "El Milia",
        "name_ar": "الميلية",
        "daira_id": 217
    },
    {
        "id": 604,
        "code": "18021",
        "name": "Ouled Yahia Khadrouch",
        "name_ar": "أولاد يحيى خدروش",
        "daira_id": 217
    },
    {
        "id": 605,
        "code": "18002",
        "name": "Taher",
        "name_ar": "الطاهير",
        "daira_id": 218
    },
    {
        "id": 606,
        "code": "18010",
        "name": "Emir Abdelkader",
        "name_ar": "الامير عبد القادر",
        "daira_id": 218
    },
    {
        "id": 607,
        "code": "18027",
        "name": "Chahna",
        "name_ar": "الشحنة",
        "daira_id": 218
    },
    {
        "id": 608,
        "code": "18036",
        "name": "Boussif Ouled Askeur",
        "name_ar": "بوسيف أولاد عسكر",
        "daira_id": 218
    },
    {
        "id": 609,
        "code": "18047",
        "name": "Oudjana",
        "name_ar": "وجانة",
        "daira_id": 218
    },
    {
        "id": 610,
        "code": "18003",
        "name": "Chekfa",
        "name_ar": "الشقفة",
        "daira_id": 219
    },
    {
        "id": 611,
        "code": "18017",
        "name": "Sidi Abdelaziz",
        "name_ar": "سيدي عبد العزيز",
        "daira_id": 219
    },
    {
        "id": 612,
        "code": "18030",
        "name": "El Kennar Nouchfi",
        "name_ar": "القنار نشفي",
        "daira_id": 219
    },
    {
        "id": 613,
        "code": "18041",
        "name": "Bordj T'har",
        "name_ar": "برج الطهر",
        "daira_id": 219
    },
    {
        "id": 614,
        "code": "18004",
        "name": "El Ancer",
        "name_ar": "العنصر",
        "daira_id": 220
    },
    {
        "id": 615,
        "code": "18023",
        "name": "Bouraoui Belhadef",
        "name_ar": "بوراوي بلهادف",
        "daira_id": 220
    },
    {
        "id": 616,
        "code": "18024",
        "name": "Khiri Oued Adjoul",
        "name_ar": "خيري واد عجول",
        "daira_id": 220
    },
    {
        "id": 617,
        "code": "18029",
        "name": "Djemaa Beni Habibi",
        "name_ar": "الجمعة بني حبيبي",
        "daira_id": 220
    },
    {
        "id": 618,
        "code": "18005",
        "name": "El Aouana",
        "name_ar": "العوانة",
        "daira_id": 221
    },
    {
        "id": 619,
        "code": "18049",
        "name": "Selma Benziada",
        "name_ar": "سلمى بن زيادة",
        "daira_id": 221
    },
    {
        "id": 620,
        "code": "18006",
        "name": "Texenna",
        "name_ar": "تاكسنة",
        "daira_id": 222
    },
    {
        "id": 621,
        "code": "18015",
        "name": "Kaous",
        "name_ar": "قاوس",
        "daira_id": 222
    },
    {
        "id": 622,
        "code": "18007",
        "name": "Ziama Mansouriah",
        "name_ar": "زيامة منصورية",
        "daira_id": 223
    },
    {
        "id": 623,
        "code": "18032",
        "name": "Erraguene Souissi",
        "name_ar": "أراقن سويسي",
        "daira_id": 223
    },
    {
        "id": 624,
        "code": "18016",
        "name": "Settara",
        "name_ar": "السطارة",
        "daira_id": 224
    },
    {
        "id": 625,
        "code": "18026",
        "name": "Ghebala",
        "name_ar": "غبالة",
        "daira_id": 224
    },
    {
        "id": 626,
        "code": "18018",
        "name": "Sidi Marouf",
        "name_ar": "سيدي معروف",
        "daira_id": 225
    },
    {
        "id": 627,
        "code": "18046",
        "name": "Ouled Rabah",
        "name_ar": "أولاد رابح",
        "daira_id": 225
    },
    {
        "id": 628,
        "code": "18025",
        "name": "Boudria Beniyadjis",
        "name_ar": "بودريعة بني  ياجيس",
        "daira_id": 226
    },
    {
        "id": 629,
        "code": "18031",
        "name": "Djimla",
        "name_ar": "جيملة",
        "daira_id": 226
    },
    {
        "id": 630,
        "code": "19000",
        "name": "Setif",
        "name_ar": "سطيف",
        "daira_id": 227
    },
    {
        "id": 631,
        "code": "19001",
        "name": "El Eulma",
        "name_ar": "العلمة",
        "daira_id": 228
    },
    {
        "id": 632,
        "code": "19036",
        "name": "Bazer-Sakra",
        "name_ar": "بازر سكرة",
        "daira_id": 228
    },
    {
        "id": 633,
        "code": "19002",
        "name": "Ain Oulmene",
        "name_ar": "عين ولمان",
        "daira_id": 229
    },
    {
        "id": 634,
        "code": "19050",
        "name": "Guellal",
        "name_ar": "قلال",
        "daira_id": 229
    },
    {
        "id": 635,
        "code": "19054",
        "name": "Kasr El Abtal",
        "name_ar": "قصر الابطال",
        "daira_id": 229
    },
    {
        "id": 636,
        "code": "19121",
        "name": "Ouled Si Ahmed",
        "name_ar": "أولاد سي أحمد",
        "daira_id": 229
    },
    {
        "id": 637,
        "code": "19003",
        "name": "Bougaa",
        "name_ar": "بوقاعة",
        "daira_id": 230
    },
    {
        "id": 638,
        "code": "19019",
        "name": "Ain-Roua",
        "name_ar": "عين الروى",
        "daira_id": 230
    },
    {
        "id": 639,
        "code": "19037",
        "name": "Beni Oussine",
        "name_ar": "بني وسين",
        "daira_id": 230
    },
    {
        "id": 640,
        "code": "19007",
        "name": "Ain Azel",
        "name_ar": "عين أزال",
        "daira_id": 231
    },
    {
        "id": 641,
        "code": "19018",
        "name": "Ain Lahdjar",
        "name_ar": "عين الحجر",
        "daira_id": 231
    },
    {
        "id": 642,
        "code": "19021",
        "name": "Beidha Bordj",
        "name_ar": "بيضاء برج",
        "daira_id": 231
    },
    {
        "id": 643,
        "code": "19039",
        "name": "Bir Haddada",
        "name_ar": "بئر حدادة",
        "daira_id": 231
    },
    {
        "id": 644,
        "code": "19008",
        "name": "Ain El Kebira",
        "name_ar": "عين الكبيرة",
        "daira_id": 232
    },
    {
        "id": 645,
        "code": "19041",
        "name": "Dehamcha",
        "name_ar": "الدهامشة",
        "daira_id": 232
    },
    {
        "id": 646,
        "code": "19053",
        "name": "Ouled Addouane",
        "name_ar": "أولاد عدوان",
        "daira_id": 232
    },
    {
        "id": 647,
        "code": "19009",
        "name": "Amoucha",
        "name_ar": "عموشة",
        "daira_id": 233
    },
    {
        "id": 648,
        "code": "19068",
        "name": "Tizi N'bechar",
        "name_ar": "تيزي نبشار",
        "daira_id": 233
    },
    {
        "id": 649,
        "code": "19115",
        "name": "Oued El Bared",
        "name_ar": "واد البارد",
        "daira_id": 233
    },
    {
        "id": 650,
        "code": "19010",
        "name": "Beni-Aziz",
        "name_ar": "بني عزيز",
        "daira_id": 234
    },
    {
        "id": 651,
        "code": "19033",
        "name": "Ain-Sebt",
        "name_ar": "عين السبت",
        "daira_id": 234
    },
    {
        "id": 652,
        "code": "19055",
        "name": "Maaouia",
        "name_ar": "معاوية",
        "daira_id": 234
    },
    {
        "id": 653,
        "code": "19011",
        "name": "Beni Ourtilane",
        "name_ar": "بني ورتيلان",
        "daira_id": 235
    },
    {
        "id": 654,
        "code": "19031",
        "name": "Beni Chebana",
        "name_ar": "بني شبانة",
        "daira_id": 235
    },
    {
        "id": 655,
        "code": "19035",
        "name": "Ain-Legradj",
        "name_ar": "عين لقراج",
        "daira_id": 235
    },
    {
        "id": 656,
        "code": "19038",
        "name": "Beni-Mouhli",
        "name_ar": "بني موحلي",
        "daira_id": 235
    },
    {
        "id": 657,
        "code": "19012",
        "name": "Bouandas",
        "name_ar": "بوعنداس",
        "daira_id": 236
    },
    {
        "id": 658,
        "code": "19052",
        "name": "Bousselam",
        "name_ar": "بوسلام",
        "daira_id": 236
    },
    {
        "id": 659,
        "code": "19076",
        "name": "Ait Naoual Mezada",
        "name_ar": "أيت نوال مزادة",
        "daira_id": 236
    },
    {
        "id": 660,
        "code": "19077",
        "name": "Ait-Tizi",
        "name_ar": "ايت تيزي",
        "daira_id": 236
    },
    {
        "id": 661,
        "code": "19013",
        "name": "Salah Bey",
        "name_ar": "صالح باي",
        "daira_id": 237
    },
    {
        "id": 662,
        "code": "19015",
        "name": "Hamma",
        "name_ar": "الحامة",
        "daira_id": 237
    },
    {
        "id": 663,
        "code": "19030",
        "name": "Ouled Tebben",
        "name_ar": "أولاد تبان",
        "daira_id": 237
    },
    {
        "id": 664,
        "code": "19060",
        "name": "Rosfa",
        "name_ar": "الرصفة",
        "daira_id": 237
    },
    {
        "id": 665,
        "code": "19089",
        "name": "Boutaleb",
        "name_ar": "بوطالب",
        "daira_id": 237
    },
    {
        "id": 666,
        "code": "19016",
        "name": "Ain Abessa",
        "name_ar": "عين عباسة",
        "daira_id": 238
    },
    {
        "id": 667,
        "code": "19017",
        "name": "Ain Arnat",
        "name_ar": "عين أرنات",
        "daira_id": 238
    },
    {
        "id": 668,
        "code": "19047",
        "name": "El Ouricia",
        "name_ar": "أوريسيا",
        "daira_id": 238
    },
    {
        "id": 669,
        "code": "19056",
        "name": "Mezloug",
        "name_ar": "مزلوق",
        "daira_id": 238
    },
    {
        "id": 670,
        "code": "19020",
        "name": "Babor",
        "name_ar": "بابور",
        "daira_id": 239
    },
    {
        "id": 671,
        "code": "19086",
        "name": "Serdj-El-Ghoul",
        "name_ar": "سرج الغول",
        "daira_id": 239
    },
    {
        "id": 672,
        "code": "19022",
        "name": "Bellaa",
        "name_ar": "بلاعة",
        "daira_id": 240
    },
    {
        "id": 673,
        "code": "19024",
        "name": "Bir-El-Arch",
        "name_ar": "بئر العرش",
        "daira_id": 240
    },
    {
        "id": 674,
        "code": "19046",
        "name": "El-Ouldja",
        "name_ar": "الولجة",
        "daira_id": 240
    },
    {
        "id": 675,
        "code": "19125",
        "name": "Tachouda",
        "name_ar": "تاشودة",
        "daira_id": 240
    },
    {
        "id": 676,
        "code": "19023",
        "name": "Beni Fouda",
        "name_ar": "بني فودة",
        "daira_id": 241
    },
    {
        "id": 677,
        "code": "19025",
        "name": "Djemila",
        "name_ar": "جميلة",
        "daira_id": 241
    },
    {
        "id": 678,
        "code": "19026",
        "name": "Guenzet",
        "name_ar": "قنزات",
        "daira_id": 242
    },
    {
        "id": 679,
        "code": "19032",
        "name": "Harbil",
        "name_ar": "حربيل",
        "daira_id": 242
    },
    {
        "id": 680,
        "code": "19027",
        "name": "Guidjel",
        "name_ar": "قجال",
        "daira_id": 243
    },
    {
        "id": 681,
        "code": "19120",
        "name": "Ouled Sabor",
        "name_ar": "أولاد صابر",
        "daira_id": 243
    },
    {
        "id": 682,
        "code": "19028",
        "name": "Maouaklane",
        "name_ar": "ماوكلان",
        "daira_id": 244
    },
    {
        "id": 683,
        "code": "19069",
        "name": "Tala-Ifacene",
        "name_ar": "تالة إيفاسن",
        "daira_id": 244
    },
    {
        "id": 684,
        "code": "19029",
        "name": "Draa-Kebila",
        "name_ar": "ذراع قبيلة",
        "daira_id": 245
    },
    {
        "id": 685,
        "code": "19051",
        "name": "Hammam Guergour",
        "name_ar": "حمام قرقور",
        "daira_id": 245
    },
    {
        "id": 686,
        "code": "19059",
        "name": "Hamam Soukhna",
        "name_ar": "حمام السخنة",
        "daira_id": 246
    },
    {
        "id": 687,
        "code": "19067",
        "name": "Taya",
        "name_ar": "الطاية",
        "daira_id": 246
    },
    {
        "id": 688,
        "code": "19087",
        "name": "Tella",
        "name_ar": "التلة",
        "daira_id": 246
    },
    {
        "id": 689,
        "code": "20000",
        "name": "Saida",
        "name_ar": "سعيدة",
        "daira_id": 247
    },
    {
        "id": 690,
        "code": "20012",
        "name": "Sidi Ahmed",
        "name_ar": "سيدي احمد",
        "daira_id": 248
    },
    {
        "id": 691,
        "code": "20014",
        "name": "Moulay Larbi",
        "name_ar": "مولاي العربي",
        "daira_id": 248
    },
    {
        "id": 692,
        "code": "26036",
        "name": "Ouled Brahim",
        "name_ar": "أولاد إبراهيم",
        "daira_id": 310
    },
    {
        "id": 693,
        "code": "20029",
        "name": "Ain Soltane",
        "name_ar": "عين السلطان",
        "daira_id": 249
    },
    {
        "id": 694,
        "code": "20035",
        "name": "Tircine",
        "name_ar": "تيرسين",
        "daira_id": 249
    },
    {
        "id": 695,
        "code": "20003",
        "name": "El Hassasna",
        "name_ar": "الحساسنة",
        "daira_id": 250
    },
    {
        "id": 696,
        "code": "20009",
        "name": "Ain Sekhouna",
        "name_ar": "عين السخونة",
        "daira_id": 250
    },
    {
        "id": 697,
        "code": "20004",
        "name": "Ouled Khaled",
        "name_ar": "أولاد خالد",
        "daira_id": 251
    },
    {
        "id": 698,
        "code": "20007",
        "name": "Sidi Boubekeur",
        "name_ar": "سيدي بوبكر",
        "daira_id": 251
    },
    {
        "id": 699,
        "code": "23028",
        "name": "Sidi Amar",
        "name_ar": "سيدي عمار",
        "daira_id": 282
    },
    {
        "id": 700,
        "code": "20025",
        "name": "Hounet",
        "name_ar": "هونت",
        "daira_id": 251
    },
    {
        "id": 701,
        "code": "20008",
        "name": "Youb",
        "name_ar": "يوب",
        "daira_id": 252
    },
    {
        "id": 702,
        "code": "20023",
        "name": "Doui Thabet",
        "name_ar": "دوي ثابت",
        "daira_id": 252
    },
    {
        "id": 703,
        "code": "21000",
        "name": "Skikda",
        "name_ar": "سكيكدة",
        "daira_id": 253
    },
    {
        "id": 704,
        "code": "21038",
        "name": "Hammadi Krouma",
        "name_ar": "حمادي كرومة",
        "daira_id": 253
    },
    {
        "id": 705,
        "code": "21042",
        "name": "Filfila",
        "name_ar": "فلفلة",
        "daira_id": 253
    },
    {
        "id": 706,
        "code": "21001",
        "name": "Azzaba",
        "name_ar": "عزابة",
        "daira_id": 254
    },
    {
        "id": 707,
        "code": "21006",
        "name": "Ain Charchar",
        "name_ar": "عين شرشار",
        "daira_id": 254
    },
    {
        "id": 708,
        "code": "21018",
        "name": "Es Sebt",
        "name_ar": "السبت",
        "daira_id": 254
    },
    {
        "id": 709,
        "code": "21037",
        "name": "Djendel Saadi Mohamed",
        "name_ar": "جندل سعدي محمد",
        "daira_id": 254
    },
    {
        "id": 710,
        "code": "21057",
        "name": "El Ghedir",
        "name_ar": "الغدير",
        "daira_id": 254
    },
    {
        "id": 711,
        "code": "21002",
        "name": "Collo",
        "name_ar": "القل",
        "daira_id": 255
    },
    {
        "id": 712,
        "code": "21016",
        "name": "Beni Zid",
        "name_ar": "بني زيد",
        "daira_id": 255
    },
    {
        "id": 713,
        "code": "21030",
        "name": "Cheraia",
        "name_ar": "الشرايع",
        "daira_id": 255
    },
    {
        "id": 714,
        "code": "21003",
        "name": "El Arrouch",
        "name_ar": "الحروش",
        "daira_id": 256
    },
    {
        "id": 715,
        "code": "21017",
        "name": "Emjez Edchich",
        "name_ar": "مجاز الدشيش",
        "daira_id": 256
    },
    {
        "id": 716,
        "code": "21022",
        "name": "Salah Bouchaour",
        "name_ar": "صالح بو الشعور",
        "daira_id": 256
    },
    {
        "id": 717,
        "code": "21043",
        "name": "Ouled Habbaba",
        "name_ar": "أولاد حبابة",
        "daira_id": 256
    },
    {
        "id": 718,
        "code": "21047",
        "name": "Zerdezas",
        "name_ar": "زردازة",
        "daira_id": 256
    },
    {
        "id": 719,
        "code": "21004",
        "name": "Ramdane Djamel",
        "name_ar": "رمضان جمال",
        "daira_id": 257
    },
    {
        "id": 720,
        "code": "21033",
        "name": "Beni Bechir",
        "name_ar": "بني بشير",
        "daira_id": 257
    },
    {
        "id": 721,
        "code": "21005",
        "name": "Tamalous",
        "name_ar": "تمالوس",
        "daira_id": 258
    },
    {
        "id": 722,
        "code": "21019",
        "name": "Kerkara",
        "name_ar": "الكركرة",
        "daira_id": 258
    },
    {
        "id": 723,
        "code": "21052",
        "name": "Bin El Ouiden",
        "name_ar": "بين الويدان",
        "daira_id": 258
    },
    {
        "id": 724,
        "code": "21007",
        "name": "Ain Kechra",
        "name_ar": "عين قشرة",
        "daira_id": 259
    },
    {
        "id": 725,
        "code": "21009",
        "name": "Bekkouche Lakhdar",
        "name_ar": "بكوش لخضر",
        "daira_id": 260
    },
    {
        "id": 726,
        "code": "21010",
        "name": "Ben Azzouz",
        "name_ar": "بن عزوز",
        "daira_id": 260
    },
    {
        "id": 727,
        "code": "21011",
        "name": "Beni Oulbane",
        "name_ar": "بني ولبان",
        "daira_id": 261
    },
    {
        "id": 728,
        "code": "21023",
        "name": "Sidi Mezghiche",
        "name_ar": "سيدي مزغيش",
        "daira_id": 261
    },
    {
        "id": 729,
        "code": "21031",
        "name": "Ain Bouziane",
        "name_ar": "عين بوزيان",
        "daira_id": 261
    },
    {
        "id": 730,
        "code": "21012",
        "name": "Ouled Attia",
        "name_ar": "أولاد عطية",
        "daira_id": 262
    },
    {
        "id": 731,
        "code": "21040",
        "name": "Oued Zhour",
        "name_ar": "وادي الزهور",
        "daira_id": 262
    },
    {
        "id": 732,
        "code": "21059",
        "name": "Khenag Maoune",
        "name_ar": "خناق مايو",
        "daira_id": 262
    },
    {
        "id": 733,
        "code": "21015",
        "name": "El Hadaiek",
        "name_ar": "الحدائق",
        "daira_id": 263
    },
    {
        "id": 734,
        "code": "21051",
        "name": "Ain Zouit",
        "name_ar": "عين زويت",
        "daira_id": 263
    },
    {
        "id": 735,
        "code": "21053",
        "name": "Bouchetata",
        "name_ar": "بوشطاطة",
        "daira_id": 263
    },
    {
        "id": 736,
        "code": "21020",
        "name": "Oum Toub",
        "name_ar": "أم الطوب",
        "daira_id": 264
    },
    {
        "id": 737,
        "code": "36039",
        "name": "Zitouna",
        "name_ar": "الزيتونة",
        "daira_id": 406
    },
    {
        "id": 738,
        "code": "21062",
        "name": "Kanoua",
        "name_ar": "قنواع",
        "daira_id": 265
    },
    {
        "id": 739,
        "code": "22000",
        "name": "Sidi Bel-Abbes",
        "name_ar": "سيدي بلعباس",
        "daira_id": 266
    },
    {
        "id": 740,
        "code": "22001",
        "name": "Sfisef",
        "name_ar": "سفيزف",
        "daira_id": 267
    },
    {
        "id": 741,
        "code": "22034",
        "name": "Ain- Adden",
        "name_ar": "عين أدن",
        "daira_id": 267
    },
    {
        "id": 742,
        "code": "22043",
        "name": "Boudjebaa El Bordj",
        "name_ar": "بوجبهة البرج",
        "daira_id": 267
    },
    {
        "id": 743,
        "code": "22052",
        "name": "M'cid",
        "name_ar": "مسيد",
        "daira_id": 267
    },
    {
        "id": 744,
        "code": "25037",
        "name": "Ben Badis",
        "name_ar": "أبن باديس الهرية",
        "daira_id": 301
    },
    {
        "id": 745,
        "code": "22010",
        "name": "Hassi Zahana",
        "name_ar": "حاسي زهانة",
        "daira_id": 268
    },
    {
        "id": 746,
        "code": "22038",
        "name": "Bedrabine El Mokrani",
        "name_ar": "بضرابين المقراني",
        "daira_id": 268
    },
    {
        "id": 747,
        "code": "22039",
        "name": "Chetouane Belaila",
        "name_ar": "شيطوان البلايلة",
        "daira_id": 268
    },
    {
        "id": 748,
        "code": "22007",
        "name": "Telagh",
        "name_ar": "تلاغ",
        "daira_id": 269
    },
    {
        "id": 749,
        "code": "22009",
        "name": "Dhaya",
        "name_ar": "الضاية",
        "daira_id": 269
    },
    {
        "id": 750,
        "code": "22025",
        "name": "Mezaourou",
        "name_ar": "مزاورو",
        "daira_id": 269
    },
    {
        "id": 751,
        "code": "22066",
        "name": "Teghalimet",
        "name_ar": "تغاليمت",
        "daira_id": 269
    },
    {
        "id": 752,
        "code": "22008",
        "name": "Boukhanefis",
        "name_ar": "بوخنفيس",
        "daira_id": 270
    },
    {
        "id": 753,
        "code": "22028",
        "name": "Sidi Ali Benyoub",
        "name_ar": "سيدي علي بن يوب",
        "daira_id": 270
    },
    {
        "id": 754,
        "code": "22032",
        "name": "Tabia",
        "name_ar": "طابية",
        "daira_id": 270
    },
    {
        "id": 755,
        "code": "22011",
        "name": "Marhoum",
        "name_ar": "مرحوم",
        "daira_id": 271
    },
    {
        "id": 756,
        "code": "22041",
        "name": "Bir El Hammam",
        "name_ar": "بئر الحمام",
        "daira_id": 271
    },
    {
        "id": 757,
        "code": "22061",
        "name": "Sidi Chaib",
        "name_ar": "سيدي شعيب",
        "daira_id": 271
    },
    {
        "id": 758,
        "code": "22012",
        "name": "Merine",
        "name_ar": "مرين",
        "daira_id": 272
    },
    {
        "id": 759,
        "code": "22056",
        "name": "Oued Taourira",
        "name_ar": "وادي تاوريرة",
        "daira_id": 272
    },
    {
        "id": 760,
        "code": "22064",
        "name": "Taoudmout",
        "name_ar": "تاودموت",
        "daira_id": 272
    },
    {
        "id": 761,
        "code": "22065",
        "name": "Tefessour",
        "name_ar": "تفسور",
        "daira_id": 272
    },
    {
        "id": 762,
        "code": "22013",
        "name": "Mostefa  Ben Brahim",
        "name_ar": "مصطفى بن ابراهيم",
        "daira_id": 273
    },
    {
        "id": 763,
        "code": "22023",
        "name": "Belarbi",
        "name_ar": "بلعربي",
        "daira_id": 273
    },
    {
        "id": 764,
        "code": "22044",
        "name": "Tilmouni",
        "name_ar": "تلموني",
        "daira_id": 273
    },
    {
        "id": 765,
        "code": "22068",
        "name": "Zerouala",
        "name_ar": "زروالة",
        "daira_id": 273
    },
    {
        "id": 766,
        "code": "22014",
        "name": "Sidi Ali Boussidi",
        "name_ar": "سيدي علي بوسيدي",
        "daira_id": 274
    },
    {
        "id": 767,
        "code": "22024",
        "name": "Lamtar",
        "name_ar": "لمطار",
        "daira_id": 274
    },
    {
        "id": 768,
        "code": "22035",
        "name": "Ain Kada",
        "name_ar": "عين قادة",
        "daira_id": 274
    },
    {
        "id": 769,
        "code": "22062",
        "name": "Sidi Dahou Zairs",
        "name_ar": "سيدي دحو الزاير",
        "daira_id": 274
    },
    {
        "id": 770,
        "code": "22019",
        "name": "Sidi Hamadouche",
        "name_ar": "سيدي حمادوش",
        "daira_id": 275
    },
    {
        "id": 771,
        "code": "22022",
        "name": "Ain El Berd",
        "name_ar": "عين البرد",
        "daira_id": 275
    },
    {
        "id": 772,
        "code": "22029",
        "name": "Sidi Brahim",
        "name_ar": "سيدي ابراهيم",
        "daira_id": 275
    },
    {
        "id": 773,
        "code": "22051",
        "name": "Makedra",
        "name_ar": "مكدرة",
        "daira_id": 275
    },
    {
        "id": 774,
        "code": "22020",
        "name": "Sidi Lahcene",
        "name_ar": "سيدي لحسن",
        "daira_id": 276
    },
    {
        "id": 775,
        "code": "22063",
        "name": "Sidi Yacoub",
        "name_ar": "سيدي يعقوب",
        "daira_id": 276
    },
    {
        "id": 776,
        "code": "22074",
        "name": "Amarnas",
        "name_ar": "العمارنة",
        "daira_id": 276
    },
    {
        "id": 777,
        "code": "22021",
        "name": "Tenira",
        "name_ar": "تنيرة",
        "daira_id": 277
    },
    {
        "id": 778,
        "code": "22040",
        "name": "Benachiba Chelia",
        "name_ar": "بن عشيبة شلية",
        "daira_id": 277
    },
    {
        "id": 779,
        "code": "22049",
        "name": "Hassi Dahou",
        "name_ar": "حاسي دحو",
        "daira_id": 277
    },
    {
        "id": 780,
        "code": "22055",
        "name": "Oued Sefioun",
        "name_ar": "وادي سفيون",
        "daira_id": 277
    },
    {
        "id": 781,
        "code": "22026",
        "name": "Moulay Slissen",
        "name_ar": "مولاي سليسن",
        "daira_id": 278
    },
    {
        "id": 782,
        "code": "22036",
        "name": "Ain Tindamine",
        "name_ar": "عين تندمين",
        "daira_id": 278
    },
    {
        "id": 783,
        "code": "22047",
        "name": "El Hacaiba",
        "name_ar": "الحصيبة",
        "daira_id": 278
    },
    {
        "id": 784,
        "code": "22033",
        "name": "Tessala",
        "name_ar": "تسالة",
        "daira_id": 279
    },
    {
        "id": 785,
        "code": "22037",
        "name": "Ain Thrid",
        "name_ar": "عين الثريد",
        "daira_id": 279
    },
    {
        "id": 786,
        "code": "22060",
        "name": "Sehala Thaoura",
        "name_ar": "السهالة الثورة",
        "daira_id": 279
    },
    {
        "id": 787,
        "code": "22054",
        "name": "Oued Sebaa",
        "name_ar": "وادي السبع",
        "daira_id": 280
    },
    {
        "id": 788,
        "code": "22058",
        "name": "Redjem Demouche",
        "name_ar": "رجم دموش",
        "daira_id": 280
    },
    {
        "id": 789,
        "code": "22069",
        "name": "Ras El Ma",
        "name_ar": "راس الماء",
        "daira_id": 280
    },
    {
        "id": 790,
        "code": "23000",
        "name": "Annaba",
        "name_ar": "عنابة",
        "daira_id": 281
    },
    {
        "id": 791,
        "code": "23015",
        "name": "Seraidi",
        "name_ar": "سرايدي",
        "daira_id": 281
    },
    {
        "id": 792,
        "code": "23004",
        "name": "El Hadjar",
        "name_ar": "الحجار",
        "daira_id": 282
    },
    {
        "id": 793,
        "code": "23006",
        "name": "Ain El Berda",
        "name_ar": "عين الباردة",
        "daira_id": 283
    },
    {
        "id": 794,
        "code": "23025",
        "name": "Cheurfa",
        "name_ar": "الشرفة",
        "daira_id": 283
    },
    {
        "id": 795,
        "code": "23009",
        "name": "Berrahal",
        "name_ar": "برحال",
        "daira_id": 284
    },
    {
        "id": 796,
        "code": "23021",
        "name": "Oued El Aneb",
        "name_ar": "واد العنب",
        "daira_id": 284
    },
    {
        "id": 797,
        "code": "23010",
        "name": "El Bouni",
        "name_ar": "البوني",
        "daira_id": 285
    },
    {
        "id": 798,
        "code": "23014",
        "name": "Chetaibi",
        "name_ar": "شطايبي",
        "daira_id": 286
    },
    {
        "id": 799,
        "code": "24000",
        "name": "Guelma",
        "name_ar": "قالمة",
        "daira_id": 287
    },
    {
        "id": 800,
        "code": "24034",
        "name": "Bendjarah",
        "name_ar": "بن جراح",
        "daira_id": 287
    },
    {
        "id": 801,
        "code": "24001",
        "name": "Oued Zenati",
        "name_ar": "وادي الزناتي",
        "daira_id": 288
    },
    {
        "id": 802,
        "code": "24014",
        "name": "Ain Regada",
        "name_ar": "عين رقادة",
        "daira_id": 288
    },
    {
        "id": 803,
        "code": "24017",
        "name": "Bordj Sabath",
        "name_ar": "برج صباط",
        "daira_id": 288
    },
    {
        "id": 804,
        "code": "24002",
        "name": "Bouchegouf",
        "name_ar": "بوشقوف",
        "daira_id": 289
    },
    {
        "id": 805,
        "code": "24011",
        "name": "Ain Ben Beida",
        "name_ar": "عين بن بيضاء",
        "daira_id": 289
    },
    {
        "id": 806,
        "code": "24026",
        "name": "Medjez Sfa",
        "name_ar": "مجاز الصفاء",
        "daira_id": 289
    },
    {
        "id": 807,
        "code": "24038",
        "name": "Oued Ferragha",
        "name_ar": "وادي فراغة",
        "daira_id": 289
    },
    {
        "id": 808,
        "code": "24005",
        "name": "Boumahra Ahmed",
        "name_ar": "بومهرة أحمد",
        "daira_id": 290
    },
    {
        "id": 809,
        "code": "24015",
        "name": "Belkheir",
        "name_ar": "بلخير",
        "daira_id": 290
    },
    {
        "id": 810,
        "code": "24020",
        "name": "Guelaat Bou Sbaa",
        "name_ar": "قلعة بوصبع",
        "daira_id": 290
    },
    {
        "id": 811,
        "code": "24027",
        "name": "Nechmaya",
        "name_ar": "نشماية",
        "daira_id": 290
    },
    {
        "id": 812,
        "code": "24039",
        "name": "Djeballah Khemissi",
        "name_ar": "جبالة الخميسي",
        "daira_id": 290
    },
    {
        "id": 813,
        "code": "24007",
        "name": "Hammam Debagh",
        "name_ar": "حمام دباغ",
        "daira_id": 291
    },
    {
        "id": 814,
        "code": "24028",
        "name": "Roknia",
        "name_ar": "الركنية",
        "daira_id": 291
    },
    {
        "id": 815,
        "code": "24008",
        "name": "Heliopolis",
        "name_ar": "هيليوبوليس",
        "daira_id": 292
    },
    {
        "id": 816,
        "code": "24018",
        "name": "Bouati Mahmoud",
        "name_ar": "بوعاتي محمود",
        "daira_id": 292
    },
    {
        "id": 817,
        "code": "24019",
        "name": "El Fedjoudj",
        "name_ar": "الفجوج",
        "daira_id": 292
    },
    {
        "id": 818,
        "code": "24009",
        "name": "Oued Cheham",
        "name_ar": "وادي الشحم",
        "daira_id": 293
    },
    {
        "id": 819,
        "code": "24024",
        "name": "Hammam N'bail",
        "name_ar": "حمام النبايل",
        "daira_id": 293
    },
    {
        "id": 820,
        "code": "24031",
        "name": "Dahouara",
        "name_ar": "الدهوارة",
        "daira_id": 293
    },
    {
        "id": 821,
        "code": "24010",
        "name": "Tamlouka",
        "name_ar": "تاملوكة",
        "daira_id": 294
    },
    {
        "id": 822,
        "code": "24012",
        "name": "Ain Larbi",
        "name_ar": "عين العربي",
        "daira_id": 294
    },
    {
        "id": 823,
        "code": "24013",
        "name": "Ain Makhlouf",
        "name_ar": "عين مخلوف",
        "daira_id": 294
    },
    {
        "id": 824,
        "code": "24025",
        "name": "Houari Boumedienne",
        "name_ar": "هواري بومدين",
        "daira_id": 295
    },
    {
        "id": 825,
        "code": "24029",
        "name": "Sellaoua Announa",
        "name_ar": "سلاوة عنونة",
        "daira_id": 295
    },
    {
        "id": 826,
        "code": "24043",
        "name": "Medjez Amar",
        "name_ar": "مجاز عمار",
        "daira_id": 295
    },
    {
        "id": 827,
        "code": "24049",
        "name": "Ras El Agba",
        "name_ar": "رأس العقبة",
        "daira_id": 295
    },
    {
        "id": 828,
        "code": "24032",
        "name": "Ain Sandel",
        "name_ar": "عين صندل",
        "daira_id": 296
    },
    {
        "id": 829,
        "code": "24037",
        "name": "Bou Hachana",
        "name_ar": "بوحشانة",
        "daira_id": 296
    },
    {
        "id": 830,
        "code": "25000",
        "name": "Constantine",
        "name_ar": "قسنطينة",
        "daira_id": 297
    },
    {
        "id": 831,
        "code": "25005",
        "name": "El Khroub",
        "name_ar": "الخروب",
        "daira_id": 298
    },
    {
        "id": 832,
        "code": "25006",
        "name": "Ain Smara",
        "name_ar": "عين السمارة",
        "daira_id": 298
    },
    {
        "id": 833,
        "code": "25028",
        "name": "Ouled Rahmoun",
        "name_ar": "أولاد رحمون",
        "daira_id": 298
    },
    {
        "id": 834,
        "code": "25013",
        "name": "Hamma Bouziane",
        "name_ar": "حامة بوزيان",
        "daira_id": 299
    },
    {
        "id": 835,
        "code": "25024",
        "name": "Didouche Mourad",
        "name_ar": "ديدوش مراد",
        "daira_id": 299
    },
    {
        "id": 836,
        "code": "25014",
        "name": "Zighoud Youcef",
        "name_ar": "زيغود يوسف",
        "daira_id": 300
    },
    {
        "id": 837,
        "code": "25035",
        "name": "Beni Hamidane",
        "name_ar": "بني حميدان",
        "daira_id": 300
    },
    {
        "id": 838,
        "code": "25015",
        "name": "Ain Abid",
        "name_ar": "عين عبيد",
        "daira_id": 301
    },
    {
        "id": 839,
        "code": "25027",
        "name": "Ibn Ziad",
        "name_ar": "ابن زياد",
        "daira_id": 302
    },
    {
        "id": 840,
        "code": "25032",
        "name": "Messaoud Boudjeriou",
        "name_ar": "بوجريو مسعود",
        "daira_id": 302
    },
    {
        "id": 841,
        "code": "26000",
        "name": "Medea",
        "name_ar": "المدية",
        "daira_id": 303
    },
    {
        "id": 842,
        "code": "26017",
        "name": "Draa Esmar",
        "name_ar": "ذراع السمار",
        "daira_id": 303
    },
    {
        "id": 843,
        "code": "26075",
        "name": "Tamesguida",
        "name_ar": "تمسقيدة",
        "daira_id": 303
    },
    {
        "id": 844,
        "code": "26001",
        "name": "Beni Slimane",
        "name_ar": "بني سليمان",
        "daira_id": 304
    },
    {
        "id": 845,
        "code": "26025",
        "name": "Bouskene",
        "name_ar": "بوسكن",
        "daira_id": 304
    },
    {
        "id": 846,
        "code": "26070",
        "name": "Sidi Rabie",
        "name_ar": "سيدي الربيع",
        "daira_id": 304
    },
    {
        "id": 847,
        "code": "26002",
        "name": "Berrouaghia",
        "name_ar": "البرواقية",
        "daira_id": 305
    },
    {
        "id": 848,
        "code": "26039",
        "name": "Rebaia",
        "name_ar": "الربعية",
        "daira_id": 305
    },
    {
        "id": 849,
        "code": "26044",
        "name": "Ouled Deid",
        "name_ar": "أولاد دايد",
        "daira_id": 305
    },
    {
        "id": 850,
        "code": "26003",
        "name": "Ksar El Boukhari",
        "name_ar": "قصر البخاري",
        "daira_id": 306
    },
    {
        "id": 851,
        "code": "26049",
        "name": "M'fatha",
        "name_ar": "مفاتحة",
        "daira_id": 306
    },
    {
        "id": 852,
        "code": "26067",
        "name": "Saneg",
        "name_ar": "السانق",
        "daira_id": 306
    },
    {
        "id": 853,
        "code": "26004",
        "name": "Tablat",
        "name_ar": "تابلاط",
        "daira_id": 307
    },
    {
        "id": 854,
        "code": "26022",
        "name": "Aissaouia",
        "name_ar": "العيساوية",
        "daira_id": 307
    },
    {
        "id": 855,
        "code": "26058",
        "name": "El Haoudane",
        "name_ar": "الحوضان",
        "daira_id": 307
    },
    {
        "id": 856,
        "code": "26005",
        "name": "Ain Boucif",
        "name_ar": "عين بوسيف",
        "daira_id": 308
    },
    {
        "id": 857,
        "code": "26038",
        "name": "Ouled Emaaraf",
        "name_ar": "أولاد امعرف",
        "daira_id": 308
    },
    {
        "id": 858,
        "code": "26051",
        "name": "Kef Lakhdar",
        "name_ar": "الكاف الاخضر",
        "daira_id": 308
    },
    {
        "id": 859,
        "code": "26069",
        "name": "Sidi Demed",
        "name_ar": "سيدي دامد",
        "daira_id": 308
    },
    {
        "id": 860,
        "code": "26007",
        "name": "Chelalet El Adhaoura",
        "name_ar": "شلالة العذاورة",
        "daira_id": 309
    },
    {
        "id": 861,
        "code": "26048",
        "name": "Ain Ouksir",
        "name_ar": "عين اقصير",
        "daira_id": 309
    },
    {
        "id": 862,
        "code": "26057",
        "name": "Cheniguel",
        "name_ar": "شنيقل",
        "daira_id": 309
    },
    {
        "id": 863,
        "code": "26074",
        "name": "Tafraout",
        "name_ar": "تفراوت",
        "daira_id": 309
    },
    {
        "id": 864,
        "code": "26008",
        "name": "El Omaria",
        "name_ar": "العمارية",
        "daira_id": 310
    },
    {
        "id": 865,
        "code": "26050",
        "name": "Baata",
        "name_ar": "بعطة",
        "daira_id": 310
    },
    {
        "id": 866,
        "code": "26012",
        "name": "Ben Chicao",
        "name_ar": "بن شكاو",
        "daira_id": 311
    },
    {
        "id": 867,
        "code": "26019",
        "name": "Ouzera",
        "name_ar": "وزرة",
        "daira_id": 311
    },
    {
        "id": 868,
        "code": "26060",
        "name": "El Hamdania",
        "name_ar": "الحمدانية",
        "daira_id": 311
    },
    {
        "id": 869,
        "code": "26076",
        "name": "Tizi Mahdi",
        "name_ar": "تيزي مهدي",
        "daira_id": 311
    },
    {
        "id": 870,
        "code": "26013",
        "name": "Boghar",
        "name_ar": "بوغار",
        "daira_id": 312
    },
    {
        "id": 871,
        "code": "26035",
        "name": "Ouled Antar",
        "name_ar": "أولاد عنتر",
        "daira_id": 312
    },
    {
        "id": 872,
        "code": "26037",
        "name": "Ouled Hellal",
        "name_ar": "أولاد هلال",
        "daira_id": 312
    },
    {
        "id": 873,
        "code": "26014",
        "name": "Bouchrahil",
        "name_ar": "بوشراحيل",
        "daira_id": 313
    },
    {
        "id": 874,
        "code": "26062",
        "name": "Khams Djouamaa",
        "name_ar": "خمس جوامع",
        "daira_id": 313
    },
    {
        "id": 875,
        "code": "26071",
        "name": "Sidi Naamane",
        "name_ar": "سيدي نعمان",
        "daira_id": 313
    },
    {
        "id": 876,
        "code": "26015",
        "name": "Derrag",
        "name_ar": "دراق",
        "daira_id": 314
    },
    {
        "id": 877,
        "code": "26040",
        "name": "Aziz",
        "name_ar": "عزيز",
        "daira_id": 314
    },
    {
        "id": 878,
        "code": "26042",
        "name": "Oum El Djellil",
        "name_ar": "أم الجليل",
        "daira_id": 314
    },
    {
        "id": 879,
        "code": "26016",
        "name": "Djouab",
        "name_ar": "جواب",
        "daira_id": 315
    },
    {
        "id": 880,
        "code": "26020",
        "name": "Souagui",
        "name_ar": "السواقي",
        "daira_id": 315
    },
    {
        "id": 881,
        "code": "26072",
        "name": "Sidi Zahar",
        "name_ar": "سيدي زهار",
        "daira_id": 315
    },
    {
        "id": 882,
        "code": "26018",
        "name": "El Azizia",
        "name_ar": "العزيزية",
        "daira_id": 316
    },
    {
        "id": 883,
        "code": "26032",
        "name": "Mihoub",
        "name_ar": "ميهوب",
        "daira_id": 316
    },
    {
        "id": 884,
        "code": "26063",
        "name": "Maghraoua",
        "name_ar": "مغراوة",
        "daira_id": 316
    },
    {
        "id": 885,
        "code": "26021",
        "name": "Zoubiria",
        "name_ar": "الزبيرية",
        "daira_id": 317
    },
    {
        "id": 886,
        "code": "26033",
        "name": "Medjebar",
        "name_ar": "مجبر",
        "daira_id": 317
    },
    {
        "id": 887,
        "code": "26041",
        "name": "Seghouane",
        "name_ar": "سغوان",
        "daira_id": 317
    },
    {
        "id": 888,
        "code": "26046",
        "name": "Tletat Ed Douair",
        "name_ar": "ثلاث دوائر",
        "daira_id": 317
    },
    {
        "id": 889,
        "code": "26023",
        "name": "Boughzoul",
        "name_ar": "بوغزول",
        "daira_id": 318
    },
    {
        "id": 890,
        "code": "26026",
        "name": "Chabounia",
        "name_ar": "الشهبونية",
        "daira_id": 318
    },
    {
        "id": 891,
        "code": "26027",
        "name": "Hannacha",
        "name_ar": "حناشة",
        "daira_id": 319
    },
    {
        "id": 892,
        "code": "26034",
        "name": "Ouamri",
        "name_ar": "عوامري",
        "daira_id": 319
    },
    {
        "id": 893,
        "code": "26061",
        "name": "Oued Harbil",
        "name_ar": "وادي حربيل",
        "daira_id": 319
    },
    {
        "id": 894,
        "code": "26030",
        "name": "El Guelbelkebir",
        "name_ar": "القلب الكبير",
        "daira_id": 320
    },
    {
        "id": 895,
        "code": "26053",
        "name": "Bir Ben Laabed",
        "name_ar": "بئر بن عابد",
        "daira_id": 320
    },
    {
        "id": 896,
        "code": "26068",
        "name": "Sedraya",
        "name_ar": "سدراية",
        "daira_id": 320
    },
    {
        "id": 897,
        "code": "26045",
        "name": "Si Mahdjoub",
        "name_ar": "سي المحجوب",
        "daira_id": 321
    },
    {
        "id": 898,
        "code": "26055",
        "name": "Bouaichoune",
        "name_ar": "بوعيشون",
        "daira_id": 321
    },
    {
        "id": 899,
        "code": "26064",
        "name": "Ouled Bouachra",
        "name_ar": "أولاد بوعشرة",
        "daira_id": 321
    },
    {
        "id": 900,
        "code": "27000",
        "name": "Mostaganem",
        "name_ar": "مستغانم",
        "daira_id": 322
    },
    {
        "id": 901,
        "code": "27001",
        "name": "Ain-Tedles",
        "name_ar": "عين تادلس",
        "daira_id": 323
    },
    {
        "id": 902,
        "code": "27020",
        "name": "Oued El Kheir",
        "name_ar": "وادي الخير",
        "daira_id": 323
    },
    {
        "id": 903,
        "code": "27022",
        "name": "Sour",
        "name_ar": "سور",
        "daira_id": 323
    },
    {
        "id": 904,
        "code": "27029",
        "name": "Sidi Belaattar",
        "name_ar": "سيدي بلعطار",
        "daira_id": 323
    },
    {
        "id": 905,
        "code": "27003",
        "name": "Bouguirat",
        "name_ar": "بوقيراط",
        "daira_id": 324
    },
    {
        "id": 906,
        "code": "27021",
        "name": "Sirat",
        "name_ar": "سيرات",
        "daira_id": 324
    },
    {
        "id": 907,
        "code": "27046",
        "name": "Souaflia",
        "name_ar": "السوافلية",
        "daira_id": 324
    },
    {
        "id": 908,
        "code": "27004",
        "name": "Hassi Mameche",
        "name_ar": "حاسي ماماش",
        "daira_id": 325
    },
    {
        "id": 909,
        "code": "27017",
        "name": "Mazagran",
        "name_ar": "مزغران",
        "daira_id": 325
    },
    {
        "id": 910,
        "code": "27023",
        "name": "Stidia",
        "name_ar": "ستيدية",
        "daira_id": 325
    },
    {
        "id": 911,
        "code": "27005",
        "name": "Khadra",
        "name_ar": "خضرة",
        "daira_id": 326
    },
    {
        "id": 912,
        "code": "27009",
        "name": "Achaacha",
        "name_ar": "عشعاشة",
        "daira_id": 326
    },
    {
        "id": 913,
        "code": "27026",
        "name": "Nekmaria",
        "name_ar": "نكمارية",
        "daira_id": 326
    },
    {
        "id": 914,
        "code": "27027",
        "name": "Ouled Boughalem",
        "name_ar": "أولاد بوغالم",
        "daira_id": 326
    },
    {
        "id": 915,
        "code": "27007",
        "name": "Sidi-Lakhdar",
        "name_ar": "سيدي لخضر",
        "daira_id": 327
    },
    {
        "id": 916,
        "code": "27008",
        "name": "Benabdelmalek Ramdane",
        "name_ar": "بن عبد المالك رمضان",
        "daira_id": 327
    },
    {
        "id": 917,
        "code": "27015",
        "name": "Hadjadj",
        "name_ar": "حجاج",
        "daira_id": 327
    },
    {
        "id": 918,
        "code": "27010",
        "name": "Ain-Nouissy",
        "name_ar": "عين نويسي",
        "daira_id": 328
    },
    {
        "id": 919,
        "code": "27014",
        "name": "Fornaka",
        "name_ar": "فرناقة",
        "daira_id": 328
    },
    {
        "id": 920,
        "code": "27033",
        "name": "Hassiane",
        "name_ar": "الحسيان (بني ياحي",
        "daira_id": 328
    },
    {
        "id": 921,
        "code": "27013",
        "name": "Touahria",
        "name_ar": "الطواهرية",
        "daira_id": 329
    },
    {
        "id": 922,
        "code": "27018",
        "name": "Mesra",
        "name_ar": "ماسرة",
        "daira_id": 329
    },
    {
        "id": 923,
        "code": "27024",
        "name": "Ain-Sidi Cherif",
        "name_ar": "عين سيدي الشريف",
        "daira_id": 329
    },
    {
        "id": 924,
        "code": "27016",
        "name": "Kheir-Eddine",
        "name_ar": "خير الدين",
        "daira_id": 330
    },
    {
        "id": 925,
        "code": "27031",
        "name": "Ain-Boudinar",
        "name_ar": "عين بودينار",
        "daira_id": 330
    },
    {
        "id": 926,
        "code": "27045",
        "name": "Sayada",
        "name_ar": "صيادة",
        "daira_id": 330
    },
    {
        "id": 927,
        "code": "27028",
        "name": "Ouled-Maalah",
        "name_ar": "أولاد مع الله",
        "daira_id": 331
    },
    {
        "id": 928,
        "code": "27032",
        "name": "Sidi Ali",
        "name_ar": "سيدي علي",
        "daira_id": 331
    },
    {
        "id": 929,
        "code": "27047",
        "name": "Tazgait",
        "name_ar": "تزقايت",
        "daira_id": 331
    },
    {
        "id": 930,
        "code": "28000",
        "name": "M'sila",
        "name_ar": "المسيلة",
        "daira_id": 332
    },
    {
        "id": 931,
        "code": "28001",
        "name": "Bou Saada",
        "name_ar": "بوسعادة",
        "daira_id": 333
    },
    {
        "id": 932,
        "code": "28015",
        "name": "El Hamel",
        "name_ar": "الهامل",
        "daira_id": 333
    },
    {
        "id": 933,
        "code": "28054",
        "name": "Oulteme",
        "name_ar": "ولتام",
        "daira_id": 333
    },
    {
        "id": 934,
        "code": "28002",
        "name": "Sidi Aissa",
        "name_ar": "سيدي عيسى",
        "daira_id": 334
    },
    {
        "id": 935,
        "code": "28027",
        "name": "Beni Ilmane",
        "name_ar": "بني يلمان",
        "daira_id": 334
    },
    {
        "id": 936,
        "code": "28042",
        "name": "Bouti Sayeh",
        "name_ar": "بوطي السايح",
        "daira_id": 334
    },
    {
        "id": 937,
        "code": "28003",
        "name": "Ain El Hadjel",
        "name_ar": "عين الحجل",
        "daira_id": 335
    },
    {
        "id": 938,
        "code": "28036",
        "name": "Sidi Hadjeres",
        "name_ar": "سيدي هجرس",
        "daira_id": 335
    },
    {
        "id": 939,
        "code": "28004",
        "name": "Ain El Melh",
        "name_ar": "عين الملح",
        "daira_id": 336
    },
    {
        "id": 940,
        "code": "28023",
        "name": "Ain Fares",
        "name_ar": "عين فارس",
        "daira_id": 336
    },
    {
        "id": 941,
        "code": "28025",
        "name": "Ain Rich",
        "name_ar": "عين الريش",
        "daira_id": 336
    },
    {
        "id": 942,
        "code": "28043",
        "name": "Bir Foda",
        "name_ar": "بئر فضة",
        "daira_id": 336
    },
    {
        "id": 943,
        "code": "28005",
        "name": "Hammam Dalaa",
        "name_ar": "حمام الضلعة",
        "daira_id": 337
    },
    {
        "id": 944,
        "code": "28017",
        "name": "Ouanougha",
        "name_ar": "ونوغة",
        "daira_id": 337
    },
    {
        "id": 945,
        "code": "28038",
        "name": "Tarmount",
        "name_ar": "تارمونت",
        "daira_id": 337
    },
    {
        "id": 946,
        "code": "28060",
        "name": "Ouled Mansour",
        "name_ar": "أولاد منصور",
        "daira_id": 337
    },
    {
        "id": 947,
        "code": "28006",
        "name": "Magra",
        "name_ar": "مقرة",
        "daira_id": 338
    },
    {
        "id": 948,
        "code": "28008",
        "name": "Ain Khadra",
        "name_ar": "عين الخضراء",
        "daira_id": 338
    },
    {
        "id": 949,
        "code": "28010",
        "name": "Berhoum",
        "name_ar": "برهوم",
        "daira_id": 338
    },
    {
        "id": 950,
        "code": "28026",
        "name": "Belaiba",
        "name_ar": "بلعايبة",
        "daira_id": 338
    },
    {
        "id": 951,
        "code": "28048",
        "name": "Dehahna",
        "name_ar": "دهاهنة",
        "daira_id": 338
    },
    {
        "id": 952,
        "code": "28009",
        "name": "Ben Srour",
        "name_ar": "بن سرور",
        "daira_id": 339
    },
    {
        "id": 953,
        "code": "28031",
        "name": "Ouled Slimane",
        "name_ar": "أولاد سليمان",
        "daira_id": 339
    },
    {
        "id": 954,
        "code": "28033",
        "name": "Mohamed Boudiaf",
        "name_ar": "محمد بوضياف",
        "daira_id": 339
    },
    {
        "id": 955,
        "code": "28067",
        "name": "Zarzour",
        "name_ar": "زرزور",
        "daira_id": 339
    },
    {
        "id": 956,
        "code": "28011",
        "name": "Maadid",
        "name_ar": "المعاضيد",
        "daira_id": 340
    },
    {
        "id": 957,
        "code": "28021",
        "name": "Ouled Addi Guebala",
        "name_ar": "أولاد عدي لقبالة",
        "daira_id": 340
    },
    {
        "id": 958,
        "code": "28022",
        "name": "Ouled Derradj",
        "name_ar": "أولاد دراج",
        "daira_id": 340
    },
    {
        "id": 959,
        "code": "28064",
        "name": "Souamaa",
        "name_ar": "السوامع",
        "daira_id": 340
    },
    {
        "id": 960,
        "code": "28014",
        "name": "Chellal",
        "name_ar": "شلال",
        "daira_id": 341
    },
    {
        "id": 961,
        "code": "28041",
        "name": "Maarif",
        "name_ar": "معاريف",
        "daira_id": 341
    },
    {
        "id": 962,
        "code": "28047",
        "name": "Ouled Madhi",
        "name_ar": "أولاد ماضي",
        "daira_id": 341
    },
    {
        "id": 963,
        "code": "28056",
        "name": "Khettouti Sed-El-Jir",
        "name_ar": "خطوطي سد الجير",
        "daira_id": 341
    },
    {
        "id": 964,
        "code": "28016",
        "name": "Medjedel",
        "name_ar": "امجدل",
        "daira_id": 342
    },
    {
        "id": 965,
        "code": "28024",
        "name": "Djebel Messaad",
        "name_ar": "جبل مساعد",
        "daira_id": 343
    },
    {
        "id": 966,
        "code": "28037",
        "name": "Slim",
        "name_ar": "سليم",
        "daira_id": 343
    },
    {
        "id": 967,
        "code": "28028",
        "name": "Benzouh",
        "name_ar": "بن زوه",
        "daira_id": 344
    },
    {
        "id": 968,
        "code": "28032",
        "name": "Ouled Sidi Brahim",
        "name_ar": "أولاد سيدي ابراهيم",
        "daira_id": 344
    },
    {
        "id": 969,
        "code": "28029",
        "name": "M'cif",
        "name_ar": "مسيف",
        "daira_id": 345
    },
    {
        "id": 970,
        "code": "28030",
        "name": "Khoubana",
        "name_ar": "خبانة",
        "daira_id": 345
    },
    {
        "id": 971,
        "code": "28065",
        "name": "Tamsa",
        "name_ar": "تامسة",
        "daira_id": 346
    },
    {
        "id": 972,
        "code": "29000",
        "name": "Mascara",
        "name_ar": "معسكر",
        "daira_id": 347
    },
    {
        "id": 973,
        "code": "29001",
        "name": "Sig",
        "name_ar": "سيق",
        "daira_id": 348
    },
    {
        "id": 974,
        "code": "29022",
        "name": "Bou Henni",
        "name_ar": "بوهني",
        "daira_id": 348
    },
    {
        "id": 975,
        "code": "29023",
        "name": "El Ghomri",
        "name_ar": "الغمري",
        "daira_id": 349
    },
    {
        "id": 976,
        "code": "29027",
        "name": "Mocta-Douz",
        "name_ar": "مقطع الدوز",
        "daira_id": 349
    },
    {
        "id": 977,
        "code": "29046",
        "name": "Ferraguig",
        "name_ar": "فراقيق",
        "daira_id": 349
    },
    {
        "id": 978,
        "code": "29054",
        "name": "Sidi Abdelmoumene",
        "name_ar": "سيدي عبد المومن",
        "daira_id": 349
    },
    {
        "id": 979,
        "code": "29062",
        "name": "Sedjerara",
        "name_ar": "سجرارة",
        "daira_id": 349
    },
    {
        "id": 980,
        "code": "29004",
        "name": "Tighennif",
        "name_ar": "تيغنيف",
        "daira_id": 350
    },
    {
        "id": 981,
        "code": "29030",
        "name": "Sidi Kada",
        "name_ar": "سيدي قادة",
        "daira_id": 350
    },
    {
        "id": 982,
        "code": "29063",
        "name": "Sehailia",
        "name_ar": "السهايلية",
        "daira_id": 350
    },
    {
        "id": 983,
        "code": "29005",
        "name": "Bouhanifia",
        "name_ar": "بوحنيفية",
        "daira_id": 351
    },
    {
        "id": 984,
        "code": "29014",
        "name": "Hacine",
        "name_ar": "حسين",
        "daira_id": 351
    },
    {
        "id": 985,
        "code": "29042",
        "name": "El Gueitena",
        "name_ar": "القطنة",
        "daira_id": 351
    },
    {
        "id": 986,
        "code": "29006",
        "name": "Ghriss",
        "name_ar": "غريس",
        "daira_id": 352
    },
    {
        "id": 987,
        "code": "29015",
        "name": "Maoussa",
        "name_ar": "ماوسة",
        "daira_id": 352
    },
    {
        "id": 988,
        "code": "29026",
        "name": "Matemore",
        "name_ar": "المطمور",
        "daira_id": 352
    },
    {
        "id": 989,
        "code": "29055",
        "name": "Makhda",
        "name_ar": "ماقضة",
        "daira_id": 352
    },
    {
        "id": 990,
        "code": "29069",
        "name": "Sidi Boussaid",
        "name_ar": "سيدي بوسعيد",
        "daira_id": 352
    },
    {
        "id": 991,
        "code": "29011",
        "name": "Ain Fekan",
        "name_ar": "عين فكان",
        "daira_id": 353
    },
    {
        "id": 992,
        "code": "29034",
        "name": "Ain Frass",
        "name_ar": "عين أفرص",
        "daira_id": 353
    },
    {
        "id": 993,
        "code": "29012",
        "name": "El Bordj",
        "name_ar": "البرج",
        "daira_id": 354
    },
    {
        "id": 994,
        "code": "29025",
        "name": "Khalouia",
        "name_ar": "خلوية",
        "daira_id": 354
    },
    {
        "id": 995,
        "code": "29044",
        "name": "El Menaouer",
        "name_ar": "المنور",
        "daira_id": 354
    },
    {
        "id": 996,
        "code": "29013",
        "name": "El Hachem",
        "name_ar": "الحشم",
        "daira_id": 355
    },
    {
        "id": 997,
        "code": "29057",
        "name": "Zelamta",
        "name_ar": "زلامطة",
        "daira_id": 355
    },
    {
        "id": 998,
        "code": "29058",
        "name": "Nesmot",
        "name_ar": "نسمط",
        "daira_id": 355
    },
    {
        "id": 999,
        "code": "29016",
        "name": "Oued El Abtal",
        "name_ar": "وادي الأبطال",
        "daira_id": 356
    },
    {
        "id": 1000,
        "code": "29032",
        "name": "Ain Ferah",
        "name_ar": "عين فراح",
        "daira_id": 356
    },
    {
        "id": 1001,
        "code": "29065",
        "name": "Sidi Abdeldjebar",
        "name_ar": "سيدي عبد الجبار",
        "daira_id": 356
    },
    {
        "id": 1002,
        "code": "29017",
        "name": "Oued Taria",
        "name_ar": "وادي التاغية",
        "daira_id": 357
    },
    {
        "id": 1003,
        "code": "29050",
        "name": "Guerdjoum",
        "name_ar": "قرجوم",
        "daira_id": 357
    },
    {
        "id": 1004,
        "code": "29019",
        "name": "Zahana",
        "name_ar": "زهانة",
        "daira_id": 358
    },
    {
        "id": 1005,
        "code": "29041",
        "name": "El Gaada",
        "name_ar": "القعدة",
        "daira_id": 358
    },
    {
        "id": 1006,
        "code": "29021",
        "name": "Aouf",
        "name_ar": "عوف",
        "daira_id": 359
    },
    {
        "id": 1007,
        "code": "29038",
        "name": "Benian",
        "name_ar": "بنيان",
        "daira_id": 359
    },
    {
        "id": 1008,
        "code": "29047",
        "name": "Gharrous",
        "name_ar": "غروس",
        "daira_id": 359
    },
    {
        "id": 1009,
        "code": "29024",
        "name": "Froha",
        "name_ar": "فروحة",
        "daira_id": 360
    },
    {
        "id": 1010,
        "code": "29043",
        "name": "El Keurt",
        "name_ar": "القرط",
        "daira_id": 360
    },
    {
        "id": 1011,
        "code": "29029",
        "name": "Oggaz",
        "name_ar": "عقاز",
        "daira_id": 361
    },
    {
        "id": 1012,
        "code": "29036",
        "name": "Alaimia",
        "name_ar": "العلايمية",
        "daira_id": 361
    },
    {
        "id": 1013,
        "code": "29060",
        "name": "Ras El Ain Amirouche",
        "name_ar": "رأس عين عميروش",
        "daira_id": 361
    },
    {
        "id": 1014,
        "code": "29056",
        "name": "El Mamounia",
        "name_ar": "المأمونية",
        "daira_id": 362
    },
    {
        "id": 1015,
        "code": "30000",
        "name": "Ouargla",
        "name_ar": "ورقلة",
        "daira_id": 363
    },
    {
        "id": 1016,
        "code": "30013",
        "name": "Rouissat",
        "name_ar": "الرويسات",
        "daira_id": 363
    },
    {
        "id": 1017,
        "code": "30001",
        "name": "Hassi Messaoud",
        "name_ar": "حاسي مسعود",
        "daira_id": 364
    },
    {
        "id": 1018,
        "code": "30025",
        "name": "El Borma",
        "name_ar": "البرمة",
        "daira_id": 365
    },
    {
        "id": 1019,
        "code": "30026",
        "name": "N'goussa",
        "name_ar": "انقوسة",
        "daira_id": 366
    },
    {
        "id": 1020,
        "code": "30035",
        "name": "Sidi Khouiled",
        "name_ar": "سيدي خويلد",
        "daira_id": 367
    },
    {
        "id": 1021,
        "code": "30052",
        "name": "Hassi Ben Abdellah",
        "name_ar": "حاسي بن عبد الله",
        "daira_id": 367
    },
    {
        "id": 1022,
        "code": "31000",
        "name": "Oran",
        "name_ar": "وهران",
        "daira_id": 368
    },
    {
        "id": 1023,
        "code": "31001",
        "name": "Bir El Djir",
        "name_ar": "بئر الجير",
        "daira_id": 369
    },
    {
        "id": 1024,
        "code": "31028",
        "name": "Hassi Bounif",
        "name_ar": "حاسي بونيف",
        "daira_id": 369
    },
    {
        "id": 1025,
        "code": "31049",
        "name": "Hassi Ben Okba",
        "name_ar": "حاسي بن عقبة",
        "daira_id": 369
    },
    {
        "id": 1026,
        "code": "31004",
        "name": "Arzew",
        "name_ar": "أرزيو",
        "daira_id": 370
    },
    {
        "id": 1027,
        "code": "31058",
        "name": "Sidi Ben Yebka",
        "name_ar": "سيدي بن يبقى",
        "daira_id": 370
    },
    {
        "id": 1028,
        "code": "31005",
        "name": "Es Senia",
        "name_ar": "السانية",
        "daira_id": 371
    },
    {
        "id": 1029,
        "code": "31026",
        "name": "El Kerma",
        "name_ar": "الكرمة",
        "daira_id": 371
    },
    {
        "id": 1030,
        "code": "31038",
        "name": "Sidi Chami",
        "name_ar": "سيدي الشحمي",
        "daira_id": 371
    },
    {
        "id": 1031,
        "code": "31019",
        "name": "Mers El Kebir",
        "name_ar": "المرسى الكبير",
        "daira_id": 372
    },
    {
        "id": 1032,
        "code": "31025",
        "name": "Bousfer",
        "name_ar": "بوسفر",
        "daira_id": 372
    },
    {
        "id": 1033,
        "code": "31043",
        "name": "El Ancor",
        "name_ar": "العنصر",
        "daira_id": 372
    },
    {
        "id": 1034,
        "code": "31015",
        "name": "Bethioua",
        "name_ar": "بطيوة",
        "daira_id": 373
    },
    {
        "id": 1035,
        "code": "31030",
        "name": "Marsat El Hadjadj",
        "name_ar": "مرسى الحجاج",
        "daira_id": 373
    },
    {
        "id": 1036,
        "code": "31040",
        "name": "Ain Biya",
        "name_ar": "عين البية",
        "daira_id": 373
    },
    {
        "id": 1037,
        "code": "31016",
        "name": "Boutlelis",
        "name_ar": "بوتليليس",
        "daira_id": 374
    },
    {
        "id": 1038,
        "code": "31031",
        "name": "Messerghin",
        "name_ar": "مسرغين",
        "daira_id": 374
    },
    {
        "id": 1039,
        "code": "36011",
        "name": "Ain Kerma",
        "name_ar": "عين الكرمة",
        "daira_id": 410
    },
    {
        "id": 1040,
        "code": "31017",
        "name": "Gdyel",
        "name_ar": "قديل",
        "daira_id": 375
    },
    {
        "id": 1041,
        "code": "31027",
        "name": "Ben Freha",
        "name_ar": "بن فريحة",
        "daira_id": 375
    },
    {
        "id": 1042,
        "code": "31046",
        "name": "Hassi Mefsoukh",
        "name_ar": "حاسي مفسوخ",
        "daira_id": 375
    },
    {
        "id": 1043,
        "code": "31024",
        "name": "Boufatis",
        "name_ar": "بوفاتيس",
        "daira_id": 376
    },
    {
        "id": 1044,
        "code": "31037",
        "name": "Oued Tlelat",
        "name_ar": "وادي تليلات",
        "daira_id": 376
    },
    {
        "id": 1045,
        "code": "31070",
        "name": "El Braya",
        "name_ar": "البراية",
        "daira_id": 376
    },
    {
        "id": 1046,
        "code": "31077",
        "name": "Tafraoui",
        "name_ar": "طفراوي",
        "daira_id": 376
    },
    {
        "id": 1047,
        "code": "32000",
        "name": "El Bayadh",
        "name_ar": "البيض",
        "daira_id": 377
    },
    {
        "id": 1048,
        "code": "32001",
        "name": "Bougtoub",
        "name_ar": "بوقطب",
        "daira_id": 378
    },
    {
        "id": 1049,
        "code": "32011",
        "name": "El Kheiter",
        "name_ar": "الخيثر",
        "daira_id": 378
    },
    {
        "id": 1050,
        "code": "32034",
        "name": "Tousmouline",
        "name_ar": "توسمولين",
        "daira_id": 378
    },
    {
        "id": 1051,
        "code": "32002",
        "name": "Brezina",
        "name_ar": "بريزينة",
        "daira_id": 379
    },
    {
        "id": 1052,
        "code": "32017",
        "name": "Ghassoul",
        "name_ar": "الغاسول",
        "daira_id": 379
    },
    {
        "id": 1053,
        "code": "32027",
        "name": "Krakda",
        "name_ar": "كراكدة",
        "daira_id": 379
    },
    {
        "id": 1054,
        "code": "32003",
        "name": "Labiodh Sidi Cheikh",
        "name_ar": "الأبيض سيدي الشيخ",
        "daira_id": 380
    },
    {
        "id": 1055,
        "code": "32005",
        "name": "Arbaouat",
        "name_ar": "اربوات",
        "daira_id": 380
    },
    {
        "id": 1056,
        "code": "32019",
        "name": "Ain El Orak",
        "name_ar": "عين العراك",
        "daira_id": 380
    },
    {
        "id": 1057,
        "code": "32025",
        "name": "El Bnoud",
        "name_ar": "البنود",
        "daira_id": 380
    },
    {
        "id": 1058,
        "code": "32006",
        "name": "Boualem",
        "name_ar": "بوعلام",
        "daira_id": 381
    },
    {
        "id": 1059,
        "code": "32032",
        "name": "Sidi Tiffour",
        "name_ar": "سيدي طيفور",
        "daira_id": 381
    },
    {
        "id": 1060,
        "code": "32033",
        "name": "Stitten",
        "name_ar": "ستيتن",
        "daira_id": 381
    },
    {
        "id": 1061,
        "code": "32013",
        "name": "Kef El Ahmar",
        "name_ar": "الكاف الأحمر",
        "daira_id": 382
    },
    {
        "id": 1062,
        "code": "32018",
        "name": "Rogassa",
        "name_ar": "رقاصة",
        "daira_id": 382
    },
    {
        "id": 1063,
        "code": "32022",
        "name": "Cheguig",
        "name_ar": "الشقيق",
        "daira_id": 382
    },
    {
        "id": 1064,
        "code": "32014",
        "name": "Boussemghoun",
        "name_ar": "بوسمغون",
        "daira_id": 383
    },
    {
        "id": 1065,
        "code": "32015",
        "name": "Chellala",
        "name_ar": "شلالة",
        "daira_id": 384
    },
    {
        "id": 1066,
        "code": "32024",
        "name": "El Mehara",
        "name_ar": "المحرة",
        "daira_id": 384
    },
    {
        "id": 1067,
        "code": "33000",
        "name": "Illizi",
        "name_ar": "إيليزي",
        "daira_id": 385
    },
    {
        "id": 1068,
        "code": "33001",
        "name": "In Amenas",
        "name_ar": "إن أمناس",
        "daira_id": 386
    },
    {
        "id": 1069,
        "code": "33003",
        "name": "Bordj Omar Driss",
        "name_ar": "برج عمر إدريس",
        "daira_id": 386
    },
    {
        "id": 1070,
        "code": "33004",
        "name": "Debdeb",
        "name_ar": "دبداب",
        "daira_id": 386
    },
    {
        "id": 1071,
        "code": "34000",
        "name": "B. B. Arreridj",
        "name_ar": "برج بوعريرج",
        "daira_id": 387
    },
    {
        "id": 1072,
        "code": "34001",
        "name": "Ras El Oued",
        "name_ar": "رأس الوادي",
        "daira_id": 388
    },
    {
        "id": 1073,
        "code": "34027",
        "name": "Ain Tesra",
        "name_ar": "عين تسرة",
        "daira_id": 388
    },
    {
        "id": 1074,
        "code": "34032",
        "name": "Ouled Brahem",
        "name_ar": "أولاد أبراهم",
        "daira_id": 388
    },
    {
        "id": 1075,
        "code": "34004",
        "name": "Bordj Ghedir",
        "name_ar": "برج الغدير",
        "daira_id": 389
    },
    {
        "id": 1076,
        "code": "34025",
        "name": "Belimour",
        "name_ar": "بليمور",
        "daira_id": 389
    },
    {
        "id": 1077,
        "code": "34030",
        "name": "El Annasseur",
        "name_ar": "العناصر",
        "daira_id": 389
    },
    {
        "id": 1078,
        "code": "34031",
        "name": "Ghailasa",
        "name_ar": "غيلاسة",
        "daira_id": 389
    },
    {
        "id": 1079,
        "code": "34059",
        "name": "Taglait",
        "name_ar": "تقلعيت",
        "daira_id": 389
    },
    {
        "id": 1080,
        "code": "34005",
        "name": "Bordj Zemmoura",
        "name_ar": "برج زمورة",
        "daira_id": 390
    },
    {
        "id": 1081,
        "code": "34026",
        "name": "Tassamert",
        "name_ar": "تسامرت",
        "daira_id": 390
    },
    {
        "id": 1082,
        "code": "34033",
        "name": "Ouled Dahmane",
        "name_ar": "أولاد دحمان",
        "daira_id": 390
    },
    {
        "id": 1083,
        "code": "34006",
        "name": "El Achir",
        "name_ar": "الياشير",
        "daira_id": 391
    },
    {
        "id": 1084,
        "code": "34009",
        "name": "Medjana",
        "name_ar": "مجانة",
        "daira_id": 391
    },
    {
        "id": 1085,
        "code": "34021",
        "name": "Teniet En Nasr",
        "name_ar": "ثنية النصر",
        "daira_id": 391
    },
    {
        "id": 1086,
        "code": "34068",
        "name": "Hasnaoua",
        "name_ar": "حسناوة",
        "daira_id": 391
    },
    {
        "id": 1087,
        "code": "47023",
        "name": "Mansoura",
        "name_ar": "المنصورة",
        "daira_id": 509
    },
    {
        "id": 1088,
        "code": "34019",
        "name": "El M'hir",
        "name_ar": "المهير",
        "daira_id": 392
    },
    {
        "id": 1089,
        "code": "34047",
        "name": "Haraza",
        "name_ar": "حرازة",
        "daira_id": 392
    },
    {
        "id": 1090,
        "code": "34052",
        "name": "Ouled Sidi-Brahim",
        "name_ar": "أولاد سيدي ابراهيم",
        "daira_id": 392
    },
    {
        "id": 1091,
        "code": "34073",
        "name": "Ben Daoud",
        "name_ar": "بن داود",
        "daira_id": 392
    },
    {
        "id": 1092,
        "code": "34010",
        "name": "Ain Taghrout",
        "name_ar": "عين تاغروت",
        "daira_id": 393
    },
    {
        "id": 1093,
        "code": "34022",
        "name": "Tixter",
        "name_ar": "تيكستار",
        "daira_id": 393
    },
    {
        "id": 1094,
        "code": "34011",
        "name": "Bir Kasdali",
        "name_ar": "بئر قاصد علي",
        "daira_id": 394
    },
    {
        "id": 1095,
        "code": "34020",
        "name": "Sidi-Embarek",
        "name_ar": "سيدي أمبارك",
        "daira_id": 394
    },
    {
        "id": 1096,
        "code": "34028",
        "name": "Khelil",
        "name_ar": "خليل",
        "daira_id": 394
    },
    {
        "id": 1097,
        "code": "34015",
        "name": "Colla",
        "name_ar": "القلة",
        "daira_id": 395
    },
    {
        "id": 1098,
        "code": "34016",
        "name": "Djaafra",
        "name_ar": "جعافرة",
        "daira_id": 395
    },
    {
        "id": 1099,
        "code": "34018",
        "name": "El Main",
        "name_ar": "الماين",
        "daira_id": 395
    },
    {
        "id": 1100,
        "code": "34061",
        "name": "Tefreg",
        "name_ar": "تفرق",
        "daira_id": 395
    },
    {
        "id": 1101,
        "code": "34029",
        "name": "El Euch",
        "name_ar": "العش",
        "daira_id": 396
    },
    {
        "id": 1102,
        "code": "34035",
        "name": "Rabta",
        "name_ar": "الرابطة",
        "daira_id": 396
    },
    {
        "id": 1103,
        "code": "34048",
        "name": "Ksour",
        "name_ar": "القصور",
        "daira_id": 396
    },
    {
        "id": 1104,
        "code": "35000",
        "name": "Boumerdes",
        "name_ar": "بومرداس",
        "daira_id": 397
    },
    {
        "id": 1105,
        "code": "35014",
        "name": "Corso",
        "name_ar": "قورصو",
        "daira_id": 397
    },
    {
        "id": 1106,
        "code": "35021",
        "name": "Tidjelabine",
        "name_ar": "تيجلابين",
        "daira_id": 397
    },
    {
        "id": 1107,
        "code": "35001",
        "name": "Bordj Menaiel",
        "name_ar": "برج منايل",
        "daira_id": 398
    },
    {
        "id": 1108,
        "code": "35012",
        "name": "Zemmouri",
        "name_ar": "زموري",
        "daira_id": 398
    },
    {
        "id": 1109,
        "code": "35024",
        "name": "Djinet",
        "name_ar": "جنات",
        "daira_id": 398
    },
    {
        "id": 1110,
        "code": "35026",
        "name": "Leghata",
        "name_ar": "لقاطة",
        "daira_id": 398
    },
    {
        "id": 1111,
        "code": "35003",
        "name": "Boudouaou",
        "name_ar": "بودواو",
        "daira_id": 399
    },
    {
        "id": 1112,
        "code": "35023",
        "name": "Boudouaou El Bahri",
        "name_ar": "بودواو البحري",
        "daira_id": 399
    },
    {
        "id": 1113,
        "code": "35038",
        "name": "Bouzegza Keddara",
        "name_ar": "بوزقزة قدارة",
        "daira_id": 399
    },
    {
        "id": 1114,
        "code": "35052",
        "name": "Ouled Hedadj",
        "name_ar": "أولاد هداج",
        "daira_id": 399
    },
    {
        "id": 1115,
        "code": "35004",
        "name": "Dellys",
        "name_ar": "دلس",
        "daira_id": 400
    },
    {
        "id": 1116,
        "code": "35022",
        "name": "Afir",
        "name_ar": "أعفير",
        "daira_id": 400
    },
    {
        "id": 1117,
        "code": "35033",
        "name": "Ben Choud",
        "name_ar": "بن شود",
        "daira_id": 400
    },
    {
        "id": 1118,
        "code": "35005",
        "name": "Thenia",
        "name_ar": "الثنية",
        "daira_id": 401
    },
    {
        "id": 1119,
        "code": "35006",
        "name": "Beni Amrane",
        "name_ar": "بني عمران",
        "daira_id": 401
    },
    {
        "id": 1120,
        "code": "35031",
        "name": "Ammal",
        "name_ar": "عمال",
        "daira_id": 401
    },
    {
        "id": 1121,
        "code": "35008",
        "name": "Chabet El Ameur",
        "name_ar": "شعبة العامر",
        "daira_id": 402
    },
    {
        "id": 1122,
        "code": "35009",
        "name": "Isser",
        "name_ar": "يسر",
        "daira_id": 402
    },
    {
        "id": 1123,
        "code": "35028",
        "name": "Si Mustapha",
        "name_ar": "سي مصطفى",
        "daira_id": 402
    },
    {
        "id": 1124,
        "code": "35010",
        "name": "Khemis El Khechna",
        "name_ar": "خميس الخشنة",
        "daira_id": 403
    },
    {
        "id": 1125,
        "code": "35011",
        "name": "Ouled Moussa",
        "name_ar": "أولاد موسى",
        "daira_id": 403
    },
    {
        "id": 1126,
        "code": "35015",
        "name": "Hammedi",
        "name_ar": "حمادي",
        "daira_id": 403
    },
    {
        "id": 1127,
        "code": "35017",
        "name": "Larbatache",
        "name_ar": "الاربعطاش",
        "daira_id": 403
    },
    {
        "id": 1128,
        "code": "35013",
        "name": "Baghlia",
        "name_ar": "بغلية",
        "daira_id": 404
    },
    {
        "id": 1129,
        "code": "35019",
        "name": "Sidi Daoud",
        "name_ar": "سيدي داود",
        "daira_id": 404
    },
    {
        "id": 1130,
        "code": "35029",
        "name": "Taourga",
        "name_ar": "تاورقة",
        "daira_id": 404
    },
    {
        "id": 1131,
        "code": "35018",
        "name": "Naciria",
        "name_ar": "الناصرية",
        "daira_id": 405
    },
    {
        "id": 1132,
        "code": "36000",
        "name": "El Tarf",
        "name_ar": "الطارف",
        "daira_id": 406
    },
    {
        "id": 1133,
        "code": "36010",
        "name": "Ain El Assel",
        "name_ar": "عين العسل",
        "daira_id": 406
    },
    {
        "id": 1134,
        "code": "36029",
        "name": "Bougous",
        "name_ar": "بوقوس",
        "daira_id": 406
    },
    {
        "id": 1135,
        "code": "36001",
        "name": "Drean",
        "name_ar": "الذرعـان",
        "daira_id": 407
    },
    {
        "id": 1136,
        "code": "36013",
        "name": "Chebaita Mokhtar",
        "name_ar": "شبيطة مختار",
        "daira_id": 407
    },
    {
        "id": 1137,
        "code": "36014",
        "name": "Chihani",
        "name_ar": "شحاني",
        "daira_id": 407
    },
    {
        "id": 1138,
        "code": "36002",
        "name": "El Kala",
        "name_ar": "القالة",
        "daira_id": 408
    },
    {
        "id": 1139,
        "code": "36018",
        "name": "El Aioun",
        "name_ar": "العيون",
        "daira_id": 408
    },
    {
        "id": 1140,
        "code": "36020",
        "name": "Souarekh",
        "name_ar": "السوارخ",
        "daira_id": 408
    },
    {
        "id": 1141,
        "code": "36021",
        "name": "Raml Souk",
        "name_ar": "رمل السوق",
        "daira_id": 408
    },
    {
        "id": 1142,
        "code": "36003",
        "name": "Ben M Hidi",
        "name_ar": "بن مهيدي",
        "daira_id": 409
    },
    {
        "id": 1143,
        "code": "36025",
        "name": "Echatt",
        "name_ar": "الشط",
        "daira_id": 409
    },
    {
        "id": 1144,
        "code": "36027",
        "name": "Berrihane",
        "name_ar": "بريحان",
        "daira_id": 409
    },
    {
        "id": 1145,
        "code": "36005",
        "name": "Bouhadjar",
        "name_ar": "بوحجار",
        "daira_id": 410
    },
    {
        "id": 1146,
        "code": "36036",
        "name": "Hammam Beni Salah",
        "name_ar": "حمام بني صالح",
        "daira_id": 410
    },
    {
        "id": 1147,
        "code": "36044",
        "name": "Oued Zitoun",
        "name_ar": "وادي الزيتون",
        "daira_id": 410
    },
    {
        "id": 1148,
        "code": "36006",
        "name": "Bouteldja",
        "name_ar": "بوثلجة",
        "daira_id": 411
    },
    {
        "id": 1149,
        "code": "36019",
        "name": "Lac Des Oiseaux",
        "name_ar": "بحيرة الطيور",
        "daira_id": 411
    },
    {
        "id": 1150,
        "code": "36032",
        "name": "Chefia",
        "name_ar": "الشافية",
        "daira_id": 411
    },
    {
        "id": 1151,
        "code": "36012",
        "name": "Asfour",
        "name_ar": "عصفور",
        "daira_id": 412
    },
    {
        "id": 1152,
        "code": "36015",
        "name": "Zerizer",
        "name_ar": "زريزر",
        "daira_id": 412
    },
    {
        "id": 1153,
        "code": "07044",
        "name": "Besbes",
        "name_ar": "بسباس",
        "daira_id": 529
    },
    {
        "id": 1154,
        "code": "37000",
        "name": "Tindouf",
        "name_ar": "تندوف",
        "daira_id": 413
    },
    {
        "id": 1155,
        "code": "37003",
        "name": "Oum El Assel",
        "name_ar": "أم العسل",
        "daira_id": 413
    },
    {
        "id": 1156,
        "code": "38000",
        "name": "Tissemsilt",
        "name_ar": "تيسمسيلت",
        "daira_id": 414
    },
    {
        "id": 1157,
        "code": "38014",
        "name": "Ouled Bessam",
        "name_ar": "أولاد بسام",
        "daira_id": 414
    },
    {
        "id": 1158,
        "code": "38001",
        "name": "Bordj Bounaama",
        "name_ar": "برج بونعامة",
        "daira_id": 415
    },
    {
        "id": 1159,
        "code": "38019",
        "name": "Beni Chaib",
        "name_ar": "بني شعيب",
        "daira_id": 415
    },
    {
        "id": 1160,
        "code": "38020",
        "name": "Beni Lahcene",
        "name_ar": "بني لحسن",
        "daira_id": 415
    },
    {
        "id": 1161,
        "code": "38002",
        "name": "Lardjem",
        "name_ar": "لرجام",
        "daira_id": 416
    },
    {
        "id": 1162,
        "code": "38013",
        "name": "Melaab",
        "name_ar": "الملعب",
        "daira_id": 416
    },
    {
        "id": 1163,
        "code": "38027",
        "name": "Sidi Lantri",
        "name_ar": "سيدي العنتري",
        "daira_id": 416
    },
    {
        "id": 1164,
        "code": "38029",
        "name": "Tamellahet",
        "name_ar": "تملاحت",
        "daira_id": 416
    },
    {
        "id": 1165,
        "code": "38003",
        "name": "Theniet El Had",
        "name_ar": "ثنية الاحد",
        "daira_id": 417
    },
    {
        "id": 1166,
        "code": "38026",
        "name": "Sidi Boutouchent",
        "name_ar": "سيدي بوتوشنت",
        "daira_id": 417
    },
    {
        "id": 1167,
        "code": "38005",
        "name": "Boucaid",
        "name_ar": "بوقائد",
        "daira_id": 418
    },
    {
        "id": 1168,
        "code": "38008",
        "name": "Lazharia",
        "name_ar": "الأزهرية",
        "daira_id": 418
    },
    {
        "id": 1169,
        "code": "38007",
        "name": "Layoune",
        "name_ar": "العيون",
        "daira_id": 419
    },
    {
        "id": 1170,
        "code": "42016",
        "name": "Khemisti",
        "name_ar": "خميستي",
        "daira_id": 454
    },
    {
        "id": 1171,
        "code": "38012",
        "name": "Ammari",
        "name_ar": "عماري",
        "daira_id": 420
    },
    {
        "id": 1172,
        "code": "38023",
        "name": "Maacem",
        "name_ar": "المعاصم",
        "daira_id": 420
    },
    {
        "id": 1173,
        "code": "38025",
        "name": "Sidi Abed",
        "name_ar": "سيدي عابد",
        "daira_id": 420
    },
    {
        "id": 1174,
        "code": "38031",
        "name": "Youssoufia",
        "name_ar": "اليوسفية",
        "daira_id": 421
    },
    {
        "id": 1175,
        "code": "38041",
        "name": "Bordj El Emir Abdelkader",
        "name_ar": "برج الأمير عبد القادر",
        "daira_id": 421
    },
    {
        "id": 1176,
        "code": "39000",
        "name": "El-Oued",
        "name_ar": "الوادي",
        "daira_id": 422
    },
    {
        "id": 1177,
        "code": "39014",
        "name": "Kouinine",
        "name_ar": "كوينين",
        "daira_id": 422
    },
    {
        "id": 1178,
        "code": "39002",
        "name": "Guemar",
        "name_ar": "قمار",
        "daira_id": 423
    },
    {
        "id": 1179,
        "code": "39035",
        "name": "Ourmes",
        "name_ar": "ورماس",
        "daira_id": 423
    },
    {
        "id": 1180,
        "code": "39003",
        "name": "Debila",
        "name_ar": "الدبيلة",
        "daira_id": 424
    },
    {
        "id": 1181,
        "code": "39020",
        "name": "Hassani Abdelkrim",
        "name_ar": "حساني عبد الكريم",
        "daira_id": 424
    },
    {
        "id": 1182,
        "code": "39007",
        "name": "Bayadha",
        "name_ar": "البياضة",
        "daira_id": 425
    },
    {
        "id": 1183,
        "code": "39013",
        "name": "Hassi Khalifa",
        "name_ar": "حاسي خليفة",
        "daira_id": 426
    },
    {
        "id": 1184,
        "code": "39044",
        "name": "Trifaoui",
        "name_ar": "الطريفاوي",
        "daira_id": 426
    },
    {
        "id": 1185,
        "code": "39015",
        "name": "Magrane",
        "name_ar": "المقرن",
        "daira_id": 427
    },
    {
        "id": 1186,
        "code": "39037",
        "name": "Sidi Aoun",
        "name_ar": "سيدي عون",
        "daira_id": 427
    },
    {
        "id": 1187,
        "code": "39016",
        "name": "Reguiba",
        "name_ar": "الرقيبة",
        "daira_id": 428
    },
    {
        "id": 1188,
        "code": "39061",
        "name": "Hamraia",
        "name_ar": "الحمراية",
        "daira_id": 428
    },
    {
        "id": 1189,
        "code": "39017",
        "name": "Robbah",
        "name_ar": "الرباح",
        "daira_id": 429
    },
    {
        "id": 1190,
        "code": "39031",
        "name": "Nakhla",
        "name_ar": "النخلة",
        "daira_id": 429
    },
    {
        "id": 1191,
        "code": "39019",
        "name": "Taleb Larbi",
        "name_ar": "الطالب العربي",
        "daira_id": 430
    },
    {
        "id": 1192,
        "code": "39024",
        "name": "Douar El Maa",
        "name_ar": "دوار الماء",
        "daira_id": 430
    },
    {
        "id": 1193,
        "code": "39048",
        "name": "Ben Guecha",
        "name_ar": "بن  قشة",
        "daira_id": 430
    },
    {
        "id": 1194,
        "code": "39030",
        "name": "Mih Ouansa",
        "name_ar": "اميه وانسة",
        "daira_id": 431
    },
    {
        "id": 1195,
        "code": "39033",
        "name": "Oued El Alenda",
        "name_ar": "وادي العلندة",
        "daira_id": 431
    },
    {
        "id": 1196,
        "code": "40000",
        "name": "Khenchela",
        "name_ar": "خنشلة",
        "daira_id": 432
    },
    {
        "id": 1197,
        "code": "40001",
        "name": "Kais",
        "name_ar": "قايس",
        "daira_id": 433
    },
    {
        "id": 1198,
        "code": "40011",
        "name": "Taouzianat",
        "name_ar": "تاوزيانت",
        "daira_id": 433
    },
    {
        "id": 1199,
        "code": "40041",
        "name": "Remila",
        "name_ar": "الرميلة",
        "daira_id": 433
    },
    {
        "id": 1200,
        "code": "40006",
        "name": "Babar",
        "name_ar": "بابار",
        "daira_id": 434
    },
    {
        "id": 1201,
        "code": "40007",
        "name": "Bouhmama",
        "name_ar": "بوحمامة",
        "daira_id": 435
    },
    {
        "id": 1202,
        "code": "40023",
        "name": "Yabous",
        "name_ar": "يابوس",
        "daira_id": 435
    },
    {
        "id": 1203,
        "code": "40030",
        "name": "Chelia",
        "name_ar": "شلية",
        "daira_id": 435
    },
    {
        "id": 1204,
        "code": "40039",
        "name": "M'sara",
        "name_ar": "مصارة",
        "daira_id": 435
    },
    {
        "id": 1205,
        "code": "40008",
        "name": "Chechar",
        "name_ar": "ششار",
        "daira_id": 436
    },
    {
        "id": 1206,
        "code": "40015",
        "name": "Djellal",
        "name_ar": "جلال",
        "daira_id": 436
    },
    {
        "id": 1207,
        "code": "40036",
        "name": "Khirane",
        "name_ar": "خيران",
        "daira_id": 436
    },
    {
        "id": 1208,
        "code": "40012",
        "name": "El Mahmal",
        "name_ar": "المحمل",
        "daira_id": 437
    },
    {
        "id": 1209,
        "code": "40013",
        "name": "Ouled Rechache",
        "name_ar": "أولاد رشاش",
        "daira_id": 437
    },
    {
        "id": 1210,
        "code": "40014",
        "name": "Baghai",
        "name_ar": "بغاي",
        "daira_id": 438
    },
    {
        "id": 1211,
        "code": "40024",
        "name": "Tamza",
        "name_ar": "طامزة",
        "daira_id": 438
    },
    {
        "id": 1212,
        "code": "40031",
        "name": "El Hamma",
        "name_ar": "الحامة",
        "daira_id": 438
    },
    {
        "id": 1213,
        "code": "40043",
        "name": "Ensigha",
        "name_ar": "انسيغة",
        "daira_id": 438
    },
    {
        "id": 1214,
        "code": "40021",
        "name": "M'toussa",
        "name_ar": "متوسة",
        "daira_id": 439
    },
    {
        "id": 1215,
        "code": "40028",
        "name": "Ain Touila",
        "name_ar": "عين الطويلة",
        "daira_id": 439
    },
    {
        "id": 1216,
        "code": "41000",
        "name": "Souk Ahras",
        "name_ar": "سوق أهراس",
        "daira_id": 440
    },
    {
        "id": 1217,
        "code": "41001",
        "name": "M'daourouche",
        "name_ar": "مداوروش",
        "daira_id": 441
    },
    {
        "id": 1218,
        "code": "41033",
        "name": "Ragouba",
        "name_ar": "الراقوبة",
        "daira_id": 441
    },
    {
        "id": 1219,
        "code": "41038",
        "name": "Tiffech",
        "name_ar": "تيفاش",
        "daira_id": 441
    },
    {
        "id": 1220,
        "code": "41004",
        "name": "Merahna",
        "name_ar": "المراهنة",
        "daira_id": 442
    },
    {
        "id": 1221,
        "code": "41029",
        "name": "Ouillen",
        "name_ar": "ويلان",
        "daira_id": 442
    },
    {
        "id": 1222,
        "code": "41005",
        "name": "Ouled Driss",
        "name_ar": "أولاد إدريس",
        "daira_id": 443
    },
    {
        "id": 1223,
        "code": "41027",
        "name": "Ain Zana",
        "name_ar": "عين الزانة",
        "daira_id": 443
    },
    {
        "id": 1224,
        "code": "41006",
        "name": "Sedrata",
        "name_ar": "سدراتة",
        "daira_id": 444
    },
    {
        "id": 1225,
        "code": "41031",
        "name": "Khemissa",
        "name_ar": "خميسة",
        "daira_id": 444
    },
    {
        "id": 1226,
        "code": "41009",
        "name": "Taoura",
        "name_ar": "تاورة",
        "daira_id": 445
    },
    {
        "id": 1227,
        "code": "41015",
        "name": "Drea",
        "name_ar": "الدريعة",
        "daira_id": 445
    },
    {
        "id": 1228,
        "code": "41025",
        "name": "Zaarouria",
        "name_ar": "الزعرورية",
        "daira_id": 445
    },
    {
        "id": 1229,
        "code": "41010",
        "name": "Machroha",
        "name_ar": "المشروحة",
        "daira_id": 446
    },
    {
        "id": 1230,
        "code": "41016",
        "name": "Hanencha",
        "name_ar": "الحنانشة",
        "daira_id": 446
    },
    {
        "id": 1231,
        "code": "41011",
        "name": "Bir Bouhouche",
        "name_ar": "بئر بوحوش",
        "daira_id": 447
    },
    {
        "id": 1232,
        "code": "41035",
        "name": "Safel El Ouiden",
        "name_ar": "سافل الويدان",
        "daira_id": 447
    },
    {
        "id": 1233,
        "code": "41039",
        "name": "Zouabi",
        "name_ar": "الزوابي",
        "daira_id": 447
    },
    {
        "id": 1234,
        "code": "41012",
        "name": "Haddada",
        "name_ar": "الحدادة",
        "daira_id": 448
    },
    {
        "id": 1235,
        "code": "41013",
        "name": "Khedara",
        "name_ar": "الخضارة",
        "daira_id": 448
    },
    {
        "id": 1236,
        "code": "41034",
        "name": "Ouled Moumen",
        "name_ar": "أولاد مومن",
        "daira_id": 448
    },
    {
        "id": 1237,
        "code": "41018",
        "name": "Oued Kebrit",
        "name_ar": "وادي الكبريت",
        "daira_id": 449
    },
    {
        "id": 1238,
        "code": "41019",
        "name": "Oum El Adhaim",
        "name_ar": "أم العظايم",
        "daira_id": 449
    },
    {
        "id": 1239,
        "code": "41037",
        "name": "Terraguelt",
        "name_ar": "ترقالت",
        "daira_id": 449
    },
    {
        "id": 1240,
        "code": "42000",
        "name": "Tipaza",
        "name_ar": "تيبازة",
        "daira_id": 450
    },
    {
        "id": 1241,
        "code": "42001",
        "name": "Hadjout",
        "name_ar": "حجوط",
        "daira_id": 451
    },
    {
        "id": 1242,
        "code": "42019",
        "name": "Merad",
        "name_ar": "مراد",
        "daira_id": 451
    },
    {
        "id": 1243,
        "code": "42002",
        "name": "Cherchell",
        "name_ar": "شرشال",
        "daira_id": 452
    },
    {
        "id": 1244,
        "code": "42021",
        "name": "Sidi Ghiles",
        "name_ar": "سيدي غيلاس",
        "daira_id": 452
    },
    {
        "id": 1245,
        "code": "42029",
        "name": "Hadjret Ennous",
        "name_ar": "حجرة النص",
        "daira_id": 452
    },
    {
        "id": 1246,
        "code": "42041",
        "name": "Sidi Semiane",
        "name_ar": "سيدي سميان",
        "daira_id": 452
    },
    {
        "id": 1247,
        "code": "42003",
        "name": "Kolea",
        "name_ar": "القليعة",
        "daira_id": 453
    },
    {
        "id": 1248,
        "code": "42008",
        "name": "Attatba",
        "name_ar": "الحطاطبة",
        "daira_id": 453
    },
    {
        "id": 1249,
        "code": "07045",
        "name": "Chaiba",
        "name_ar": "الشعيبة",
        "daira_id": 528
    },
    {
        "id": 1250,
        "code": "42004",
        "name": "Bou Ismail",
        "name_ar": "بواسماعيل",
        "daira_id": 454
    },
    {
        "id": 1251,
        "code": "42009",
        "name": "Bou Haroun",
        "name_ar": "بوهارون",
        "daira_id": 454
    },
    {
        "id": 1252,
        "code": "42023",
        "name": "Ain Tagourait",
        "name_ar": "عين تاقورايت",
        "daira_id": 454
    },
    {
        "id": 1253,
        "code": "42005",
        "name": "Ahmer El Ain",
        "name_ar": "أحمر العين",
        "daira_id": 455
    },
    {
        "id": 1254,
        "code": "42011",
        "name": "Bourkika",
        "name_ar": "بورقيقة",
        "daira_id": 455
    },
    {
        "id": 1255,
        "code": "42040",
        "name": "Sidi Rached",
        "name_ar": "سيدي راشد",
        "daira_id": 455
    },
    {
        "id": 1256,
        "code": "42006",
        "name": "Fouka",
        "name_ar": "فوكة",
        "daira_id": 456
    },
    {
        "id": 1257,
        "code": "42015",
        "name": "Douaouda",
        "name_ar": "دواودة",
        "daira_id": 456
    },
    {
        "id": 1258,
        "code": "42007",
        "name": "Gouraya",
        "name_ar": "قوراية",
        "daira_id": 457
    },
    {
        "id": 1259,
        "code": "42035",
        "name": "Aghbal",
        "name_ar": "أغبال",
        "daira_id": 457
    },
    {
        "id": 1260,
        "code": "42036",
        "name": "Messelmoun",
        "name_ar": "مسلمون",
        "daira_id": 457
    },
    {
        "id": 1261,
        "code": "42014",
        "name": "Damous",
        "name_ar": "الداموس",
        "daira_id": 458
    },
    {
        "id": 1262,
        "code": "42017",
        "name": "Larhat",
        "name_ar": "الأرهاط",
        "daira_id": 458
    },
    {
        "id": 1263,
        "code": "42024",
        "name": "Beni Mileuk",
        "name_ar": "بني ميلك",
        "daira_id": 458
    },
    {
        "id": 1264,
        "code": "42018",
        "name": "Menaceur",
        "name_ar": "مناصر",
        "daira_id": 459
    },
    {
        "id": 1265,
        "code": "42039",
        "name": "Nador",
        "name_ar": "الناظور",
        "daira_id": 459
    },
    {
        "id": 1266,
        "code": "43000",
        "name": "Mila",
        "name_ar": "ميلة",
        "daira_id": 460
    },
    {
        "id": 1267,
        "code": "43016",
        "name": "Ain Tine",
        "name_ar": "عين التين",
        "daira_id": 460
    },
    {
        "id": 1268,
        "code": "43058",
        "name": "Sidi Khelifa",
        "name_ar": "سيدي خليفة",
        "daira_id": 460
    },
    {
        "id": 1269,
        "code": "43001",
        "name": "Chelghoum Laid",
        "name_ar": "شلغوم العيد",
        "daira_id": 461
    },
    {
        "id": 1270,
        "code": "43005",
        "name": "Oued Athmenia",
        "name_ar": "وادي العثمانية",
        "daira_id": 461
    },
    {
        "id": 1271,
        "code": "43015",
        "name": "Ain Mellouk",
        "name_ar": "عين الملوك",
        "daira_id": 461
    },
    {
        "id": 1272,
        "code": "43002",
        "name": "Ferdjioua",
        "name_ar": "فرجيوة",
        "daira_id": 462
    },
    {
        "id": 1273,
        "code": "43071",
        "name": "Yahia Beniguecha",
        "name_ar": "يحي بني قشة",
        "daira_id": 462
    },
    {
        "id": 1274,
        "code": "43004",
        "name": "Grarem Gouga",
        "name_ar": "القرارم قوقة",
        "daira_id": 463
    },
    {
        "id": 1275,
        "code": "43052",
        "name": "Hamala",
        "name_ar": "حمالة",
        "daira_id": 463
    },
    {
        "id": 1276,
        "code": "43006",
        "name": "Oued Endja",
        "name_ar": "وادي النجاء",
        "daira_id": 464
    },
    {
        "id": 1277,
        "code": "43012",
        "name": "Zeghaia",
        "name_ar": "زغاية",
        "daira_id": 464
    },
    {
        "id": 1278,
        "code": "43013",
        "name": "Ahmed Rachedi",
        "name_ar": "أحمد راشدي",
        "daira_id": 464
    },
    {
        "id": 1279,
        "code": "43007",
        "name": "Tadjenanet",
        "name_ar": "تاجنانت",
        "daira_id": 465
    },
    {
        "id": 1280,
        "code": "43020",
        "name": "Benyahia Abderrahmane",
        "name_ar": "بن يحي عبد الرحمن",
        "daira_id": 465
    },
    {
        "id": 1281,
        "code": "43032",
        "name": "Ouled Khalouf",
        "name_ar": "أولاد اخلوف",
        "daira_id": 465
    },
    {
        "id": 1282,
        "code": "43008",
        "name": "Teleghma",
        "name_ar": "التلاغمة",
        "daira_id": 466
    },
    {
        "id": 1283,
        "code": "43026",
        "name": "El Mechira",
        "name_ar": "مشيرة",
        "daira_id": 466
    },
    {
        "id": 1284,
        "code": "43031",
        "name": "Oued Seguen",
        "name_ar": "وادي سقان",
        "daira_id": 466
    },
    {
        "id": 1285,
        "code": "43009",
        "name": "Rouached",
        "name_ar": "الرواشد",
        "daira_id": 467
    },
    {
        "id": 1286,
        "code": "43035",
        "name": "Tiberguent",
        "name_ar": "تيبرقنت",
        "daira_id": 467
    },
    {
        "id": 1287,
        "code": "43010",
        "name": "Sidi Merouane",
        "name_ar": "سيدي مروان",
        "daira_id": 468
    },
    {
        "id": 1288,
        "code": "43025",
        "name": "Chigara",
        "name_ar": "الشيقارة",
        "daira_id": 468
    },
    {
        "id": 1289,
        "code": "43014",
        "name": "Ain Beida Harriche",
        "name_ar": " عين البيضاء أحريش",
        "daira_id": 469
    },
    {
        "id": 1290,
        "code": "43050",
        "name": "El Ayadi Barbes",
        "name_ar": "العياضي برباس",
        "daira_id": 469
    },
    {
        "id": 1291,
        "code": "43017",
        "name": "Amira Arres",
        "name_ar": "اعميرة اراس",
        "daira_id": 470
    },
    {
        "id": 1292,
        "code": "43018",
        "name": "Terrai Bainen",
        "name_ar": "ترعي باينان",
        "daira_id": 470
    },
    {
        "id": 1293,
        "code": "43034",
        "name": "Tassala Lematai",
        "name_ar": "تسالة لمطاعي",
        "daira_id": 470
    },
    {
        "id": 1294,
        "code": "43022",
        "name": "Bouhatem",
        "name_ar": "بوحاتم",
        "daira_id": 471
    },
    {
        "id": 1295,
        "code": "43046",
        "name": "Derrahi Bousselah",
        "name_ar": "دراحي بوصلاح",
        "daira_id": 471
    },
    {
        "id": 1296,
        "code": "43033",
        "name": "Tassadane Haddada",
        "name_ar": "تسدان حدادة",
        "daira_id": 472
    },
    {
        "id": 1297,
        "code": "43036",
        "name": "Minar Zarza",
        "name_ar": "مينار زارزة",
        "daira_id": 472
    },
    {
        "id": 1298,
        "code": "44000",
        "name": "Ain-Defla",
        "name_ar": "عين الدفلى",
        "daira_id": 473
    },
    {
        "id": 1299,
        "code": "44001",
        "name": "Khemis-Miliana",
        "name_ar": "خميس مليانة",
        "daira_id": 474
    },
    {
        "id": 1300,
        "code": "44002",
        "name": "El-Attaf",
        "name_ar": "العطاف",
        "daira_id": 475
    },
    {
        "id": 1301,
        "code": "44030",
        "name": "Tiberkanine",
        "name_ar": "تبركانين",
        "daira_id": 475
    },
    {
        "id": 1302,
        "code": "44003",
        "name": "Miliana",
        "name_ar": "مليانة",
        "daira_id": 476
    },
    {
        "id": 1303,
        "code": "44040",
        "name": "Ben Allal",
        "name_ar": "بن علال",
        "daira_id": 476
    },
    {
        "id": 1304,
        "code": "44004",
        "name": "Boumedfaa",
        "name_ar": "بومدفع",
        "daira_id": 477
    },
    {
        "id": 1305,
        "code": "44048",
        "name": "Hoceinia",
        "name_ar": "الحسينية",
        "daira_id": 477
    },
    {
        "id": 1306,
        "code": "44005",
        "name": "Djendel",
        "name_ar": "جندل",
        "daira_id": 478
    },
    {
        "id": 1307,
        "code": "44024",
        "name": "Oued Chorfa",
        "name_ar": "وادي الشرفاء",
        "daira_id": 478
    },
    {
        "id": 1308,
        "code": "44042",
        "name": "Birbouche",
        "name_ar": "بربوش",
        "daira_id": 478
    },
    {
        "id": 1309,
        "code": "44006",
        "name": "El-Abadia",
        "name_ar": "العبادية",
        "daira_id": 479
    },
    {
        "id": 1310,
        "code": "44028",
        "name": "Tacheta Zegagha",
        "name_ar": "تاشتة زقاغة",
        "daira_id": 479
    },
    {
        "id": 1311,
        "code": "44032",
        "name": "Ain-Bouyahia",
        "name_ar": "عين بويحيى",
        "daira_id": 479
    },
    {
        "id": 1312,
        "code": "44008",
        "name": "Arib",
        "name_ar": "عريب",
        "daira_id": 480
    },
    {
        "id": 1313,
        "code": "44010",
        "name": "El-Amra",
        "name_ar": "العامرة",
        "daira_id": 480
    },
    {
        "id": 1314,
        "code": "44050",
        "name": "Mekhatria",
        "name_ar": "المخاطرية",
        "daira_id": 480
    },
    {
        "id": 1315,
        "code": "44009",
        "name": "Djelida",
        "name_ar": "جليدة",
        "daira_id": 481
    },
    {
        "id": 1316,
        "code": "44044",
        "name": "Bourached",
        "name_ar": "بوراشد",
        "daira_id": 481
    },
    {
        "id": 1317,
        "code": "44047",
        "name": "Djemaa Ouled Cheikh",
        "name_ar": "جمعة أولاد الشيخ",
        "daira_id": 481
    },
    {
        "id": 1318,
        "code": "44017",
        "name": "Rouina",
        "name_ar": "الروينة",
        "daira_id": 482
    },
    {
        "id": 1319,
        "code": "44031",
        "name": "Zeddine",
        "name_ar": "زدين",
        "daira_id": 482
    },
    {
        "id": 1320,
        "code": "44051",
        "name": "El-Maine",
        "name_ar": "الماين",
        "daira_id": 482
    },
    {
        "id": 1321,
        "code": "44018",
        "name": "Ain-Lechiakh",
        "name_ar": "عين الاشياخ",
        "daira_id": 483
    },
    {
        "id": 1322,
        "code": "44019",
        "name": "Ain-Soltane",
        "name_ar": "عين السلطان",
        "daira_id": 483
    },
    {
        "id": 1323,
        "code": "44049",
        "name": "Oued Djemaa",
        "name_ar": "واد الجمعة",
        "daira_id": 483
    },
    {
        "id": 1324,
        "code": "44020",
        "name": "Ain-Torki",
        "name_ar": "عين التركي",
        "daira_id": 484
    },
    {
        "id": 1325,
        "code": "44023",
        "name": "Hammam-Righa",
        "name_ar": "حمام ريغة",
        "daira_id": 484
    },
    {
        "id": 1326,
        "code": "44035",
        "name": "Ain-Benian",
        "name_ar": "عين البنيان",
        "daira_id": 484
    },
    {
        "id": 1327,
        "code": "44021",
        "name": "Bordj-Emir-Khaled",
        "name_ar": "برج الأمير خالد",
        "daira_id": 485
    },
    {
        "id": 1328,
        "code": "44029",
        "name": "Tarik-Ibn-Ziad",
        "name_ar": "طارق بن زياد",
        "daira_id": 485
    },
    {
        "id": 1329,
        "code": "44043",
        "name": "Bir-Ould-Khelifa",
        "name_ar": "بئر ولد خليفة",
        "daira_id": 485
    },
    {
        "id": 1330,
        "code": "44022",
        "name": "Hassania",
        "name_ar": "الحسانية",
        "daira_id": 486
    },
    {
        "id": 1331,
        "code": "44038",
        "name": "Belaas",
        "name_ar": "بلعاص",
        "daira_id": 486
    },
    {
        "id": 1332,
        "code": "44041",
        "name": "Bathia",
        "name_ar": "بطحية",
        "daira_id": 486
    },
    {
        "id": 1333,
        "code": "45000",
        "name": "Naama",
        "name_ar": "النعامة",
        "daira_id": 487
    },
    {
        "id": 1334,
        "code": "45001",
        "name": "Ain Sefra",
        "name_ar": "عين الصفراء",
        "daira_id": 488
    },
    {
        "id": 1335,
        "code": "45030",
        "name": "Tiout",
        "name_ar": "تيوت",
        "daira_id": 488
    },
    {
        "id": 1336,
        "code": "45002",
        "name": "Mecheria",
        "name_ar": "المشرية",
        "daira_id": 489
    },
    {
        "id": 1337,
        "code": "45004",
        "name": "El Biodh",
        "name_ar": "البيوض",
        "daira_id": 489
    },
    {
        "id": 1338,
        "code": "45008",
        "name": "Ain Ben Khelil",
        "name_ar": "عين بن خليل",
        "daira_id": 489
    },
    {
        "id": 1339,
        "code": "45005",
        "name": "Makmen Ben Amar",
        "name_ar": "مكمن بن عمار",
        "daira_id": 490
    },
    {
        "id": 1340,
        "code": "45024",
        "name": "Kasdir",
        "name_ar": "القصدير",
        "daira_id": 490
    },
    {
        "id": 1341,
        "code": "45012",
        "name": "Asla",
        "name_ar": "عسلة",
        "daira_id": 491
    },
    {
        "id": 1342,
        "code": "45013",
        "name": "Djenienne Bourezg",
        "name_ar": "جنين بورزق",
        "daira_id": 492
    },
    {
        "id": 1343,
        "code": "45014",
        "name": "Moghrar",
        "name_ar": "مغرار",
        "daira_id": 492
    },
    {
        "id": 1344,
        "code": "45021",
        "name": "Sfissifa",
        "name_ar": "سفيسيفة",
        "daira_id": 493
    },
    {
        "id": 1345,
        "code": "46000",
        "name": "Ain Temouchent",
        "name_ar": "عين تموشنت",
        "daira_id": 494
    },
    {
        "id": 1346,
        "code": "46013",
        "name": "Sidi Ben Adda",
        "name_ar": "سيدي بن عدة",
        "daira_id": 494
    },
    {
        "id": 1347,
        "code": "46001",
        "name": "Beni Saf",
        "name_ar": "بني صاف",
        "daira_id": 495
    },
    {
        "id": 1348,
        "code": "46025",
        "name": "Sidi Safi",
        "name_ar": "سيدي صافي",
        "daira_id": 495
    },
    {
        "id": 1349,
        "code": "46005",
        "name": "Hammam Bou Hadjar",
        "name_ar": "حمام بوحجر",
        "daira_id": 496
    },
    {
        "id": 1350,
        "code": "46022",
        "name": "Oued Berkeche",
        "name_ar": "وادي برقش",
        "daira_id": 496
    },
    {
        "id": 1351,
        "code": "46006",
        "name": "El Amria",
        "name_ar": "العامرية",
        "daira_id": 497
    },
    {
        "id": 1352,
        "code": "46012",
        "name": "Hassi El Ghella",
        "name_ar": "حاسي الغلة",
        "daira_id": 497
    },
    {
        "id": 1353,
        "code": "46033",
        "name": "Bouzedjar",
        "name_ar": "بوزجار",
        "daira_id": 497
    },
    {
        "id": 1354,
        "code": "46035",
        "name": "El Messaid",
        "name_ar": "المساعيد",
        "daira_id": 497
    },
    {
        "id": 1355,
        "code": "46043",
        "name": "Ouled Boudjemaa",
        "name_ar": "أولاد بوجمعة",
        "daira_id": 497
    },
    {
        "id": 1356,
        "code": "46008",
        "name": "Ain Kihal",
        "name_ar": "عين الكيحل",
        "daira_id": 498
    },
    {
        "id": 1357,
        "code": "46010",
        "name": "Ain Tolba",
        "name_ar": "عين الطلبة",
        "daira_id": 498
    },
    {
        "id": 1358,
        "code": "46016",
        "name": "Aghlal",
        "name_ar": "أغلال",
        "daira_id": 498
    },
    {
        "id": 1359,
        "code": "46017",
        "name": "Aoubellil",
        "name_ar": "عقب الليل",
        "daira_id": 498
    },
    {
        "id": 1360,
        "code": "46009",
        "name": "Ain El Arbaa",
        "name_ar": "عين الأربعاء",
        "daira_id": 499
    },
    {
        "id": 1361,
        "code": "46023",
        "name": "Oued Sebbah",
        "name_ar": "وادي الصباح",
        "daira_id": 499
    },
    {
        "id": 1362,
        "code": "46026",
        "name": "Tamzoura",
        "name_ar": "تامزورة",
        "daira_id": 499
    },
    {
        "id": 1363,
        "code": "46051",
        "name": "Sidi Boumediene",
        "name_ar": "سيدي بومدين",
        "daira_id": 499
    },
    {
        "id": 1364,
        "code": "46011",
        "name": "Chaabat El Ham",
        "name_ar": "شعبة اللحم",
        "daira_id": 500
    },
    {
        "id": 1365,
        "code": "46015",
        "name": "Terga",
        "name_ar": "تارقة",
        "daira_id": 500
    },
    {
        "id": 1366,
        "code": "46038",
        "name": "Ouled Kihal",
        "name_ar": "أولاد الكيحل",
        "daira_id": 500
    },
    {
        "id": 1367,
        "code": "46067",
        "name": "El Maleh",
        "name_ar": "المالح",
        "daira_id": 500
    },
    {
        "id": 1368,
        "code": "46024",
        "name": "Sidi Ouriache",
        "name_ar": "سيدي ورياش",
        "daira_id": 501
    },
    {
        "id": 1369,
        "code": "46053",
        "name": "Oulhaca El Gheraba",
        "name_ar": "ولهاصة الغرابة",
        "daira_id": 501
    },
    {
        "id": 1370,
        "code": "47000",
        "name": "Ghardaia",
        "name_ar": "غرداية",
        "daira_id": 502
    },
    {
        "id": 1371,
        "code": "47002",
        "name": "Metlili",
        "name_ar": "متليلي",
        "daira_id": 503
    },
    {
        "id": 1372,
        "code": "47025",
        "name": "Sebseb",
        "name_ar": "سبسب",
        "daira_id": 503
    },
    {
        "id": 1373,
        "code": "47003",
        "name": "Berriane",
        "name_ar": "بريان",
        "daira_id": 504
    },
    {
        "id": 1374,
        "code": "47004",
        "name": "El Guerrara",
        "name_ar": "القرارة",
        "daira_id": 505
    },
    {
        "id": 1375,
        "code": "47005",
        "name": "Bounoura",
        "name_ar": "بونورة",
        "daira_id": 506
    },
    {
        "id": 1376,
        "code": "47012",
        "name": "El Atteuf",
        "name_ar": "العطف",
        "daira_id": 506
    },
    {
        "id": 1377,
        "code": "47007",
        "name": "Zelfana",
        "name_ar": "زلفانة",
        "daira_id": 507
    },
    {
        "id": 1378,
        "code": "47011",
        "name": "Dhayet Bendhahoua",
        "name_ar": "ضاية بن ضحوة",
        "daira_id": 508
    },
    {
        "id": 1379,
        "code": "48000",
        "name": "Relizane",
        "name_ar": "غليزان",
        "daira_id": 510
    },
    {
        "id": 1380,
        "code": "48053",
        "name": "Bendaoud",
        "name_ar": "بن داود",
        "daira_id": 510
    },
    {
        "id": 1381,
        "code": "48001",
        "name": "Oued-Rhiou",
        "name_ar": "وادي رهيو",
        "daira_id": 511
    },
    {
        "id": 1382,
        "code": "48013",
        "name": "Ouarizane",
        "name_ar": "واريزان",
        "daira_id": 511
    },
    {
        "id": 1383,
        "code": "48020",
        "name": "Lahlef",
        "name_ar": "لحلاف",
        "daira_id": 511
    },
    {
        "id": 1384,
        "code": "48056",
        "name": "Merdja Sidi Abed",
        "name_ar": "مرجة سيدي عابد",
        "daira_id": 511
    },
    {
        "id": 1385,
        "code": "48002",
        "name": "Mazouna",
        "name_ar": "مازونة",
        "daira_id": 512
    },
    {
        "id": 1386,
        "code": "48016",
        "name": "El-Guettar",
        "name_ar": "القطار",
        "daira_id": 512
    },
    {
        "id": 1387,
        "code": "48003",
        "name": "Sidi M'hamed Benali",
        "name_ar": "سيدي أمحمد بن علي",
        "daira_id": 513
    },
    {
        "id": 1388,
        "code": "48011",
        "name": "Mediouna",
        "name_ar": "مديونة",
        "daira_id": 513
    },
    {
        "id": 1389,
        "code": "48041",
        "name": "Beni Zentis",
        "name_ar": "بني زنطيس",
        "daira_id": 513
    },
    {
        "id": 1390,
        "code": "48004",
        "name": "Ammi Moussa",
        "name_ar": "عمي موسى",
        "daira_id": 514
    },
    {
        "id": 1391,
        "code": "48019",
        "name": "Ouled Aiche",
        "name_ar": "أولاد يعيش",
        "daira_id": 514
    },
    {
        "id": 1392,
        "code": "48005",
        "name": "Djidiouia",
        "name_ar": "جديوية",
        "daira_id": 515
    },
    {
        "id": 1393,
        "code": "48051",
        "name": "Hamri",
        "name_ar": "حمري",
        "daira_id": 515
    },
    {
        "id": 1394,
        "code": "48061",
        "name": "Ouled Sidi Mihoub",
        "name_ar": "أولاد سيدي الميهوب",
        "daira_id": 515
    },
    {
        "id": 1395,
        "code": "48006",
        "name": "Yellel",
        "name_ar": "يلل",
        "daira_id": 516
    },
    {
        "id": 1396,
        "code": "48018",
        "name": "Kalaa",
        "name_ar": "القلعة",
        "daira_id": 516
    },
    {
        "id": 1397,
        "code": "48033",
        "name": "Ain Rahma",
        "name_ar": "عين الرحمة",
        "daira_id": 516
    },
    {
        "id": 1398,
        "code": "48067",
        "name": "Sidi Saada",
        "name_ar": "سيدي سعادة",
        "daira_id": 516
    },
    {
        "id": 1399,
        "code": "48008",
        "name": "Zemmoura",
        "name_ar": "زمورة",
        "daira_id": 517
    },
    {
        "id": 1400,
        "code": "48039",
        "name": "Beni Dergoun",
        "name_ar": "بني درقن",
        "daira_id": 517
    },
    {
        "id": 1401,
        "code": "48044",
        "name": "Dar Ben Abdelah",
        "name_ar": "دار بن عبد الله",
        "daira_id": 517
    },
    {
        "id": 1402,
        "code": "48009",
        "name": "El-Matmar",
        "name_ar": "المطمر",
        "daira_id": 518
    },
    {
        "id": 1403,
        "code": "48029",
        "name": "Sidi Khettab",
        "name_ar": "سيدي  خطاب",
        "daira_id": 518
    },
    {
        "id": 1404,
        "code": "48030",
        "name": "Sidi M'hamed Benaouda",
        "name_ar": "سيدي امحمد بن عودة",
        "daira_id": 518
    },
    {
        "id": 1405,
        "code": "48036",
        "name": "Belaassel Bouzagza",
        "name_ar": "بلعسل بوزقزة",
        "daira_id": 518
    },
    {
        "id": 1406,
        "code": "48012",
        "name": "Mendes",
        "name_ar": "منداس",
        "daira_id": 519
    },
    {
        "id": 1407,
        "code": "48022",
        "name": "Oued Essalem",
        "name_ar": "وادي السلام",
        "daira_id": 519
    },
    {
        "id": 1408,
        "code": "48065",
        "name": "Sidi Lazreg",
        "name_ar": "سيدي لزرق",
        "daira_id": 519
    },
    {
        "id": 1409,
        "code": "48015",
        "name": "Ain-Tarek",
        "name_ar": "عين طارق",
        "daira_id": 520
    },
    {
        "id": 1410,
        "code": "48050",
        "name": "Had Echkalla",
        "name_ar": "حد الشكالة",
        "daira_id": 520
    },
    {
        "id": 1411,
        "code": "48017",
        "name": "El H'madna",
        "name_ar": "الحمادنة",
        "daira_id": 521
    },
    {
        "id": 1412,
        "code": "48021",
        "name": "Oued El Djemaa",
        "name_ar": "وادي الجمعة",
        "daira_id": 521
    },
    {
        "id": 1413,
        "code": "48024",
        "name": "Ramka",
        "name_ar": "الرمكة",
        "daira_id": 522
    },
    {
        "id": 1414,
        "code": "01001",
        "name": "Timimoun",
        "name_ar": "تيميمون",
        "daira_id": 523
    },
    {
        "id": 1415,
        "code": "01039",
        "name": "Ouled Said",
        "name_ar": "أولاد السعيد",
        "daira_id": 523
    },
    {
        "id": 1416,
        "code": "01012",
        "name": "Aougrout",
        "name_ar": "أوقروت",
        "daira_id": 524
    },
    {
        "id": 1417,
        "code": "01033",
        "name": "Metarfa",
        "name_ar": "المطارفة",
        "daira_id": 524
    },
    {
        "id": 1418,
        "code": "01013",
        "name": "Tinerkouk",
        "name_ar": "تنركوك",
        "daira_id": 525
    },
    {
        "id": 1419,
        "code": "01035",
        "name": "Ksar Kaddour",
        "name_ar": "قصر قدور",
        "daira_id": 525
    },
    {
        "id": 1420,
        "code": "01014",
        "name": "Charouine",
        "name_ar": "شروين",
        "daira_id": 526
    },
    {
        "id": 1421,
        "code": "01034",
        "name": "Talmine",
        "name_ar": "طالمين",
        "daira_id": 526
    },
    {
        "id": 1422,
        "code": "01051",
        "name": "Ouled Aissa",
        "name_ar": "أولاد عيسى",
        "daira_id": 526
    },
    {
        "id": 1423,
        "code": "01010",
        "name": "Bordj Badji Mokhtar",
        "name_ar": "برج باجي مختار",
        "daira_id": 527
    },
    {
        "id": 1424,
        "code": "01042",
        "name": "Timiaouine",
        "name_ar": "تيمياوين",
        "daira_id": 527
    },
    {
        "id": 1425,
        "code": "07002",
        "name": "Ouled Djellal",
        "name_ar": "أولاد جلال",
        "daira_id": 528
    },
    {
        "id": 1426,
        "code": "07007",
        "name": "Doucen",
        "name_ar": "الدوسن",
        "daira_id": 528
    },
    {
        "id": 1427,
        "code": "07004",
        "name": "Sidi Khaled",
        "name_ar": "سيدي  خالد",
        "daira_id": 529
    },
    {
        "id": 1428,
        "code": "07062",
        "name": "Ras El Miad",
        "name_ar": "رأس الميعاد",
        "daira_id": 529
    },
    {
        "id": 1429,
        "code": "08002",
        "name": "Beni-Abbes",
        "name_ar": "بني عباس",
        "daira_id": 530
    },
    {
        "id": 1430,
        "code": "08046",
        "name": "Tamtert",
        "name_ar": "تامترت",
        "daira_id": 530
    },
    {
        "id": 1431,
        "code": "08020",
        "name": "El Ouata",
        "name_ar": "الواتة",
        "daira_id": 531
    },
    {
        "id": 1432,
        "code": "08021",
        "name": "Igli",
        "name_ar": "إقلي",
        "daira_id": 532
    },
    {
        "id": 1433,
        "code": "08022",
        "name": "Kerzaz",
        "name_ar": "كرزاز",
        "daira_id": 533
    },
    {
        "id": 1434,
        "code": "08025",
        "name": "Beni-Ikhlef",
        "name_ar": "بن يخلف",
        "daira_id": 533
    },
    {
        "id": 1435,
        "code": "08031",
        "name": "Timoudi",
        "name_ar": "تيمودي",
        "daira_id": 533
    },
    {
        "id": 1436,
        "code": "08028",
        "name": "Ouled-Khodeir",
        "name_ar": "أولاد خضير",
        "daira_id": 534
    },
    {
        "id": 1437,
        "code": "08039",
        "name": "Ksabi",
        "name_ar": "القصابي",
        "daira_id": 534
    },
    {
        "id": 1438,
        "code": "11001",
        "name": "Ain Salah",
        "name_ar": "عين صالح",
        "daira_id": 535
    },
    {
        "id": 1439,
        "code": "11016",
        "name": "Foggaret Ezzoua",
        "name_ar": "فقارة الزوى",
        "daira_id": 535
    },
    {
        "id": 1440,
        "code": "11004",
        "name": "Inghar",
        "name_ar": "إينغر",
        "daira_id": 536
    },
    {
        "id": 1441,
        "code": "11005",
        "name": "Ain Guezzam",
        "name_ar": "عين قزام",
        "daira_id": 537
    },
    {
        "id": 1442,
        "code": "11011",
        "name": "Tin Zouatine",
        "name_ar": "تين زواتين",
        "daira_id": 538
    },
    {
        "id": 1443,
        "code": "30002",
        "name": "Touggourt",
        "name_ar": "تقرت",
        "daira_id": 539
    },
    {
        "id": 1444,
        "code": "30004",
        "name": "Nezla",
        "name_ar": "النزلة",
        "daira_id": 539
    },
    {
        "id": 1445,
        "code": "30018",
        "name": "Zaouia El Abidia",
        "name_ar": "الزاوية العابدية",
        "daira_id": 539
    },
    {
        "id": 1446,
        "code": "30058",
        "name": "Tebesbest",
        "name_ar": "تبسبست",
        "daira_id": 539
    },
    {
        "id": 1447,
        "code": "30003",
        "name": "Temacine",
        "name_ar": "تماسين",
        "daira_id": 540
    },
    {
        "id": 1448,
        "code": "30005",
        "name": "Blidet Amor",
        "name_ar": "بلدة اعمر",
        "daira_id": 540
    },
    {
        "id": 1449,
        "code": "30006",
        "name": "El-Hadjira",
        "name_ar": "الحجيرة",
        "daira_id": 541
    },
    {
        "id": 1450,
        "code": "30023",
        "name": "El Alia",
        "name_ar": "العالية",
        "daira_id": 541
    },
    {
        "id": 1451,
        "code": "30009",
        "name": "Megarine",
        "name_ar": "المقارين",
        "daira_id": 542
    },
    {
        "id": 1452,
        "code": "30030",
        "name": "Sidi Slimane",
        "name_ar": "سيدي سليمان",
        "daira_id": 542
    },
    {
        "id": 1453,
        "code": "30015",
        "name": "Taibet",
        "name_ar": "الطيبات",
        "daira_id": 543
    },
    {
        "id": 1454,
        "code": "30020",
        "name": "Benaceur",
        "name_ar": "بن ناصر",
        "daira_id": 543
    },
    {
        "id": 1455,
        "code": "30029",
        "name": "M'naguer",
        "name_ar": "المنقر",
        "daira_id": 543
    },
    {
        "id": 1456,
        "code": "33002",
        "name": "Djanet",
        "name_ar": "جانت",
        "daira_id": 544
    },
    {
        "id": 1457,
        "code": "33008",
        "name": "Bordj El Haouass",
        "name_ar": "برج الحواس",
        "daira_id": 544
    },
    {
        "id": 1458,
        "code": "39004",
        "name": "Djamaa",
        "name_ar": "جامعة",
        "daira_id": 545
    },
    {
        "id": 1459,
        "code": "39021",
        "name": "Sidi Amrane",
        "name_ar": "سيدي عمران",
        "daira_id": 545
    },
    {
        "id": 1460,
        "code": "39042",
        "name": "Tenedla",
        "name_ar": "تندلة",
        "daira_id": 545
    },
    {
        "id": 1461,
        "code": "39067",
        "name": "M'rara",
        "name_ar": "المرارة",
        "daira_id": 545
    },
    {
        "id": 1462,
        "code": "39005",
        "name": "El-M'ghaier",
        "name_ar": "المغير",
        "daira_id": 546
    },
    {
        "id": 1463,
        "code": "39034",
        "name": "Oum Touyour",
        "name_ar": "أم الطيور",
        "daira_id": 546
    },
    {
        "id": 1464,
        "code": "39038",
        "name": "Sidi Khelil",
        "name_ar": "سيدي خليل",
        "daira_id": 546
    },
    {
        "id": 1465,
        "code": "39039",
        "name": "Still",
        "name_ar": "سطيل",
        "daira_id": 546
    },
    {
        "id": 1466,
        "code": "47001",
        "name": "El Meniaa",
        "name_ar": "المنيعة",
        "daira_id": 547
    },
    {
        "id": 1467,
        "code": "47006",
        "name": "Hassi Gara",
        "name_ar": "حاسي القارة",
        "daira_id": 547
    },
    {
        "id": 1468,
        "code": "47021",
        "name": "Hassi Fehal",
        "name_ar": "حاسي الفحل",
        "daira_id": 548
    }
];
